(function() {
  'use strict';
  var channel;
  try { channel = new BroadcastChannel('hasselblad-cart'); } catch (e) { return; }

  window.cartChannelUpdate = function(e) {
    channel.postMessage({ detail: e });
  };

  channel.onmessage = function(e) {
    if (!e.data.detail) return;
    if (window.cartDatas && window.cartDatas.token != e.data.detail.token) return;
    window.cartDatas = e.data.detail;
    // document.dispatchEvent(new CustomEvent('cart.update', {
    //   detail: e.data.detail
    // }));
  };
})();
/**
 * Toast — 轻量级消息提示（ADA 合规）
 *
 * 调用方式：
 *   window.Toast.show('操作成功');
 *   window.Toast.show('已添加到购物车', { duration: 5000 });
 *   window.Toast.dismiss();
 */
(function () {
  'use strict';

  var container = null;
  var activeToast = null;
  var previousFocus = null;
  var timer = null;

  /**
   * 获取或创建 toast 容器
   */
  function getContainer() {
    if (!container) {
      container = document.createElement('div');
      container.setAttribute('role', 'region');
      container.setAttribute('aria-label', 'Notifications');
      container.setAttribute('aria-live', 'polite');
      container.setAttribute('aria-atomic', 'false');
      container.className = 'as-toast-container';
      container.style.cssText =
        'position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);' +
        'z-index:99999;display:flex;flex-direction:column;align-items:center;' +
        'gap:8px;pointer-events:none;';
      document.body.appendChild(container);
    }
    return container;
  }

  /**
   * 创建关闭按钮（ADA: 键盘可操作 + 屏幕阅读器可识别）
   */
  function createCloseButton() {
    var btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Close notification');
    btn.className = 'as-toast-close';
    // 绝对定位在右上角
    btn.style.cssText =
      'position:absolute;top:8px;right:8px;width:20px;height:20px;' +
      'padding:0;border:none;background:transparent;color:#fff;' +
      'cursor:pointer;font-size:14px;line-height:1;opacity:.7;' +
      'display:flex;align-items:center;justify-content:center;' +
      'border-radius:4px;';
    btn.innerHTML =
      '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true" focusable="false">' +
      '<path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>' +
      '</svg>';

    // hover / focus 增强可见性
    btn.addEventListener('mouseenter', function () {
      btn.style.opacity = '1';
      btn.style.background = 'rgba(255,255,255,.15)';
    });
    btn.addEventListener('mouseleave', function () {
      btn.style.opacity = '.7';
      btn.style.background = 'transparent';
    });
    btn.addEventListener('focus', function () {
      btn.style.opacity = '1';
      btn.style.background = 'rgba(255,255,255,.15)';
      btn.style.outline = '2px solid #fff';
      btn.style.outlineOffset = '0';
    });
    btn.addEventListener('blur', function () {
      btn.style.opacity = '.7';
      btn.style.background = 'transparent';
      btn.style.outline = 'none';
    });

    return btn;
  }

  /**
   * 创建 toast 元素
   */
  function createElement(message) {
    var wrapper = document.createElement('div');
    wrapper.className = 'as-toast-item';
    wrapper.setAttribute('role', 'status');
    wrapper.setAttribute('tabindex', '-1');
    wrapper.style.cssText =
      'position:relative;background:#000;color:#fff;padding:13px 36px 13px 28px;' +
      'border-radius:8px;font-size:15px;line-height:1.4;text-align:center;' +
      'max-width:300px;word-break:break-word;' +
      'box-shadow:0 6px 24px rgba(0,0,0,.25);' +
      'opacity:0;transform:translateY(12px);' +
      'transition:opacity .25s ease,transform .25s ease;' +
      'pointer-events:auto;';

    // 文字内容
    var text = document.createElement('span');
    text.textContent = message;
    wrapper.appendChild(text);

    // 关闭按钮
    var closeBtn = createCloseButton();
    wrapper.appendChild(closeBtn);

    // 点击关闭按钮 → 手动关闭
    closeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      dismiss(wrapper);
    });

    return wrapper;
  }

  /**
   * 全局键盘事件：Esc 关闭当前 toast
   */
  function onKeyDown(e) {
    if (e.key === 'Escape' && activeToast) {
      e.preventDefault();
      dismiss(activeToast);
    }
  }

  /**
   * 显示 toast
   * @param {string} message  - 消息文本
   * @param {object|number} [options] - 配置对象或持续时间（毫秒）
   *   options.duration - 自动消失时间（毫秒），默认 2500，传 0 则仅手动关闭
   */
  function show(message, options) {
    var duration;
    if (typeof options === 'object' && options !== null) {
      duration = options.duration;
    } else if (typeof options === 'number') {
      duration = options;
    }

    if (typeof message !== 'string' || !message.trim()) {
      return;
    }

    var ms = typeof duration === 'number' && duration >= 0 ? duration : 2500;

    // 先关闭当前 toast
    if (activeToast) {
      dismiss(activeToast);
    }

    // 记录当前焦点，稍后恢复
    previousFocus = document.activeElement;

    var parent = getContainer();
    var el = createElement(message.trim());

    // 键盘可关闭
    document.addEventListener('keydown', onKeyDown);

    parent.appendChild(el);

    // 强制回流后播放入场动画
    el.offsetHeight;
    el.style.opacity = '1';
    el.style.transform = 'translateY(0)';

    // 将焦点移到 toast 上，方便键盘用户操作关闭按钮
    el.focus();

    activeToast = el;

    // 自动消失
    clearTimeout(timer);
    if (ms > 0) {
      timer = setTimeout(function () {
        dismiss(el);
      }, ms);
    }

    return el;
  }

  /**
   * 关闭 toast
   * @param {HTMLElement} [el] - 要关闭的 toast 元素，不传则关闭所有
   */
  function dismiss(el) {
    if (!el) {
      // 关闭所有
      if (container) {
        var items = container.querySelectorAll('.as-toast-item');
        for (var i = 0; i < items.length; i++) {
          dismiss(items[i]);
        }
      }
      return;
    }

    clearTimeout(timer);
    document.removeEventListener('keydown', onKeyDown);

    // 出场动画
    el.style.opacity = '0';
    el.style.transform = 'translateY(-12px)';

    if (activeToast === el) {
      activeToast = null;
    }

    var parent = el.parentNode;
    setTimeout(function () {
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
      // 容器内无元素时移除容器
      if (
        parent &&
        parent.querySelectorAll &&
        !parent.querySelector('.as-toast-item')
      ) {
        document.body.removeChild(parent);
        container = null;
      }
    }, 260);

    // 恢复之前的焦点
    if (previousFocus && typeof previousFocus.focus === 'function') {
      try {
        previousFocus.focus();
      } catch (_) {
        /* 忽略已移除元素的焦点恢复错误 */
      }
      previousFocus = null;
    }
  }

  window.Toast = {
    show: show,
    dismiss: dismiss,
  };
})();

!(function (t) {
  var e = {};
  function n(i) {
    if (e[i]) return e[i].exports;
    var r = (e[i] = { i: i, l: !1, exports: {} });
    return t[i].call(r.exports, r, r.exports, n), (r.l = !0), r.exports;
  }
  (n.m = t),
    (n.c = e),
    (n.d = function (t, e, i) {
      n.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: i });
    }),
    (n.r = function (t) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(t, "__esModule", { value: !0 });
    }),
    (n.t = function (t, e) {
      if ((1 & e && (t = n(t)), 8 & e)) return t;
      if (4 & e && "object" == typeof t && t && t.__esModule) return t;
      var i = Object.create(null);
      if (
        (n.r(i),
        Object.defineProperty(i, "default", { enumerable: !0, value: t }),
        2 & e && "string" != typeof t)
      )
        for (var r in t)
          n.d(
            i,
            r,
            function (e) {
              return t[e];
            }.bind(null, r)
          );
      return i;
    }),
    (n.n = function (t) {
      var e =
        t && t.__esModule
          ? function () {
              return t.default;
            }
          : function () {
              return t;
            };
      return n.d(e, "a", e), e;
    }),
    (n.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }),
    (n.p = ""),
    n((n.s = 57));
})([
  function (t, e, n) {
    "use strict";
    var i = n(8),
      r = Object.prototype.toString;
    function o(t) {
      return "[object Array]" === r.call(t);
    }
    function a(t) {
      return void 0 === t;
    }
    function s(t) {
      return null !== t && "object" == typeof t;
    }
    function c(t) {
      if ("[object Object]" !== r.call(t)) return !1;
      var e = Object.getPrototypeOf(t);
      return null === e || e === Object.prototype;
    }
    function l(t) {
      return "[object Function]" === r.call(t);
    }
    function u(t, e) {
      if (null != t)
        if (("object" != typeof t && (t = [t]), o(t)))
          for (var n = 0, i = t.length; n < i; n++) e.call(null, t[n], n, t);
        else
          for (var r in t)
            Object.prototype.hasOwnProperty.call(t, r) &&
              e.call(null, t[r], r, t);
    }
    t.exports = {
      isArray: o,
      isArrayBuffer: function (t) {
        return "[object ArrayBuffer]" === r.call(t);
      },
      isBuffer: function (t) {
        return (
          null !== t &&
          !a(t) &&
          null !== t.constructor &&
          !a(t.constructor) &&
          "function" == typeof t.constructor.isBuffer &&
          t.constructor.isBuffer(t)
        );
      },
      isFormData: function (t) {
        return "undefined" != typeof FormData && t instanceof FormData;
      },
      isArrayBufferView: function (t) {
        return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
          ? ArrayBuffer.isView(t)
          : t && t.buffer && t.buffer instanceof ArrayBuffer;
      },
      isString: function (t) {
        return "string" == typeof t;
      },
      isNumber: function (t) {
        return "number" == typeof t;
      },
      isObject: s,
      isPlainObject: c,
      isUndefined: a,
      isDate: function (t) {
        return "[object Date]" === r.call(t);
      },
      isFile: function (t) {
        return "[object File]" === r.call(t);
      },
      isBlob: function (t) {
        return "[object Blob]" === r.call(t);
      },
      isFunction: l,
      isStream: function (t) {
        return s(t) && l(t.pipe);
      },
      isURLSearchParams: function (t) {
        return (
          "undefined" != typeof URLSearchParams && t instanceof URLSearchParams
        );
      },
      isStandardBrowserEnv: function () {
        return (
          ("undefined" == typeof navigator ||
            ("ReactNative" !== navigator.product &&
              "NativeScript" !== navigator.product &&
              "NS" !== navigator.product)) &&
          "undefined" != typeof window &&
          "undefined" != typeof document
        );
      },
      forEach: u,
      merge: function t() {
        var e = {};
        function n(n, i) {
          c(e[i]) && c(n)
            ? (e[i] = t(e[i], n))
            : c(n)
            ? (e[i] = t({}, n))
            : o(n)
            ? (e[i] = n.slice())
            : (e[i] = n);
        }
        for (var i = 0, r = arguments.length; i < r; i++) u(arguments[i], n);
        return e;
      },
      extend: function (t, e, n) {
        return (
          u(e, function (e, r) {
            t[r] = n && "function" == typeof e ? i(e, n) : e;
          }),
          t
        );
      },
      trim: function (t) {
        return t.replace(/^\s*/, "").replace(/\s*$/, "");
      },
      stripBOM: function (t) {
        return 65279 === t.charCodeAt(0) && (t = t.slice(1)), t;
      },
    };
  },
  function (t, e, n) {
    var i, r;
    /*!
     * JavaScript Cookie v2.2.1
     * https://github.com/js-cookie/js-cookie
     *
     * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
     * Released under the MIT license
     */ !(function (o) {
      if (
        (void 0 ===
          (r = "function" == typeof (i = o) ? i.call(e, n, e, t) : i) ||
          (t.exports = r),
        !0,
        (t.exports = o()),
        !!0)
      ) {
        var a = window.Cookies,
          s = (window.Cookies = o());
        s.noConflict = function () {
          return (window.Cookies = a), s;
        };
      }
    })(function () {
      function t() {
        for (var t = 0, e = {}; t < arguments.length; t++) {
          var n = arguments[t];
          for (var i in n) e[i] = n[i];
        }
        return e;
      }
      function e(t) {
        return t.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
      }
      return (function n(i) {
        function r() {}
        function o(e, n, o) {
          if ("undefined" != typeof document) {
            "number" == typeof (o = t({ path: "/" }, r.defaults, o)).expires &&
              (o.expires = new Date(1 * new Date() + 864e5 * o.expires)),
              (o.expires = o.expires ? o.expires.toUTCString() : "");
            try {
              var a = JSON.stringify(n);
              /^[\{\[]/.test(a) && (n = a);
            } catch (t) {}
            (n = i.write
              ? i.write(n, e)
              : encodeURIComponent(String(n)).replace(
                  /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                  decodeURIComponent
                )),
              (e = encodeURIComponent(String(e))
                .replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
                .replace(/[\(\)]/g, escape));
            var s = "";
            for (var c in o)
              o[c] &&
                ((s += "; " + c),
                !0 !== o[c] && (s += "=" + o[c].split(";")[0]));
            return (document.cookie = e + "=" + n + s);
          }
        }
        function a(t, n) {
          if ("undefined" != typeof document) {
            for (
              var r = {},
                o = document.cookie ? document.cookie.split("; ") : [],
                a = 0;
              a < o.length;
              a++
            ) {
              var s = o[a].split("="),
                c = s.slice(1).join("=");
              n || '"' !== c.charAt(0) || (c = c.slice(1, -1));
              try {
                var l = e(s[0]);
                if (((c = (i.read || i)(c, l) || e(c)), n))
                  try {
                    c = JSON.parse(c);
                  } catch (t) {}
                if (((r[l] = c), t === l)) break;
              } catch (t) {}
            }
            return t ? r[t] : r;
          }
        }
        return (
          (r.set = o),
          (r.get = function (t) {
            return a(t, !1);
          }),
          (r.getJSON = function (t) {
            return a(t, !0);
          }),
          (r.remove = function (e, n) {
            o(e, "", t(n, { expires: -1 }));
          }),
          (r.defaults = {}),
          (r.withConverter = n),
          r
        );
      })(function () {});
    });
  },
  function (t, e, n) {
    var i = n(40);
    (i.Template = n(41).Template), (i.template = i.Template), (t.exports = i);
  },
  function (t, e, n) {
    "use strict";
    n.r(e);
    let i = Element.prototype.querySelectorAll,
      r = Element.prototype.querySelector;
    const o = (() => {
        const t = new CustomEvent("Bootstrap", { cancelable: !0 }),
          e = document.createElement("div");
        return (
          e.addEventListener("Bootstrap", () => null),
          t.preventDefault(),
          e.dispatchEvent(t),
          t.defaultPrevented
        );
      })(),
      a = /:scope\b/;
    (() => {
      const t = document.createElement("div");
      try {
        t.querySelectorAll(":scope *");
      } catch (t) {
        return !1;
      }
      return !0;
    })() ||
      ((i = function (t) {
        if (!a.test(t)) return this.querySelectorAll(t);
        const e = Boolean(this.id);
        e ||
          (this.id = ((t) => {
            do {
              t += Math.floor(1e6 * Math.random());
            } while (document.getElementById(t));
            return t;
          })("scope"));
        let n = null;
        try {
          (t = t.replace(a, "#" + this.id)), (n = this.querySelectorAll(t));
        } finally {
          e || this.removeAttribute("id");
        }
        return n;
      }),
      (r = function (t) {
        if (!a.test(t)) return this.querySelector(t);
        const e = i.call(this, t);
        return void 0 !== e[0] ? e[0] : null;
      }));
    const s = (() => {
        const { jQuery: t } = window;
        return t && !document.body.hasAttribute("data-no-jquery") ? t : null;
      })(),
      c = /[^.]*(?=\..*)\.|.*/,
      l = /\..*/,
      u = /::\d+$/,
      d = {};
    let f = 1;
    const h = { mouseenter: "mouseover", mouseleave: "mouseout" },
      p = [
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll",
      ];
    function m(t, e) {
      return (e && `${e}::${f++}`) || t.uidEvent || f++;
    }
    function g(t) {
      const e = m(t);
      return (t.uidEvent = e), (d[e] = d[e] || {}), d[e];
    }
    function v(t, e, n = null) {
      const i = Object.keys(t);
      for (let r = 0, o = i.length; r < o; r++) {
        const o = t[i[r]];
        if (o.originalHandler === e && o.delegationSelector === n) return o;
      }
      return null;
    }
    function y(t, e, n) {
      const i = "string" == typeof e,
        r = i ? n : e;
      let o = t.replace(l, "");
      const a = h[o];
      a && (o = a);
      return p.indexOf(o) > -1 || (o = t), [i, r, o];
    }
    function b(t, e, n, i, r) {
      if ("string" != typeof e || !t) return;
      n || ((n = i), (i = null));
      const [o, a, s] = y(e, n, i),
        l = g(t),
        u = l[s] || (l[s] = {}),
        d = v(u, a, o ? n : null);
      if (d) return void (d.oneOff = d.oneOff && r);
      const f = m(a, e.replace(c, "")),
        h = o
          ? (function (t, e, n) {
              return function i(r) {
                const o = t.querySelectorAll(e);
                for (let { target: e } = r; e && e !== this; e = e.parentNode)
                  for (let a = o.length; a--; )
                    if (o[a] === e)
                      return i.oneOff && w.off(t, r.type, n), n.apply(e, [r]);
                return null;
              };
            })(t, n, i)
          : (function (t, e) {
              return function n(i) {
                return n.oneOff && w.off(t, i.type, e), e.apply(t, [i]);
              };
            })(t, n);
      (h.delegationSelector = o ? n : null),
        (h.originalHandler = a),
        (h.oneOff = r),
        (h.uidEvent = f),
        (u[f] = h),
        t.addEventListener(s, h, o);
    }
    function _(t, e, n, i, r) {
      const o = v(e[n], i, r);
      o && (t.removeEventListener(n, o, Boolean(r)), delete e[n][o.uidEvent]);
    }
    const w = {
      on(t, e, n, i) {
        b(t, e, n, i, !1);
      },
      one(t, e, n, i) {
        b(t, e, n, i, !0);
      },
      off(t, e, n, i) {
        if ("string" != typeof e || !t) return;
        const [r, o, a] = y(e, n, i),
          s = a !== e,
          c = g(t),
          l = "." === e.charAt(0);
        if (void 0 !== o) {
          if (!c || !c[a]) return;
          return void _(t, c, a, o, r ? n : null);
        }
        l &&
          Object.keys(c).forEach((n) => {
            !(function (t, e, n, i) {
              const r = e[n] || {};
              Object.keys(r).forEach((o) => {
                if (o.indexOf(i) > -1) {
                  const i = r[o];
                  _(t, e, n, i.originalHandler, i.delegationSelector);
                }
              });
            })(t, c, n, e.slice(1));
          });
        const d = c[a] || {};
        Object.keys(d).forEach((n) => {
          const i = n.replace(u, "");
          if (!s || e.indexOf(i) > -1) {
            const e = d[n];
            _(t, c, a, e.originalHandler, e.delegationSelector);
          }
        });
      },
      trigger(t, e, n) {
        if ("string" != typeof e || !t) return null;
        const i = e.replace(l, ""),
          r = e !== i,
          a = p.indexOf(i) > -1;
        let c,
          u = !0,
          d = !0,
          f = !1,
          h = null;
        return (
          r &&
            s &&
            ((c = s.Event(e, n)),
            s(t).trigger(c),
            (u = !c.isPropagationStopped()),
            (d = !c.isImmediatePropagationStopped()),
            (f = c.isDefaultPrevented())),
          a
            ? ((h = document.createEvent("HTMLEvents")), h.initEvent(i, u, !0))
            : (h = new CustomEvent(e, { bubbles: u, cancelable: !0 })),
          void 0 !== n &&
            Object.keys(n).forEach((t) => {
              Object.defineProperty(h, t, { get: () => n[t] });
            }),
          f &&
            (h.preventDefault(),
            o ||
              Object.defineProperty(h, "defaultPrevented", { get: () => !0 })),
          d && t.dispatchEvent(h),
          h.defaultPrevented && void 0 !== c && c.preventDefault(),
          h
        );
      },
    };
    e.default = w;
  },
  function (t, e, n) {
    "use strict";
    (function (t) {
      /**!
       * @fileOverview Kickass library to create and place poppers near their reference elements.
       * @version 1.16.1
       * @license
       * Copyright (c) 2016 Federico Zivolo and contributors
       *
       * Permission is hereby granted, free of charge, to any person obtaining a copy
       * of this software and associated documentation files (the "Software"), to deal
       * in the Software without restriction, including without limitation the rights
       * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
       * copies of the Software, and to permit persons to whom the Software is
       * furnished to do so, subject to the following conditions:
       *
       * The above copyright notice and this permission notice shall be included in all
       * copies or substantial portions of the Software.
       *
       * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
       * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
       * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
       * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
       * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
       * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
       * SOFTWARE.
       */
      var n =
          "undefined" != typeof window &&
          "undefined" != typeof document &&
          "undefined" != typeof navigator,
        i = (function () {
          for (
            var t = ["Edge", "Trident", "Firefox"], e = 0;
            e < t.length;
            e += 1
          )
            if (n && navigator.userAgent.indexOf(t[e]) >= 0) return 1;
          return 0;
        })();
      var r =
        n && window.Promise
          ? function (t) {
              var e = !1;
              return function () {
                e ||
                  ((e = !0),
                  window.Promise.resolve().then(function () {
                    (e = !1), t();
                  }));
              };
            }
          : function (t) {
              var e = !1;
              return function () {
                e ||
                  ((e = !0),
                  setTimeout(function () {
                    (e = !1), t();
                  }, i));
              };
            };
      function o(t) {
        return t && "[object Function]" === {}.toString.call(t);
      }
      function a(t, e) {
        if (1 !== t.nodeType) return [];
        var n = t.ownerDocument.defaultView.getComputedStyle(t, null);
        return e ? n[e] : n;
      }
      function s(t) {
        return "HTML" === t.nodeName ? t : t.parentNode || t.host;
      }
      function c(t) {
        if (!t) return document.body;
        switch (t.nodeName) {
          case "HTML":
          case "BODY":
            return t.ownerDocument.body;
          case "#document":
            return t.body;
        }
        var e = a(t),
          n = e.overflow,
          i = e.overflowX,
          r = e.overflowY;
        return /(auto|scroll|overlay)/.test(n + r + i) ? t : c(s(t));
      }
      function l(t) {
        return t && t.referenceNode ? t.referenceNode : t;
      }
      var u = n && !(!window.MSInputMethodContext || !document.documentMode),
        d = n && /MSIE 10/.test(navigator.userAgent);
      function f(t) {
        return 11 === t ? u : 10 === t ? d : u || d;
      }
      function h(t) {
        if (!t) return document.documentElement;
        for (
          var e = f(10) ? document.body : null, n = t.offsetParent || null;
          n === e && t.nextElementSibling;

        )
          n = (t = t.nextElementSibling).offsetParent;
        var i = n && n.nodeName;
        return i && "BODY" !== i && "HTML" !== i
          ? -1 !== ["TH", "TD", "TABLE"].indexOf(n.nodeName) &&
            "static" === a(n, "position")
            ? h(n)
            : n
          : t
          ? t.ownerDocument.documentElement
          : document.documentElement;
      }
      function p(t) {
        return null !== t.parentNode ? p(t.parentNode) : t;
      }
      function m(t, e) {
        if (!(t && t.nodeType && e && e.nodeType))
          return document.documentElement;
        var n = t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_FOLLOWING,
          i = n ? t : e,
          r = n ? e : t,
          o = document.createRange();
        o.setStart(i, 0), o.setEnd(r, 0);
        var a,
          s,
          c = o.commonAncestorContainer;
        if ((t !== c && e !== c) || i.contains(r))
          return "BODY" === (s = (a = c).nodeName) ||
            ("HTML" !== s && h(a.firstElementChild) !== a)
            ? h(c)
            : c;
        var l = p(t);
        return l.host ? m(l.host, e) : m(t, p(e).host);
      }
      function g(t) {
        var e =
            arguments.length > 1 && void 0 !== arguments[1]
              ? arguments[1]
              : "top",
          n = "top" === e ? "scrollTop" : "scrollLeft",
          i = t.nodeName;
        if ("BODY" === i || "HTML" === i) {
          var r = t.ownerDocument.documentElement,
            o = t.ownerDocument.scrollingElement || r;
          return o[n];
        }
        return t[n];
      }
      function v(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = g(e, "top"),
          r = g(e, "left"),
          o = n ? -1 : 1;
        return (
          (t.top += i * o),
          (t.bottom += i * o),
          (t.left += r * o),
          (t.right += r * o),
          t
        );
      }
      function y(t, e) {
        var n = "x" === e ? "Left" : "Top",
          i = "Left" === n ? "Right" : "Bottom";
        return (
          parseFloat(t["border" + n + "Width"]) +
          parseFloat(t["border" + i + "Width"])
        );
      }
      function b(t, e, n, i) {
        return Math.max(
          e["offset" + t],
          e["scroll" + t],
          n["client" + t],
          n["offset" + t],
          n["scroll" + t],
          f(10)
            ? parseInt(n["offset" + t]) +
                parseInt(i["margin" + ("Height" === t ? "Top" : "Left")]) +
                parseInt(i["margin" + ("Height" === t ? "Bottom" : "Right")])
            : 0
        );
      }
      function _(t) {
        var e = t.body,
          n = t.documentElement,
          i = f(10) && getComputedStyle(n);
        return { height: b("Height", e, n, i), width: b("Width", e, n, i) };
      }
      var w = function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        },
        E = (function () {
          function t(t, e) {
            for (var n = 0; n < e.length; n++) {
              var i = e[n];
              (i.enumerable = i.enumerable || !1),
                (i.configurable = !0),
                "value" in i && (i.writable = !0),
                Object.defineProperty(t, i.key, i);
            }
          }
          return function (e, n, i) {
            return n && t(e.prototype, n), i && t(e, i), e;
          };
        })(),
        k = function (t, e, n) {
          return (
            e in t
              ? Object.defineProperty(t, e, {
                  value: n,
                  enumerable: !0,
                  configurable: !0,
                  writable: !0,
                })
              : (t[e] = n),
            t
          );
        },
        S =
          Object.assign ||
          function (t) {
            for (var e = 1; e < arguments.length; e++) {
              var n = arguments[e];
              for (var i in n)
                Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
            }
            return t;
          };
      function T(t) {
        return S({}, t, { right: t.left + t.width, bottom: t.top + t.height });
      }
      function A(t) {
        var e = {};
        try {
          if (f(10)) {
            e = t.getBoundingClientRect();
            var n = g(t, "top"),
              i = g(t, "left");
            (e.top += n), (e.left += i), (e.bottom += n), (e.right += i);
          } else e = t.getBoundingClientRect();
        } catch (t) {}
        var r = {
            left: e.left,
            top: e.top,
            width: e.right - e.left,
            height: e.bottom - e.top,
          },
          o = "HTML" === t.nodeName ? _(t.ownerDocument) : {},
          s = o.width || t.clientWidth || r.width,
          c = o.height || t.clientHeight || r.height,
          l = t.offsetWidth - s,
          u = t.offsetHeight - c;
        if (l || u) {
          var d = a(t);
          (l -= y(d, "x")), (u -= y(d, "y")), (r.width -= l), (r.height -= u);
        }
        return T(r);
      }
      function L(t, e) {
        var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
          i = f(10),
          r = "HTML" === e.nodeName,
          o = A(t),
          s = A(e),
          l = c(t),
          u = a(e),
          d = parseFloat(u.borderTopWidth),
          h = parseFloat(u.borderLeftWidth);
        n &&
          r &&
          ((s.top = Math.max(s.top, 0)), (s.left = Math.max(s.left, 0)));
        var p = T({
          top: o.top - s.top - d,
          left: o.left - s.left - h,
          width: o.width,
          height: o.height,
        });
        if (((p.marginTop = 0), (p.marginLeft = 0), !i && r)) {
          var m = parseFloat(u.marginTop),
            g = parseFloat(u.marginLeft);
          (p.top -= d - m),
            (p.bottom -= d - m),
            (p.left -= h - g),
            (p.right -= h - g),
            (p.marginTop = m),
            (p.marginLeft = g);
        }
        return (
          (i && !n ? e.contains(l) : e === l && "BODY" !== l.nodeName) &&
            (p = v(p, e)),
          p
        );
      }
      function C(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = t.ownerDocument.documentElement,
          i = L(t, n),
          r = Math.max(n.clientWidth, window.innerWidth || 0),
          o = Math.max(n.clientHeight, window.innerHeight || 0),
          a = e ? 0 : g(n),
          s = e ? 0 : g(n, "left"),
          c = {
            top: a - i.top + i.marginTop,
            left: s - i.left + i.marginLeft,
            width: r,
            height: o,
          };
        return T(c);
      }
      function x(t) {
        var e = t.nodeName;
        if ("BODY" === e || "HTML" === e) return !1;
        if ("fixed" === a(t, "position")) return !0;
        var n = s(t);
        return !!n && x(n);
      }
      function O(t) {
        if (!t || !t.parentElement || f()) return document.documentElement;
        for (var e = t.parentElement; e && "none" === a(e, "transform"); )
          e = e.parentElement;
        return e || document.documentElement;
      }
      function $(t, e, n, i) {
        var r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4],
          o = { top: 0, left: 0 },
          a = r ? O(t) : m(t, l(e));
        if ("viewport" === i) o = C(a, r);
        else {
          var u = void 0;
          "scrollParent" === i
            ? "BODY" === (u = c(s(e))).nodeName &&
              (u = t.ownerDocument.documentElement)
            : (u = "window" === i ? t.ownerDocument.documentElement : i);
          var d = L(u, a, r);
          if ("HTML" !== u.nodeName || x(a)) o = d;
          else {
            var f = _(t.ownerDocument),
              h = f.height,
              p = f.width;
            (o.top += d.top - d.marginTop),
              (o.bottom = h + d.top),
              (o.left += d.left - d.marginLeft),
              (o.right = p + d.left);
          }
        }
        var g = "number" == typeof (n = n || 0);
        return (
          (o.left += g ? n : n.left || 0),
          (o.top += g ? n : n.top || 0),
          (o.right -= g ? n : n.right || 0),
          (o.bottom -= g ? n : n.bottom || 0),
          o
        );
      }
      function P(t) {
        return t.width * t.height;
      }
      function I(t, e, n, i, r) {
        var o =
          arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0;
        if (-1 === t.indexOf("auto")) return t;
        var a = $(n, i, o, r),
          s = {
            top: { width: a.width, height: e.top - a.top },
            right: { width: a.right - e.right, height: a.height },
            bottom: { width: a.width, height: a.bottom - e.bottom },
            left: { width: e.left - a.left, height: a.height },
          },
          c = Object.keys(s)
            .map(function (t) {
              return S({ key: t }, s[t], { area: P(s[t]) });
            })
            .sort(function (t, e) {
              return e.area - t.area;
            }),
          l = c.filter(function (t) {
            var e = t.width,
              i = t.height;
            return e >= n.clientWidth && i >= n.clientHeight;
          }),
          u = l.length > 0 ? l[0].key : c[0].key,
          d = t.split("-")[1];
        return u + (d ? "-" + d : "");
      }
      function R(t, e, n) {
        var i =
            arguments.length > 3 && void 0 !== arguments[3]
              ? arguments[3]
              : null,
          r = i ? O(e) : m(e, l(n));
        return L(n, r, i);
      }
      function M(t) {
        var e = t.ownerDocument.defaultView.getComputedStyle(t),
          n = parseFloat(e.marginTop || 0) + parseFloat(e.marginBottom || 0),
          i = parseFloat(e.marginLeft || 0) + parseFloat(e.marginRight || 0);
        return { width: t.offsetWidth + i, height: t.offsetHeight + n };
      }
      function N(t) {
        var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
        return t.replace(/left|right|bottom|top/g, function (t) {
          return e[t];
        });
      }
      function D(t, e, n) {
        n = n.split("-")[0];
        var i = M(t),
          r = { width: i.width, height: i.height },
          o = -1 !== ["right", "left"].indexOf(n),
          a = o ? "top" : "left",
          s = o ? "left" : "top",
          c = o ? "height" : "width",
          l = o ? "width" : "height";
        return (
          (r[a] = e[a] + e[c] / 2 - i[c] / 2),
          (r[s] = n === s ? e[s] - i[l] : e[N(s)]),
          r
        );
      }
      function q(t, e) {
        return Array.prototype.find ? t.find(e) : t.filter(e)[0];
      }
      function j(t, e, n) {
        return (
          (void 0 === n
            ? t
            : t.slice(
                0,
                (function (t, e, n) {
                  if (Array.prototype.findIndex)
                    return t.findIndex(function (t) {
                      return t[e] === n;
                    });
                  var i = q(t, function (t) {
                    return t[e] === n;
                  });
                  return t.indexOf(i);
                })(t, "name", n)
              )
          ).forEach(function (t) {
            t.function &&
              console.warn(
                "`modifier.function` is deprecated, use `modifier.fn`!"
              );
            var n = t.function || t.fn;
            t.enabled &&
              o(n) &&
              ((e.offsets.popper = T(e.offsets.popper)),
              (e.offsets.reference = T(e.offsets.reference)),
              (e = n(e, t)));
          }),
          e
        );
      }
      function B() {
        if (!this.state.isDestroyed) {
          var t = {
            instance: this,
            styles: {},
            arrowStyles: {},
            attributes: {},
            flipped: !1,
            offsets: {},
          };
          (t.offsets.reference = R(
            this.state,
            this.popper,
            this.reference,
            this.options.positionFixed
          )),
            (t.placement = I(
              this.options.placement,
              t.offsets.reference,
              this.popper,
              this.reference,
              this.options.modifiers.flip.boundariesElement,
              this.options.modifiers.flip.padding
            )),
            (t.originalPlacement = t.placement),
            (t.positionFixed = this.options.positionFixed),
            (t.offsets.popper = D(
              this.popper,
              t.offsets.reference,
              t.placement
            )),
            (t.offsets.popper.position = this.options.positionFixed
              ? "fixed"
              : "absolute"),
            (t = j(this.modifiers, t)),
            this.state.isCreated
              ? this.options.onUpdate(t)
              : ((this.state.isCreated = !0), this.options.onCreate(t));
        }
      }
      function H(t, e) {
        return t.some(function (t) {
          var n = t.name;
          return t.enabled && n === e;
        });
      }
      function U(t) {
        for (
          var e = [!1, "ms", "Webkit", "Moz", "O"],
            n = t.charAt(0).toUpperCase() + t.slice(1),
            i = 0;
          i < e.length;
          i++
        ) {
          var r = e[i],
            o = r ? "" + r + n : t;
          if (void 0 !== document.body.style[o]) return o;
        }
        return null;
      }
      function F() {
        return (
          (this.state.isDestroyed = !0),
          H(this.modifiers, "applyStyle") &&
            (this.popper.removeAttribute("x-placement"),
            (this.popper.style.position = ""),
            (this.popper.style.top = ""),
            (this.popper.style.left = ""),
            (this.popper.style.right = ""),
            (this.popper.style.bottom = ""),
            (this.popper.style.willChange = ""),
            (this.popper.style[U("transform")] = "")),
          this.disableEventListeners(),
          this.options.removeOnDestroy &&
            this.popper.parentNode.removeChild(this.popper),
          this
        );
      }
      function W(t) {
        var e = t.ownerDocument;
        return e ? e.defaultView : window;
      }
      function z(t, e, n, i) {
        (n.updateBound = i),
          W(t).addEventListener("resize", n.updateBound, { passive: !0 });
        var r = c(t);
        return (
          (function t(e, n, i, r) {
            var o = "BODY" === e.nodeName,
              a = o ? e.ownerDocument.defaultView : e;
            a.addEventListener(n, i, { passive: !0 }),
              o || t(c(a.parentNode), n, i, r),
              r.push(a);
          })(r, "scroll", n.updateBound, n.scrollParents),
          (n.scrollElement = r),
          (n.eventsEnabled = !0),
          n
        );
      }
      function Y() {
        this.state.eventsEnabled ||
          (this.state = z(
            this.reference,
            this.options,
            this.state,
            this.scheduleUpdate
          ));
      }
      function V() {
        var t, e;
        this.state.eventsEnabled &&
          (cancelAnimationFrame(this.scheduleUpdate),
          (this.state =
            ((t = this.reference),
            (e = this.state),
            W(t).removeEventListener("resize", e.updateBound),
            e.scrollParents.forEach(function (t) {
              t.removeEventListener("scroll", e.updateBound);
            }),
            (e.updateBound = null),
            (e.scrollParents = []),
            (e.scrollElement = null),
            (e.eventsEnabled = !1),
            e)));
      }
      function K(t) {
        return "" !== t && !isNaN(parseFloat(t)) && isFinite(t);
      }
      function Q(t, e) {
        Object.keys(e).forEach(function (n) {
          var i = "";
          -1 !==
            ["width", "height", "top", "right", "bottom", "left"].indexOf(n) &&
            K(e[n]) &&
            (i = "px"),
            (t.style[n] = e[n] + i);
        });
      }
      var G = n && /Firefox/i.test(navigator.userAgent);
      function X(t, e, n) {
        var i = q(t, function (t) {
            return t.name === e;
          }),
          r =
            !!i &&
            t.some(function (t) {
              return t.name === n && t.enabled && t.order < i.order;
            });
        if (!r) {
          var o = "`" + e + "`",
            a = "`" + n + "`";
          console.warn(
            a +
              " modifier is required by " +
              o +
              " modifier in order to work, be sure to include it before " +
              o +
              "!"
          );
        }
        return r;
      }
      var J = [
          "auto-start",
          "auto",
          "auto-end",
          "top-start",
          "top",
          "top-end",
          "right-start",
          "right",
          "right-end",
          "bottom-end",
          "bottom",
          "bottom-start",
          "left-end",
          "left",
          "left-start",
        ],
        Z = J.slice(3);
      function tt(t) {
        var e = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
          n = Z.indexOf(t),
          i = Z.slice(n + 1).concat(Z.slice(0, n));
        return e ? i.reverse() : i;
      }
      var et = "flip",
        nt = "clockwise",
        it = "counterclockwise";
      function rt(t, e, n, i) {
        var r = [0, 0],
          o = -1 !== ["right", "left"].indexOf(i),
          a = t.split(/(\+|\-)/).map(function (t) {
            return t.trim();
          }),
          s = a.indexOf(
            q(a, function (t) {
              return -1 !== t.search(/,|\s/);
            })
          );
        a[s] &&
          -1 === a[s].indexOf(",") &&
          console.warn(
            "Offsets separated by white space(s) are deprecated, use a comma (,) instead."
          );
        var c = /\s*,\s*|\s+/,
          l =
            -1 !== s
              ? [
                  a.slice(0, s).concat([a[s].split(c)[0]]),
                  [a[s].split(c)[1]].concat(a.slice(s + 1)),
                ]
              : [a];
        return (
          (l = l.map(function (t, i) {
            var r = (1 === i ? !o : o) ? "height" : "width",
              a = !1;
            return t
              .reduce(function (t, e) {
                return "" === t[t.length - 1] && -1 !== ["+", "-"].indexOf(e)
                  ? ((t[t.length - 1] = e), (a = !0), t)
                  : a
                  ? ((t[t.length - 1] += e), (a = !1), t)
                  : t.concat(e);
              }, [])
              .map(function (t) {
                return (function (t, e, n, i) {
                  var r = t.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),
                    o = +r[1],
                    a = r[2];
                  if (!o) return t;
                  if (0 === a.indexOf("%")) {
                    var s = void 0;
                    switch (a) {
                      case "%p":
                        s = n;
                        break;
                      case "%":
                      case "%r":
                      default:
                        s = i;
                    }
                    return (T(s)[e] / 100) * o;
                  }
                  if ("vh" === a || "vw" === a) {
                    return (
                      (("vh" === a
                        ? Math.max(
                            document.documentElement.clientHeight,
                            window.innerHeight || 0
                          )
                        : Math.max(
                            document.documentElement.clientWidth,
                            window.innerWidth || 0
                          )) /
                        100) *
                      o
                    );
                  }
                  return o;
                })(t, r, e, n);
              });
          })).forEach(function (t, e) {
            t.forEach(function (n, i) {
              K(n) && (r[e] += n * ("-" === t[i - 1] ? -1 : 1));
            });
          }),
          r
        );
      }
      var ot = {
          placement: "bottom",
          positionFixed: !1,
          eventsEnabled: !0,
          removeOnDestroy: !1,
          onCreate: function () {},
          onUpdate: function () {},
          modifiers: {
            shift: {
              order: 100,
              enabled: !0,
              fn: function (t) {
                var e = t.placement,
                  n = e.split("-")[0],
                  i = e.split("-")[1];
                if (i) {
                  var r = t.offsets,
                    o = r.reference,
                    a = r.popper,
                    s = -1 !== ["bottom", "top"].indexOf(n),
                    c = s ? "left" : "top",
                    l = s ? "width" : "height",
                    u = {
                      start: k({}, c, o[c]),
                      end: k({}, c, o[c] + o[l] - a[l]),
                    };
                  t.offsets.popper = S({}, a, u[i]);
                }
                return t;
              },
            },
            offset: {
              order: 200,
              enabled: !0,
              fn: function (t, e) {
                var n = e.offset,
                  i = t.placement,
                  r = t.offsets,
                  o = r.popper,
                  a = r.reference,
                  s = i.split("-")[0],
                  c = void 0;
                return (
                  (c = K(+n) ? [+n, 0] : rt(n, o, a, s)),
                  "left" === s
                    ? ((o.top += c[0]), (o.left -= c[1]))
                    : "right" === s
                    ? ((o.top += c[0]), (o.left += c[1]))
                    : "top" === s
                    ? ((o.left += c[0]), (o.top -= c[1]))
                    : "bottom" === s && ((o.left += c[0]), (o.top += c[1])),
                  (t.popper = o),
                  t
                );
              },
              offset: 0,
            },
            preventOverflow: {
              order: 300,
              enabled: !0,
              fn: function (t, e) {
                var n = e.boundariesElement || h(t.instance.popper);
                t.instance.reference === n && (n = h(n));
                var i = U("transform"),
                  r = t.instance.popper.style,
                  o = r.top,
                  a = r.left,
                  s = r[i];
                (r.top = ""), (r.left = ""), (r[i] = "");
                var c = $(
                  t.instance.popper,
                  t.instance.reference,
                  e.padding,
                  n,
                  t.positionFixed
                );
                (r.top = o), (r.left = a), (r[i] = s), (e.boundaries = c);
                var l = e.priority,
                  u = t.offsets.popper,
                  d = {
                    primary: function (t) {
                      var n = u[t];
                      return (
                        u[t] < c[t] &&
                          !e.escapeWithReference &&
                          (n = Math.max(u[t], c[t])),
                        k({}, t, n)
                      );
                    },
                    secondary: function (t) {
                      var n = "right" === t ? "left" : "top",
                        i = u[n];
                      return (
                        u[t] > c[t] &&
                          !e.escapeWithReference &&
                          (i = Math.min(
                            u[n],
                            c[t] - ("right" === t ? u.width : u.height)
                          )),
                        k({}, n, i)
                      );
                    },
                  };
                return (
                  l.forEach(function (t) {
                    var e =
                      -1 !== ["left", "top"].indexOf(t)
                        ? "primary"
                        : "secondary";
                    u = S({}, u, d[e](t));
                  }),
                  (t.offsets.popper = u),
                  t
                );
              },
              priority: ["left", "right", "top", "bottom"],
              padding: 5,
              boundariesElement: "scrollParent",
            },
            keepTogether: {
              order: 400,
              enabled: !0,
              fn: function (t) {
                var e = t.offsets,
                  n = e.popper,
                  i = e.reference,
                  r = t.placement.split("-")[0],
                  o = Math.floor,
                  a = -1 !== ["top", "bottom"].indexOf(r),
                  s = a ? "right" : "bottom",
                  c = a ? "left" : "top",
                  l = a ? "width" : "height";
                return (
                  n[s] < o(i[c]) && (t.offsets.popper[c] = o(i[c]) - n[l]),
                  n[c] > o(i[s]) && (t.offsets.popper[c] = o(i[s])),
                  t
                );
              },
            },
            arrow: {
              order: 500,
              enabled: !0,
              fn: function (t, e) {
                var n;
                if (!X(t.instance.modifiers, "arrow", "keepTogether")) return t;
                var i = e.element;
                if ("string" == typeof i) {
                  if (!(i = t.instance.popper.querySelector(i))) return t;
                } else if (!t.instance.popper.contains(i))
                  return (
                    console.warn(
                      "WARNING: `arrow.element` must be child of its popper element!"
                    ),
                    t
                  );
                var r = t.placement.split("-")[0],
                  o = t.offsets,
                  s = o.popper,
                  c = o.reference,
                  l = -1 !== ["left", "right"].indexOf(r),
                  u = l ? "height" : "width",
                  d = l ? "Top" : "Left",
                  f = d.toLowerCase(),
                  h = l ? "left" : "top",
                  p = l ? "bottom" : "right",
                  m = M(i)[u];
                c[p] - m < s[f] && (t.offsets.popper[f] -= s[f] - (c[p] - m)),
                  c[f] + m > s[p] && (t.offsets.popper[f] += c[f] + m - s[p]),
                  (t.offsets.popper = T(t.offsets.popper));
                var g = c[f] + c[u] / 2 - m / 2,
                  v = a(t.instance.popper),
                  y = parseFloat(v["margin" + d]),
                  b = parseFloat(v["border" + d + "Width"]),
                  _ = g - t.offsets.popper[f] - y - b;
                return (
                  (_ = Math.max(Math.min(s[u] - m, _), 0)),
                  (t.arrowElement = i),
                  (t.offsets.arrow =
                    (k((n = {}), f, Math.round(_)), k(n, h, ""), n)),
                  t
                );
              },
              element: "[x-arrow]",
            },
            flip: {
              order: 600,
              enabled: !0,
              fn: function (t, e) {
                if (H(t.instance.modifiers, "inner")) return t;
                if (t.flipped && t.placement === t.originalPlacement) return t;
                var n = $(
                    t.instance.popper,
                    t.instance.reference,
                    e.padding,
                    e.boundariesElement,
                    t.positionFixed
                  ),
                  i = t.placement.split("-")[0],
                  r = N(i),
                  o = t.placement.split("-")[1] || "",
                  a = [];
                switch (e.behavior) {
                  case et:
                    a = [i, r];
                    break;
                  case nt:
                    a = tt(i);
                    break;
                  case it:
                    a = tt(i, !0);
                    break;
                  default:
                    a = e.behavior;
                }
                return (
                  a.forEach(function (s, c) {
                    if (i !== s || a.length === c + 1) return t;
                    (i = t.placement.split("-")[0]), (r = N(i));
                    var l = t.offsets.popper,
                      u = t.offsets.reference,
                      d = Math.floor,
                      f =
                        ("left" === i && d(l.right) > d(u.left)) ||
                        ("right" === i && d(l.left) < d(u.right)) ||
                        ("top" === i && d(l.bottom) > d(u.top)) ||
                        ("bottom" === i && d(l.top) < d(u.bottom)),
                      h = d(l.left) < d(n.left),
                      p = d(l.right) > d(n.right),
                      m = d(l.top) < d(n.top),
                      g = d(l.bottom) > d(n.bottom),
                      v =
                        ("left" === i && h) ||
                        ("right" === i && p) ||
                        ("top" === i && m) ||
                        ("bottom" === i && g),
                      y = -1 !== ["top", "bottom"].indexOf(i),
                      b =
                        !!e.flipVariations &&
                        ((y && "start" === o && h) ||
                          (y && "end" === o && p) ||
                          (!y && "start" === o && m) ||
                          (!y && "end" === o && g)),
                      _ =
                        !!e.flipVariationsByContent &&
                        ((y && "start" === o && p) ||
                          (y && "end" === o && h) ||
                          (!y && "start" === o && g) ||
                          (!y && "end" === o && m)),
                      w = b || _;
                    (f || v || w) &&
                      ((t.flipped = !0),
                      (f || v) && (i = a[c + 1]),
                      w &&
                        (o = (function (t) {
                          return "end" === t
                            ? "start"
                            : "start" === t
                            ? "end"
                            : t;
                        })(o)),
                      (t.placement = i + (o ? "-" + o : "")),
                      (t.offsets.popper = S(
                        {},
                        t.offsets.popper,
                        D(t.instance.popper, t.offsets.reference, t.placement)
                      )),
                      (t = j(t.instance.modifiers, t, "flip")));
                  }),
                  t
                );
              },
              behavior: "flip",
              padding: 5,
              boundariesElement: "viewport",
              flipVariations: !1,
              flipVariationsByContent: !1,
            },
            inner: {
              order: 700,
              enabled: !1,
              fn: function (t) {
                var e = t.placement,
                  n = e.split("-")[0],
                  i = t.offsets,
                  r = i.popper,
                  o = i.reference,
                  a = -1 !== ["left", "right"].indexOf(n),
                  s = -1 === ["top", "left"].indexOf(n);
                return (
                  (r[a ? "left" : "top"] =
                    o[n] - (s ? r[a ? "width" : "height"] : 0)),
                  (t.placement = N(e)),
                  (t.offsets.popper = T(r)),
                  t
                );
              },
            },
            hide: {
              order: 800,
              enabled: !0,
              fn: function (t) {
                if (!X(t.instance.modifiers, "hide", "preventOverflow"))
                  return t;
                var e = t.offsets.reference,
                  n = q(t.instance.modifiers, function (t) {
                    return "preventOverflow" === t.name;
                  }).boundaries;
                if (
                  e.bottom < n.top ||
                  e.left > n.right ||
                  e.top > n.bottom ||
                  e.right < n.left
                ) {
                  if (!0 === t.hide) return t;
                  (t.hide = !0), (t.attributes["x-out-of-boundaries"] = "");
                } else {
                  if (!1 === t.hide) return t;
                  (t.hide = !1), (t.attributes["x-out-of-boundaries"] = !1);
                }
                return t;
              },
            },
            computeStyle: {
              order: 850,
              enabled: !0,
              fn: function (t, e) {
                var n = e.x,
                  i = e.y,
                  r = t.offsets.popper,
                  o = q(t.instance.modifiers, function (t) {
                    return "applyStyle" === t.name;
                  }).gpuAcceleration;
                void 0 !== o &&
                  console.warn(
                    "WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!"
                  );
                var a = void 0 !== o ? o : e.gpuAcceleration,
                  s = h(t.instance.popper),
                  c = A(s),
                  l = { position: r.position },
                  u = (function (t, e) {
                    var n = t.offsets,
                      i = n.popper,
                      r = n.reference,
                      o = Math.round,
                      a = Math.floor,
                      s = function (t) {
                        return t;
                      },
                      c = o(r.width),
                      l = o(i.width),
                      u = -1 !== ["left", "right"].indexOf(t.placement),
                      d = -1 !== t.placement.indexOf("-"),
                      f = e ? (u || d || c % 2 == l % 2 ? o : a) : s,
                      h = e ? o : s;
                    return {
                      left: f(
                        c % 2 == 1 && l % 2 == 1 && !d && e
                          ? i.left - 1
                          : i.left
                      ),
                      top: h(i.top),
                      bottom: h(i.bottom),
                      right: f(i.right),
                    };
                  })(t, window.devicePixelRatio < 2 || !G),
                  d = "bottom" === n ? "top" : "bottom",
                  f = "right" === i ? "left" : "right",
                  p = U("transform"),
                  m = void 0,
                  g = void 0;
                if (
                  ((g =
                    "bottom" === d
                      ? "HTML" === s.nodeName
                        ? -s.clientHeight + u.bottom
                        : -c.height + u.bottom
                      : u.top),
                  (m =
                    "right" === f
                      ? "HTML" === s.nodeName
                        ? -s.clientWidth + u.right
                        : -c.width + u.right
                      : u.left),
                  a && p)
                )
                  (l[p] = "translate3d(" + m + "px, " + g + "px, 0)"),
                    (l[d] = 0),
                    (l[f] = 0),
                    (l.willChange = "transform");
                else {
                  var v = "bottom" === d ? -1 : 1,
                    y = "right" === f ? -1 : 1;
                  (l[d] = g * v), (l[f] = m * y), (l.willChange = d + ", " + f);
                }
                var b = { "x-placement": t.placement };
                return (
                  (t.attributes = S({}, b, t.attributes)),
                  (t.styles = S({}, l, t.styles)),
                  (t.arrowStyles = S({}, t.offsets.arrow, t.arrowStyles)),
                  t
                );
              },
              gpuAcceleration: !0,
              x: "bottom",
              y: "right",
            },
            applyStyle: {
              order: 900,
              enabled: !0,
              fn: function (t) {
                var e, n;
                return (
                  Q(t.instance.popper, t.styles),
                  (e = t.instance.popper),
                  (n = t.attributes),
                  Object.keys(n).forEach(function (t) {
                    !1 !== n[t]
                      ? e.setAttribute(t, n[t])
                      : e.removeAttribute(t);
                  }),
                  t.arrowElement &&
                    Object.keys(t.arrowStyles).length &&
                    Q(t.arrowElement, t.arrowStyles),
                  t
                );
              },
              onLoad: function (t, e, n, i, r) {
                var o = R(r, e, t, n.positionFixed),
                  a = I(
                    n.placement,
                    o,
                    e,
                    t,
                    n.modifiers.flip.boundariesElement,
                    n.modifiers.flip.padding
                  );
                return (
                  e.setAttribute("x-placement", a),
                  Q(e, { position: n.positionFixed ? "fixed" : "absolute" }),
                  n
                );
              },
              gpuAcceleration: void 0,
            },
          },
        },
        at = (function () {
          function t(e, n) {
            var i = this,
              a =
                arguments.length > 2 && void 0 !== arguments[2]
                  ? arguments[2]
                  : {};
            w(this, t),
              (this.scheduleUpdate = function () {
                return requestAnimationFrame(i.update);
              }),
              (this.update = r(this.update.bind(this))),
              (this.options = S({}, t.Defaults, a)),
              (this.state = {
                isDestroyed: !1,
                isCreated: !1,
                scrollParents: [],
              }),
              (this.reference = e && e.jquery ? e[0] : e),
              (this.popper = n && n.jquery ? n[0] : n),
              (this.options.modifiers = {}),
              Object.keys(S({}, t.Defaults.modifiers, a.modifiers)).forEach(
                function (e) {
                  i.options.modifiers[e] = S(
                    {},
                    t.Defaults.modifiers[e] || {},
                    a.modifiers ? a.modifiers[e] : {}
                  );
                }
              ),
              (this.modifiers = Object.keys(this.options.modifiers)
                .map(function (t) {
                  return S({ name: t }, i.options.modifiers[t]);
                })
                .sort(function (t, e) {
                  return t.order - e.order;
                })),
              this.modifiers.forEach(function (t) {
                t.enabled &&
                  o(t.onLoad) &&
                  t.onLoad(i.reference, i.popper, i.options, t, i.state);
              }),
              this.update();
            var s = this.options.eventsEnabled;
            s && this.enableEventListeners(), (this.state.eventsEnabled = s);
          }
          return (
            E(t, [
              {
                key: "update",
                value: function () {
                  return B.call(this);
                },
              },
              {
                key: "destroy",
                value: function () {
                  return F.call(this);
                },
              },
              {
                key: "enableEventListeners",
                value: function () {
                  return Y.call(this);
                },
              },
              {
                key: "disableEventListeners",
                value: function () {
                  return V.call(this);
                },
              },
            ]),
            t
          );
        })();
      (at.Utils = ("undefined" != typeof window ? window : t).PopperUtils),
        (at.placements = J),
        (at.Defaults = ot),
        (e.a = at);
    }).call(this, n(21));
  },
  function (t, e, n) {
    "use strict";
    n.r(e),
      n.d(e, "Alert", function () {
        return G;
      }),
      n.d(e, "Button", function () {
        return Z;
      }),
      n.d(e, "Carousel", function () {
        return dt;
      }),
      n.d(e, "Collapse", function () {
        return vt;
      }),
      n.d(e, "Dropdown", function () {
        return St;
      }),
      n.d(e, "Modal", function () {
        return xt;
      }),
      n.d(e, "Popover", function () {
        return Jt;
      }),
      n.d(e, "ScrollSpy", function () {
        return re;
      }),
      n.d(e, "Tab", function () {
        return se;
      }),
      n.d(e, "Toast", function () {
        return fe;
      }),
      n.d(e, "Tooltip", function () {
        return Wt;
      });
    var i = n(4);
    /*!
     * Bootstrap v5.0.0-alpha1 (https://getbootstrap.com/)
     * Copyright 2011-2020 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
     * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
     */ function r(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function o(t, e, n) {
      return e && r(t.prototype, e), n && r(t, n), t;
    }
    function a(t, e, n) {
      return (
        e in t
          ? Object.defineProperty(t, e, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0,
            })
          : (t[e] = n),
        t
      );
    }
    function s(t, e) {
      var n = Object.keys(t);
      if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(t);
        e &&
          (i = i.filter(function (e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
          })),
          n.push.apply(n, i);
      }
      return n;
    }
    function c(t) {
      for (var e = 1; e < arguments.length; e++) {
        var n = null != arguments[e] ? arguments[e] : {};
        e % 2
          ? s(Object(n), !0).forEach(function (e) {
              a(t, e, n[e]);
            })
          : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n))
          : s(Object(n)).forEach(function (e) {
              Object.defineProperty(
                t,
                e,
                Object.getOwnPropertyDescriptor(n, e)
              );
            });
      }
      return t;
    }
    var l,
      u,
      d,
      f,
      h = function (t) {
        do {
          t += Math.floor(1e6 * Math.random());
        } while (document.getElementById(t));
        return t;
      },
      p = function (t) {
        var e = t.getAttribute("data-target");
        if (!e || "#" === e) {
          var n = t.getAttribute("href");
          e = n && "#" !== n ? n.trim() : null;
        }
        return e;
      },
      m = function (t) {
        var e = p(t);
        return e && document.querySelector(e) ? e : null;
      },
      g = function (t) {
        var e = p(t);
        return e ? document.querySelector(e) : null;
      },
      v = function (t) {
        if (!t) return 0;
        var e = window.getComputedStyle(t),
          n = e.transitionDuration,
          i = e.transitionDelay,
          r = parseFloat(n),
          o = parseFloat(i);
        return r || o
          ? ((n = n.split(",")[0]),
            (i = i.split(",")[0]),
            1e3 * (parseFloat(n) + parseFloat(i)))
          : 0;
      },
      y = function (t) {
        t.dispatchEvent(new Event("transitionend"));
      },
      b = function (t) {
        return (t[0] || t).nodeType;
      },
      _ = function (t, e) {
        var n = !1,
          i = e + 5;
        t.addEventListener("transitionend", function e() {
          (n = !0), t.removeEventListener("transitionend", e);
        }),
          setTimeout(function () {
            n || y(t);
          }, i);
      },
      w = function (t, e, n) {
        Object.keys(n).forEach(function (i) {
          var r,
            o = n[i],
            a = e[i],
            s =
              a && b(a)
                ? "element"
                : null == (r = a)
                ? "" + r
                : {}.toString
                    .call(r)
                    .match(/\s([a-z]+)/i)[1]
                    .toLowerCase();
          if (!new RegExp(o).test(s))
            throw new Error(
              t.toUpperCase() +
                ': Option "' +
                i +
                '" provided type "' +
                s +
                '" but expected type "' +
                o +
                '".'
            );
        });
      },
      E = function (t) {
        if (!t) return !1;
        if (t.style && t.parentNode && t.parentNode.style) {
          var e = getComputedStyle(t),
            n = getComputedStyle(t.parentNode);
          return (
            "none" !== e.display &&
            "none" !== n.display &&
            "hidden" !== e.visibility
          );
        }
        return !1;
      },
      k = function () {
        return function () {};
      },
      S = function (t) {
        return t.offsetHeight;
      },
      T = function () {
        var t = window.jQuery;
        return t && !document.body.hasAttribute("data-no-jquery") ? t : null;
      },
      A =
        ((l = {}),
        (u = 1),
        {
          set: function (t, e, n) {
            void 0 === t.key && ((t.key = { key: e, id: u }), u++),
              (l[t.key.id] = n);
          },
          get: function (t, e) {
            if (!t || void 0 === t.key) return null;
            var n = t.key;
            return n.key === e ? l[n.id] : null;
          },
          delete: function (t, e) {
            if (void 0 !== t.key) {
              var n = t.key;
              n.key === e && (delete l[n.id], delete t.key);
            }
          },
        }),
      L = function (t, e, n) {
        A.set(t, e, n);
      },
      C = function (t, e) {
        return A.get(t, e);
      },
      x = function (t, e) {
        A.delete(t, e);
      },
      O = Element.prototype.querySelectorAll,
      $ = Element.prototype.querySelector,
      P =
        ((d = new CustomEvent("Bootstrap", { cancelable: !0 })),
        (f = document.createElement("div")).addEventListener(
          "Bootstrap",
          function () {
            return null;
          }
        ),
        d.preventDefault(),
        f.dispatchEvent(d),
        d.defaultPrevented),
      I = /:scope\b/;
    (function () {
      var t = document.createElement("div");
      try {
        t.querySelectorAll(":scope *");
      } catch (t) {
        return !1;
      }
      return !0;
    })() ||
      ((O = function (t) {
        if (!I.test(t)) return this.querySelectorAll(t);
        var e = Boolean(this.id);
        e || (this.id = h("scope"));
        var n = null;
        try {
          (t = t.replace(I, "#" + this.id)), (n = this.querySelectorAll(t));
        } finally {
          e || this.removeAttribute("id");
        }
        return n;
      }),
      ($ = function (t) {
        if (!I.test(t)) return this.querySelector(t);
        var e = O.call(this, t);
        return void 0 !== e[0] ? e[0] : null;
      }));
    var R = T(),
      M = /[^.]*(?=\..*)\.|.*/,
      N = /\..*/,
      D = /::\d+$/,
      q = {},
      j = 1,
      B = { mouseenter: "mouseover", mouseleave: "mouseout" },
      H = [
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll",
      ];
    function U(t, e) {
      return (e && e + "::" + j++) || t.uidEvent || j++;
    }
    function F(t) {
      var e = U(t);
      return (t.uidEvent = e), (q[e] = q[e] || {}), q[e];
    }
    function W(t, e, n) {
      void 0 === n && (n = null);
      for (var i = Object.keys(t), r = 0, o = i.length; r < o; r++) {
        var a = t[i[r]];
        if (a.originalHandler === e && a.delegationSelector === n) return a;
      }
      return null;
    }
    function z(t, e, n) {
      var i = "string" == typeof e,
        r = i ? n : e,
        o = t.replace(N, ""),
        a = B[o];
      return a && (o = a), H.indexOf(o) > -1 || (o = t), [i, r, o];
    }
    function Y(t, e, n, i, r) {
      if ("string" == typeof e && t) {
        n || ((n = i), (i = null));
        var o = z(e, n, i),
          a = o[0],
          s = o[1],
          c = o[2],
          l = F(t),
          u = l[c] || (l[c] = {}),
          d = W(u, s, a ? n : null);
        if (d) d.oneOff = d.oneOff && r;
        else {
          var f = U(s, e.replace(M, "")),
            h = a
              ? (function (t, e, n) {
                  return function i(r) {
                    for (
                      var o = t.querySelectorAll(e), a = r.target;
                      a && a !== this;
                      a = a.parentNode
                    )
                      for (var s = o.length; s--; )
                        if (o[s] === a)
                          return (
                            i.oneOff && K.off(t, r.type, n), n.apply(a, [r])
                          );
                    return null;
                  };
                })(t, n, i)
              : (function (t, e) {
                  return function n(i) {
                    return n.oneOff && K.off(t, i.type, e), e.apply(t, [i]);
                  };
                })(t, n);
          (h.delegationSelector = a ? n : null),
            (h.originalHandler = s),
            (h.oneOff = r),
            (h.uidEvent = f),
            (u[f] = h),
            t.addEventListener(c, h, a);
        }
      }
    }
    function V(t, e, n, i, r) {
      var o = W(e[n], i, r);
      o && (t.removeEventListener(n, o, Boolean(r)), delete e[n][o.uidEvent]);
    }
    var K = {
        on: function (t, e, n, i) {
          Y(t, e, n, i, !1);
        },
        one: function (t, e, n, i) {
          Y(t, e, n, i, !0);
        },
        off: function (t, e, n, i) {
          if ("string" == typeof e && t) {
            var r = z(e, n, i),
              o = r[0],
              a = r[1],
              s = r[2],
              c = s !== e,
              l = F(t),
              u = "." === e.charAt(0);
            if (void 0 === a) {
              u &&
                Object.keys(l).forEach(function (n) {
                  !(function (t, e, n, i) {
                    var r = e[n] || {};
                    Object.keys(r).forEach(function (o) {
                      if (o.indexOf(i) > -1) {
                        var a = r[o];
                        V(t, e, n, a.originalHandler, a.delegationSelector);
                      }
                    });
                  })(t, l, n, e.slice(1));
                });
              var d = l[s] || {};
              Object.keys(d).forEach(function (n) {
                var i = n.replace(D, "");
                if (!c || e.indexOf(i) > -1) {
                  var r = d[n];
                  V(t, l, s, r.originalHandler, r.delegationSelector);
                }
              });
            } else {
              if (!l || !l[s]) return;
              V(t, l, s, a, o ? n : null);
            }
          }
        },
        trigger: function (t, e, n) {
          if ("string" != typeof e || !t) return null;
          var i,
            r = e.replace(N, ""),
            o = e !== r,
            a = H.indexOf(r) > -1,
            s = !0,
            c = !0,
            l = !1,
            u = null;
          return (
            o &&
              R &&
              ((i = R.Event(e, n)),
              R(t).trigger(i),
              (s = !i.isPropagationStopped()),
              (c = !i.isImmediatePropagationStopped()),
              (l = i.isDefaultPrevented())),
            a
              ? (u = document.createEvent("HTMLEvents")).initEvent(r, s, !0)
              : (u = new CustomEvent(e, { bubbles: s, cancelable: !0 })),
            void 0 !== n &&
              Object.keys(n).forEach(function (t) {
                Object.defineProperty(u, t, {
                  get: function () {
                    return n[t];
                  },
                });
              }),
            l &&
              (u.preventDefault(),
              P ||
                Object.defineProperty(u, "defaultPrevented", {
                  get: function () {
                    return !0;
                  },
                })),
            c && t.dispatchEvent(u),
            u.defaultPrevented && void 0 !== i && i.preventDefault(),
            u
          );
        },
      },
      Q = "alert",
      G = (function () {
        function t(t) {
          (this._element = t), this._element && L(t, "bs.alert", this);
        }
        var e = t.prototype;
        return (
          (e.close = function (t) {
            var e = this._element;
            t && (e = this._getRootElement(t));
            var n = this._triggerCloseEvent(e);
            null === n || n.defaultPrevented || this._removeElement(e);
          }),
          (e.dispose = function () {
            x(this._element, "bs.alert"), (this._element = null);
          }),
          (e._getRootElement = function (t) {
            return g(t) || t.closest(".alert");
          }),
          (e._triggerCloseEvent = function (t) {
            return K.trigger(t, "close.bs.alert");
          }),
          (e._removeElement = function (t) {
            var e = this;
            if ((t.classList.remove("show"), t.classList.contains("fade"))) {
              var n = v(t);
              K.one(t, "transitionend", function () {
                return e._destroyElement(t);
              }),
                _(t, n);
            } else this._destroyElement(t);
          }),
          (e._destroyElement = function (t) {
            t.parentNode && t.parentNode.removeChild(t),
              K.trigger(t, "closed.bs.alert");
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              var n = C(this, "bs.alert");
              n || (n = new t(this)), "close" === e && n[e](this);
            });
          }),
          (t.handleDismiss = function (t) {
            return function (e) {
              e && e.preventDefault(), t.close(this);
            };
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.alert");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
          ]),
          t
        );
      })();
    K.on(
      document,
      "click.bs.alert.data-api",
      '[data-dismiss="alert"]',
      G.handleDismiss(new G())
    );
    var X = T();
    if (X) {
      var J = X.fn[Q];
      (X.fn[Q] = G.jQueryInterface),
        (X.fn[Q].Constructor = G),
        (X.fn[Q].noConflict = function () {
          return (X.fn[Q] = J), G.jQueryInterface;
        });
    }
    var Z = (function () {
      function t(t) {
        (this._element = t), L(t, "bs.button", this);
      }
      var e = t.prototype;
      return (
        (e.toggle = function () {
          this._element.setAttribute(
            "aria-pressed",
            this._element.classList.toggle("active")
          );
        }),
        (e.dispose = function () {
          x(this._element, "bs.button"), (this._element = null);
        }),
        (t.jQueryInterface = function (e) {
          return this.each(function () {
            var n = C(this, "bs.button");
            n || (n = new t(this)), "toggle" === e && n[e]();
          });
        }),
        (t.getInstance = function (t) {
          return C(t, "bs.button");
        }),
        o(t, null, [
          {
            key: "VERSION",
            get: function () {
              return "5.0.0-alpha1";
            },
          },
        ]),
        t
      );
    })();
    K.on(
      document,
      "click.bs.button.data-api",
      '[data-toggle="button"]',
      function (t) {
        t.preventDefault();
        var e = t.target.closest('[data-toggle="button"]'),
          n = C(e, "bs.button");
        n || (n = new Z(e)), n.toggle();
      }
    );
    var tt = T();
    if (tt) {
      var et = tt.fn.button;
      (tt.fn.button = Z.jQueryInterface),
        (tt.fn.button.Constructor = Z),
        (tt.fn.button.noConflict = function () {
          return (tt.fn.button = et), Z.jQueryInterface;
        });
    }
    function nt(t) {
      return (
        "true" === t ||
        ("false" !== t &&
          (t === Number(t).toString()
            ? Number(t)
            : "" === t || "null" === t
            ? null
            : t))
      );
    }
    function it(t) {
      return t.replace(/[A-Z]/g, function (t) {
        return "-" + t.toLowerCase();
      });
    }
    var rt = {
        setDataAttribute: function (t, e, n) {
          t.setAttribute("data-" + it(e), n);
        },
        removeDataAttribute: function (t, e) {
          t.removeAttribute("data-" + it(e));
        },
        getDataAttributes: function (t) {
          if (!t) return {};
          var e = c({}, t.dataset);
          return (
            Object.keys(e).forEach(function (t) {
              e[t] = nt(e[t]);
            }),
            e
          );
        },
        getDataAttribute: function (t, e) {
          return nt(t.getAttribute("data-" + it(e)));
        },
        offset: function (t) {
          var e = t.getBoundingClientRect();
          return {
            top: e.top + document.body.scrollTop,
            left: e.left + document.body.scrollLeft,
          };
        },
        position: function (t) {
          return { top: t.offsetTop, left: t.offsetLeft };
        },
        toggleClass: function (t, e) {
          t &&
            (t.classList.contains(e)
              ? t.classList.remove(e)
              : t.classList.add(e));
        },
      },
      ot = {
        matches: function (t, e) {
          return t.matches(e);
        },
        find: function (t, e) {
          var n;
          return (
            void 0 === e && (e = document.documentElement),
            (n = []).concat.apply(n, O.call(e, t))
          );
        },
        findOne: function (t, e) {
          return void 0 === e && (e = document.documentElement), $.call(e, t);
        },
        children: function (t, e) {
          var n,
            i = (n = []).concat.apply(n, t.children);
          return i.filter(function (t) {
            return t.matches(e);
          });
        },
        parents: function (t, e) {
          for (
            var n = [], i = t.parentNode;
            i && i.nodeType === Node.ELEMENT_NODE && 3 !== i.nodeType;

          )
            this.matches(i, e) && n.push(i), (i = i.parentNode);
          return n;
        },
        prev: function (t, e) {
          for (var n = t.previousElementSibling; n; ) {
            if (n.matches(e)) return [n];
            n = n.previousElementSibling;
          }
          return [];
        },
        next: function (t, e) {
          for (var n = t.nextElementSibling; n; ) {
            if (this.matches(n, e)) return [n];
            n = n.nextElementSibling;
          }
          return [];
        },
      },
      at = "carousel",
      st = ".bs.carousel",
      ct = {
        interval: 5e3,
        keyboard: !0,
        slide: !1,
        pause: "hover",
        wrap: !0,
        touch: !0,
      },
      lt = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean",
        touch: "boolean",
      },
      ut = { TOUCH: "touch", PEN: "pen" },
      dt = (function () {
        function t(t, e) {
          (this._items = null),
            (this._interval = null),
            (this._activeElement = null),
            (this._isPaused = !1),
            (this._isSliding = !1),
            (this.touchTimeout = null),
            (this.touchStartX = 0),
            (this.touchDeltaX = 0),
            (this._config = this._getConfig(e)),
            (this._element = t),
            (this._indicatorsElement = ot.findOne(
              ".carousel-indicators",
              this._element
            )),
            (this._touchSupported =
              "ontouchstart" in document.documentElement ||
              navigator.maxTouchPoints > 0),
            (this._pointerEvent = Boolean(window.PointerEvent)),
            this._addEventListeners(),
            L(t, "bs.carousel", this);
        }
        var e = t.prototype;
        return (
          (e.next = function () {
            this._isSliding || this._slide("next");
          }),
          (e.nextWhenVisible = function () {
            !document.hidden && E(this._element) && this.next();
          }),
          (e.prev = function () {
            this._isSliding || this._slide("prev");
          }),
          (e.pause = function (t) {
            t || (this._isPaused = !0),
              ot.findOne(
                ".carousel-item-next, .carousel-item-prev",
                this._element
              ) && (y(this._element), this.cycle(!0)),
              clearInterval(this._interval),
              (this._interval = null);
          }),
          (e.cycle = function (t) {
            t || (this._isPaused = !1),
              this._interval &&
                (clearInterval(this._interval), (this._interval = null)),
              this._config &&
                this._config.interval &&
                !this._isPaused &&
                (this._interval = setInterval(
                  (document.visibilityState
                    ? this.nextWhenVisible
                    : this.next
                  ).bind(this),
                  this._config.interval
                ));
          }),
          (e.to = function (t) {
            var e = this;
            this._activeElement = ot.findOne(
              ".active.carousel-item",
              this._element
            );
            var n = this._getItemIndex(this._activeElement);
            if (!(t > this._items.length - 1 || t < 0))
              if (this._isSliding)
                K.one(this._element, "slid.bs.carousel", function () {
                  return e.to(t);
                });
              else {
                if (n === t) return this.pause(), void this.cycle();
                var i = t > n ? "next" : "prev";
                this._slide(i, this._items[t]);
              }
          }),
          (e.dispose = function () {
            K.off(this._element, st),
              x(this._element, "bs.carousel"),
              (this._items = null),
              (this._config = null),
              (this._element = null),
              (this._interval = null),
              (this._isPaused = null),
              (this._isSliding = null),
              (this._activeElement = null),
              (this._indicatorsElement = null);
          }),
          (e._getConfig = function (t) {
            return (t = c(c({}, ct), t)), w(at, t, lt), t;
          }),
          (e._handleSwipe = function () {
            var t = Math.abs(this.touchDeltaX);
            if (!(t <= 40)) {
              var e = t / this.touchDeltaX;
              (this.touchDeltaX = 0),
                e > 0 && this.prev(),
                e < 0 && this.next();
            }
          }),
          (e._addEventListeners = function () {
            var t = this;
            this._config.keyboard &&
              K.on(this._element, "keydown.bs.carousel", function (e) {
                return t._keydown(e);
              }),
              "hover" === this._config.pause &&
                (K.on(this._element, "mouseenter.bs.carousel", function (e) {
                  return t.pause(e);
                }),
                K.on(this._element, "mouseleave.bs.carousel", function (e) {
                  return t.cycle(e);
                })),
              this._config.touch &&
                this._touchSupported &&
                this._addTouchEventListeners();
          }),
          (e._addTouchEventListeners = function () {
            var t = this,
              e = function (e) {
                t._pointerEvent && ut[e.pointerType.toUpperCase()]
                  ? (t.touchStartX = e.clientX)
                  : t._pointerEvent || (t.touchStartX = e.touches[0].clientX);
              },
              n = function (e) {
                t._pointerEvent &&
                  ut[e.pointerType.toUpperCase()] &&
                  (t.touchDeltaX = e.clientX - t.touchStartX),
                  t._handleSwipe(),
                  "hover" === t._config.pause &&
                    (t.pause(),
                    t.touchTimeout && clearTimeout(t.touchTimeout),
                    (t.touchTimeout = setTimeout(function (e) {
                      return t.cycle(e);
                    }, 500 + t._config.interval)));
              };
            ot.find(".carousel-item img", this._element).forEach(function (t) {
              K.on(t, "dragstart.bs.carousel", function (t) {
                return t.preventDefault();
              });
            }),
              this._pointerEvent
                ? (K.on(this._element, "pointerdown.bs.carousel", function (t) {
                    return e(t);
                  }),
                  K.on(this._element, "pointerup.bs.carousel", function (t) {
                    return n(t);
                  }),
                  this._element.classList.add("pointer-event"))
                : (K.on(this._element, "touchstart.bs.carousel", function (t) {
                    return e(t);
                  }),
                  K.on(this._element, "touchmove.bs.carousel", function (e) {
                    return (function (e) {
                      e.touches && e.touches.length > 1
                        ? (t.touchDeltaX = 0)
                        : (t.touchDeltaX =
                            e.touches[0].clientX - t.touchStartX);
                    })(e);
                  }),
                  K.on(this._element, "touchend.bs.carousel", function (t) {
                    return n(t);
                  }));
          }),
          (e._keydown = function (t) {
            if (!/input|textarea/i.test(t.target.tagName))
              switch (t.key) {
                case "ArrowLeft":
                  t.preventDefault(), this.prev();
                  break;
                case "ArrowRight":
                  t.preventDefault(), this.next();
              }
          }),
          (e._getItemIndex = function (t) {
            return (
              (this._items =
                t && t.parentNode
                  ? ot.find(".carousel-item", t.parentNode)
                  : []),
              this._items.indexOf(t)
            );
          }),
          (e._getItemByDirection = function (t, e) {
            var n = "next" === t,
              i = "prev" === t,
              r = this._getItemIndex(e),
              o = this._items.length - 1;
            if (((i && 0 === r) || (n && r === o)) && !this._config.wrap)
              return e;
            var a = (r + ("prev" === t ? -1 : 1)) % this._items.length;
            return -1 === a
              ? this._items[this._items.length - 1]
              : this._items[a];
          }),
          (e._triggerSlideEvent = function (t, e) {
            var n = this._getItemIndex(t),
              i = this._getItemIndex(
                ot.findOne(".active.carousel-item", this._element)
              );
            return K.trigger(this._element, "slide.bs.carousel", {
              relatedTarget: t,
              direction: e,
              from: i,
              to: n,
            });
          }),
          (e._setActiveIndicatorElement = function (t) {
            if (this._indicatorsElement) {
              for (
                var e = ot.find(".active", this._indicatorsElement), n = 0;
                n < e.length;
                n++
              )
                e[n].classList.remove("active");
              var i = this._indicatorsElement.children[this._getItemIndex(t)];
              i && i.classList.add("active");
            }
          }),
          (e._slide = function (t, e) {
            var n,
              i,
              r,
              o = this,
              a = ot.findOne(".active.carousel-item", this._element),
              s = this._getItemIndex(a),
              c = e || (a && this._getItemByDirection(t, a)),
              l = this._getItemIndex(c),
              u = Boolean(this._interval);
            if (
              ("next" === t
                ? ((n = "carousel-item-left"),
                  (i = "carousel-item-next"),
                  (r = "left"))
                : ((n = "carousel-item-right"),
                  (i = "carousel-item-prev"),
                  (r = "right")),
              c && c.classList.contains("active"))
            )
              this._isSliding = !1;
            else if (
              !this._triggerSlideEvent(c, r).defaultPrevented &&
              a &&
              c
            ) {
              if (
                ((this._isSliding = !0),
                u && this.pause(),
                this._setActiveIndicatorElement(c),
                this._element.classList.contains("slide"))
              ) {
                c.classList.add(i),
                  S(c),
                  a.classList.add(n),
                  c.classList.add(n);
                var d = parseInt(c.getAttribute("data-interval"), 10);
                d
                  ? ((this._config.defaultInterval =
                      this._config.defaultInterval || this._config.interval),
                    (this._config.interval = d))
                  : (this._config.interval =
                      this._config.defaultInterval || this._config.interval);
                var f = v(a);
                K.one(a, "transitionend", function () {
                  c.classList.remove(n, i),
                    c.classList.add("active"),
                    a.classList.remove("active", i, n),
                    (o._isSliding = !1),
                    setTimeout(function () {
                      K.trigger(o._element, "slid.bs.carousel", {
                        relatedTarget: c,
                        direction: r,
                        from: s,
                        to: l,
                      });
                    }, 0);
                }),
                  _(a, f);
              } else
                a.classList.remove("active"),
                  c.classList.add("active"),
                  (this._isSliding = !1),
                  K.trigger(this._element, "slid.bs.carousel", {
                    relatedTarget: c,
                    direction: r,
                    from: s,
                    to: l,
                  });
              u && this.cycle();
            }
          }),
          (t.carouselInterface = function (e, n) {
            var i = C(e, "bs.carousel"),
              r = c(c({}, ct), rt.getDataAttributes(e));
            "object" == typeof n && (r = c(c({}, r), n));
            var o = "string" == typeof n ? n : r.slide;
            if ((i || (i = new t(e, r)), "number" == typeof n)) i.to(n);
            else if ("string" == typeof o) {
              if (void 0 === i[o])
                throw new TypeError('No method named "' + o + '"');
              i[o]();
            } else r.interval && r.ride && (i.pause(), i.cycle());
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              t.carouselInterface(this, e);
            });
          }),
          (t.dataApiClickHandler = function (e) {
            var n = g(this);
            if (n && n.classList.contains("carousel")) {
              var i = c(
                  c({}, rt.getDataAttributes(n)),
                  rt.getDataAttributes(this)
                ),
                r = this.getAttribute("data-slide-to");
              r && (i.interval = !1),
                t.carouselInterface(n, i),
                r && C(n, "bs.carousel").to(r),
                e.preventDefault();
            }
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.carousel");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return ct;
              },
            },
          ]),
          t
        );
      })();
    K.on(
      document,
      "click.bs.carousel.data-api",
      "[data-slide], [data-slide-to]",
      dt.dataApiClickHandler
    ),
      K.on(window, "load.bs.carousel.data-api", function () {
        for (
          var t = ot.find('[data-ride="carousel"]'), e = 0, n = t.length;
          e < n;
          e++
        )
          dt.carouselInterface(t[e], C(t[e], "bs.carousel"));
      });
    var ft = T();
    if (ft) {
      var ht = ft.fn[at];
      (ft.fn[at] = dt.jQueryInterface),
        (ft.fn[at].Constructor = dt),
        (ft.fn[at].noConflict = function () {
          return (ft.fn[at] = ht), dt.jQueryInterface;
        });
    }
    var pt = "collapse",
      mt = { toggle: !0, parent: "" },
      gt = { toggle: "boolean", parent: "(string|element)" },
      vt = (function () {
        function t(t, e) {
          (this._isTransitioning = !1),
            (this._element = t),
            (this._config = this._getConfig(e)),
            (this._triggerArray = ot.find(
              '[data-toggle="collapse"][href="#' +
                t.id +
                '"],[data-toggle="collapse"][data-target="#' +
                t.id +
                '"]'
            ));
          for (
            var n = ot.find('[data-toggle="collapse"]'), i = 0, r = n.length;
            i < r;
            i++
          ) {
            var o = n[i],
              a = m(o),
              s = ot.find(a).filter(function (e) {
                return e === t;
              });
            null !== a &&
              s.length &&
              ((this._selector = a), this._triggerArray.push(o));
          }
          (this._parent = this._config.parent ? this._getParent() : null),
            this._config.parent ||
              this._addAriaAndCollapsedClass(this._element, this._triggerArray),
            this._config.toggle && this.toggle(),
            L(t, "bs.collapse", this);
        }
        var e = t.prototype;
        return (
          (e.toggle = function () {
            this._element.classList.contains("show")
              ? this.hide()
              : this.show();
          }),
          (e.show = function () {
            var e = this;
            if (
              !this._isTransitioning &&
              !this._element.classList.contains("show")
            ) {
              var n, i;
              this._parent &&
                0 ===
                  (n = ot
                    .find(".show, .collapsing", this._parent)
                    .filter(function (t) {
                      return "string" == typeof e._config.parent
                        ? t.getAttribute("data-parent") === e._config.parent
                        : t.classList.contains("collapse");
                    })).length &&
                (n = null);
              var r = ot.findOne(this._selector);
              if (n) {
                var o = n.filter(function (t) {
                  return r !== t;
                });
                if (
                  (i = o[0] ? C(o[0], "bs.collapse") : null) &&
                  i._isTransitioning
                )
                  return;
              }
              if (
                !K.trigger(this._element, "show.bs.collapse").defaultPrevented
              ) {
                n &&
                  n.forEach(function (e) {
                    r !== e && t.collapseInterface(e, "hide"),
                      i || L(e, "bs.collapse", null);
                  });
                var a = this._getDimension();
                this._element.classList.remove("collapse"),
                  this._element.classList.add("collapsing"),
                  (this._element.style[a] = 0),
                  this._triggerArray.length &&
                    this._triggerArray.forEach(function (t) {
                      t.classList.remove("collapsed"),
                        t.setAttribute("aria-expanded", !0);
                    }),
                  this.setTransitioning(!0);
                var s = "scroll" + (a[0].toUpperCase() + a.slice(1)),
                  c = v(this._element);
                K.one(this._element, "transitionend", function () {
                  e._element.classList.remove("collapsing"),
                    e._element.classList.add("collapse", "show"),
                    (e._element.style[a] = ""),
                    e.setTransitioning(!1),
                    K.trigger(e._element, "shown.bs.collapse");
                }),
                  _(this._element, c),
                  (this._element.style[a] = this._element[s] + "px");
              }
            }
          }),
          (e.hide = function () {
            var t = this;
            if (
              !this._isTransitioning &&
              this._element.classList.contains("show") &&
              !K.trigger(this._element, "hide.bs.collapse").defaultPrevented
            ) {
              var e = this._getDimension();
              (this._element.style[e] =
                this._element.getBoundingClientRect()[e] + "px"),
                S(this._element),
                this._element.classList.add("collapsing"),
                this._element.classList.remove("collapse", "show");
              var n = this._triggerArray.length;
              if (n > 0)
                for (var i = 0; i < n; i++) {
                  var r = this._triggerArray[i],
                    o = g(r);
                  o &&
                    !o.classList.contains("show") &&
                    (r.classList.add("collapsed"),
                    r.setAttribute("aria-expanded", !1));
                }
              this.setTransitioning(!0);
              this._element.style[e] = "";
              var a = v(this._element);
              K.one(this._element, "transitionend", function () {
                t.setTransitioning(!1),
                  t._element.classList.remove("collapsing"),
                  t._element.classList.add("collapse"),
                  K.trigger(t._element, "hidden.bs.collapse");
              }),
                _(this._element, a);
            }
          }),
          (e.setTransitioning = function (t) {
            this._isTransitioning = t;
          }),
          (e.dispose = function () {
            x(this._element, "bs.collapse"),
              (this._config = null),
              (this._parent = null),
              (this._element = null),
              (this._triggerArray = null),
              (this._isTransitioning = null);
          }),
          (e._getConfig = function (t) {
            return (
              ((t = c(c({}, mt), t)).toggle = Boolean(t.toggle)),
              w(pt, t, gt),
              t
            );
          }),
          (e._getDimension = function () {
            return this._element.classList.contains("width")
              ? "width"
              : "height";
          }),
          (e._getParent = function () {
            var t = this,
              e = this._config.parent;
            b(e)
              ? (void 0 === e.jquery && void 0 === e[0]) || (e = e[0])
              : (e = ot.findOne(e));
            var n = '[data-toggle="collapse"][data-parent="' + e + '"]';
            return (
              ot.find(n, e).forEach(function (e) {
                var n = g(e);
                t._addAriaAndCollapsedClass(n, [e]);
              }),
              e
            );
          }),
          (e._addAriaAndCollapsedClass = function (t, e) {
            if (t) {
              var n = t.classList.contains("show");
              e.length &&
                e.forEach(function (t) {
                  n
                    ? t.classList.remove("collapsed")
                    : t.classList.add("collapsed"),
                    t.setAttribute("aria-expanded", n);
                });
            }
          }),
          (t.collapseInterface = function (e, n) {
            var i = C(e, "bs.collapse"),
              r = c(
                c(c({}, mt), rt.getDataAttributes(e)),
                "object" == typeof n && n ? n : {}
              );
            if (
              (!i &&
                r.toggle &&
                "string" == typeof n &&
                /show|hide/.test(n) &&
                (r.toggle = !1),
              i || (i = new t(e, r)),
              "string" == typeof n)
            ) {
              if (void 0 === i[n])
                throw new TypeError('No method named "' + n + '"');
              i[n]();
            }
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              t.collapseInterface(this, e);
            });
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.collapse");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return mt;
              },
            },
          ]),
          t
        );
      })();
    K.on(
      document,
      "click.bs.collapse.data-api",
      '[data-toggle="collapse"]',
      function (t) {
        "A" === t.target.tagName && t.preventDefault();
        var e = rt.getDataAttributes(this),
          n = m(this);
        ot.find(n).forEach(function (t) {
          var n,
            i = C(t, "bs.collapse");
          i
            ? (null === i._parent &&
                "string" == typeof e.parent &&
                ((i._config.parent = e.parent), (i._parent = i._getParent())),
              (n = "toggle"))
            : (n = e),
            vt.collapseInterface(t, n);
        });
      }
    );
    var yt = T();
    if (yt) {
      var bt = yt.fn[pt];
      (yt.fn[pt] = vt.jQueryInterface),
        (yt.fn[pt].Constructor = vt),
        (yt.fn[pt].noConflict = function () {
          return (yt.fn[pt] = bt), vt.jQueryInterface;
        });
    }
    var _t = "dropdown",
      wt = new RegExp("ArrowUp|ArrowDown|Escape"),
      Et = {
        offset: 0,
        flip: !0,
        boundary: "scrollParent",
        reference: "toggle",
        display: "dynamic",
        popperConfig: null,
      },
      kt = {
        offset: "(number|string|function)",
        flip: "boolean",
        boundary: "(string|element)",
        reference: "(string|element)",
        display: "string",
        popperConfig: "(null|object)",
      },
      St = (function () {
        function t(t, e) {
          (this._element = t),
            (this._popper = null),
            (this._config = this._getConfig(e)),
            (this._menu = this._getMenuElement()),
            (this._inNavbar = this._detectNavbar()),
            this._addEventListeners(),
            L(t, "bs.dropdown", this);
        }
        var e = t.prototype;
        return (
          (e.toggle = function () {
            if (
              !this._element.disabled &&
              !this._element.classList.contains("disabled")
            ) {
              var e = this._element.classList.contains("show");
              t.clearMenus(), e || this.show();
            }
          }),
          (e.show = function () {
            if (
              !(
                this._element.disabled ||
                this._element.classList.contains("disabled") ||
                this._menu.classList.contains("show")
              )
            ) {
              var e = t.getParentFromElement(this._element),
                n = { relatedTarget: this._element };
              if (
                !K.trigger(this._element, "show.bs.dropdown", n)
                  .defaultPrevented
              ) {
                if (!this._inNavbar) {
                  if (void 0 === i.a)
                    throw new TypeError(
                      "Bootstrap's dropdowns require Popper.js (https://popper.js.org)"
                    );
                  var r = this._element;
                  "parent" === this._config.reference
                    ? (r = e)
                    : b(this._config.reference) &&
                      ((r = this._config.reference),
                      void 0 !== this._config.reference.jquery &&
                        (r = this._config.reference[0])),
                    "scrollParent" !== this._config.boundary &&
                      e.classList.add("position-static"),
                    (this._popper = new i.a(
                      r,
                      this._menu,
                      this._getPopperConfig()
                    ));
                }
                var o;
                if (
                  "ontouchstart" in document.documentElement &&
                  !e.closest(".navbar-nav")
                )
                  (o = []).concat
                    .apply(o, document.body.children)
                    .forEach(function (t) {
                      return K.on(t, "mouseover", null, function () {});
                    });
                this._element.focus(),
                  this._element.setAttribute("aria-expanded", !0),
                  rt.toggleClass(this._menu, "show"),
                  rt.toggleClass(this._element, "show"),
                  K.trigger(e, "shown.bs.dropdown", n);
              }
            }
          }),
          (e.hide = function () {
            if (
              !this._element.disabled &&
              !this._element.classList.contains("disabled") &&
              this._menu.classList.contains("show")
            ) {
              var e = t.getParentFromElement(this._element),
                n = { relatedTarget: this._element };
              K.trigger(e, "hide.bs.dropdown", n).defaultPrevented ||
                (this._popper && this._popper.destroy(),
                rt.toggleClass(this._menu, "show"),
                rt.toggleClass(this._element, "show"),
                K.trigger(e, "hidden.bs.dropdown", n));
            }
          }),
          (e.dispose = function () {
            x(this._element, "bs.dropdown"),
              K.off(this._element, ".bs.dropdown"),
              (this._element = null),
              (this._menu = null),
              this._popper && (this._popper.destroy(), (this._popper = null));
          }),
          (e.update = function () {
            (this._inNavbar = this._detectNavbar()),
              this._popper && this._popper.scheduleUpdate();
          }),
          (e._addEventListeners = function () {
            var t = this;
            K.on(this._element, "click.bs.dropdown", function (e) {
              e.preventDefault(), e.stopPropagation(), t.toggle();
            });
          }),
          (e._getConfig = function (t) {
            return (
              (t = c(
                c(
                  c({}, this.constructor.Default),
                  rt.getDataAttributes(this._element)
                ),
                t
              )),
              w(_t, t, this.constructor.DefaultType),
              t
            );
          }),
          (e._getMenuElement = function () {
            return ot.next(this._element, ".dropdown-menu")[0];
          }),
          (e._getPlacement = function () {
            var t = this._element.parentNode,
              e = "bottom-start";
            return (
              t.classList.contains("dropup")
                ? ((e = "top-start"),
                  this._menu.classList.contains("dropdown-menu-right") &&
                    (e = "top-end"))
                : t.classList.contains("dropright")
                ? (e = "right-start")
                : t.classList.contains("dropleft")
                ? (e = "left-start")
                : this._menu.classList.contains("dropdown-menu-right") &&
                  (e = "bottom-end"),
              e
            );
          }),
          (e._detectNavbar = function () {
            return Boolean(this._element.closest(".navbar"));
          }),
          (e._getOffset = function () {
            var t = this,
              e = {};
            return (
              "function" == typeof this._config.offset
                ? (e.fn = function (e) {
                    return (
                      (e.offsets = c(
                        c({}, e.offsets),
                        t._config.offset(e.offsets, t._element) || {}
                      )),
                      e
                    );
                  })
                : (e.offset = this._config.offset),
              e
            );
          }),
          (e._getPopperConfig = function () {
            var t = {
              placement: this._getPlacement(),
              modifiers: {
                offset: this._getOffset(),
                flip: { enabled: this._config.flip },
                preventOverflow: { boundariesElement: this._config.boundary },
              },
            };
            return (
              "static" === this._config.display &&
                (t.modifiers.applyStyle = { enabled: !1 }),
              c(c({}, t), this._config.popperConfig)
            );
          }),
          (t.dropdownInterface = function (e, n) {
            var i = C(e, "bs.dropdown");
            if (
              (i || (i = new t(e, "object" == typeof n ? n : null)),
              "string" == typeof n)
            ) {
              if (void 0 === i[n])
                throw new TypeError('No method named "' + n + '"');
              i[n]();
            }
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              t.dropdownInterface(this, e);
            });
          }),
          (t.clearMenus = function (e) {
            if (
              !e ||
              (2 !== e.button && ("keyup" !== e.type || "Tab" === e.key))
            )
              for (
                var n = ot.find('[data-toggle="dropdown"]'),
                  i = 0,
                  r = n.length;
                i < r;
                i++
              ) {
                var o = t.getParentFromElement(n[i]),
                  a = C(n[i], "bs.dropdown"),
                  s = { relatedTarget: n[i] };
                if ((e && "click" === e.type && (s.clickEvent = e), a)) {
                  var c = a._menu;
                  if (n[i].classList.contains("show"))
                    if (
                      !(
                        e &&
                        (("click" === e.type &&
                          /input|textarea/i.test(e.target.tagName)) ||
                          ("keyup" === e.type && "Tab" === e.key)) &&
                        c.contains(e.target)
                      )
                    )
                      if (
                        !K.trigger(o, "hide.bs.dropdown", s).defaultPrevented
                      ) {
                        var l;
                        if ("ontouchstart" in document.documentElement)
                          (l = []).concat
                            .apply(l, document.body.children)
                            .forEach(function (t) {
                              return K.off(
                                t,
                                "mouseover",
                                null,
                                function () {}
                              );
                            });
                        n[i].setAttribute("aria-expanded", "false"),
                          a._popper && a._popper.destroy(),
                          c.classList.remove("show"),
                          n[i].classList.remove("show"),
                          K.trigger(o, "hidden.bs.dropdown", s);
                      }
                }
              }
          }),
          (t.getParentFromElement = function (t) {
            return g(t) || t.parentNode;
          }),
          (t.dataApiKeydownHandler = function (e) {
            if (
              !(/input|textarea/i.test(e.target.tagName)
                ? "Space" === e.key ||
                  ("Escape" !== e.key &&
                    (("ArrowDown" !== e.key && "ArrowUp" !== e.key) ||
                      e.target.closest(".dropdown-menu")))
                : !wt.test(e.key)) &&
              (e.preventDefault(),
              e.stopPropagation(),
              !this.disabled && !this.classList.contains("disabled"))
            ) {
              var n = t.getParentFromElement(this),
                i = this.classList.contains("show");
              if ("Escape" === e.key)
                return (
                  (this.matches('[data-toggle="dropdown"]')
                    ? this
                    : ot.prev(this, '[data-toggle="dropdown"]')[0]
                  ).focus(),
                  void t.clearMenus()
                );
              if (i && "Space" !== e.key) {
                var r = ot
                  .find(
                    ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
                    n
                  )
                  .filter(E);
                if (r.length) {
                  var o = r.indexOf(e.target);
                  "ArrowUp" === e.key && o > 0 && o--,
                    "ArrowDown" === e.key && o < r.length - 1 && o++,
                    r[(o = -1 === o ? 0 : o)].focus();
                }
              } else t.clearMenus();
            }
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.dropdown");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return Et;
              },
            },
            {
              key: "DefaultType",
              get: function () {
                return kt;
              },
            },
          ]),
          t
        );
      })();
    K.on(
      document,
      "keydown.bs.dropdown.data-api",
      '[data-toggle="dropdown"]',
      St.dataApiKeydownHandler
    ),
      K.on(
        document,
        "keydown.bs.dropdown.data-api",
        ".dropdown-menu",
        St.dataApiKeydownHandler
      ),
      K.on(document, "click.bs.dropdown.data-api", St.clearMenus),
      K.on(document, "keyup.bs.dropdown.data-api", St.clearMenus),
      K.on(
        document,
        "click.bs.dropdown.data-api",
        '[data-toggle="dropdown"]',
        function (t) {
          t.preventDefault(),
            t.stopPropagation(),
            St.dropdownInterface(this, "toggle");
        }
      ),
      K.on(
        document,
        "click.bs.dropdown.data-api",
        ".dropdown form",
        function (t) {
          return t.stopPropagation();
        }
      );
    var Tt = T();
    if (Tt) {
      var At = Tt.fn[_t];
      (Tt.fn[_t] = St.jQueryInterface),
        (Tt.fn[_t].Constructor = St),
        (Tt.fn[_t].noConflict = function () {
          return (Tt.fn[_t] = At), St.jQueryInterface;
        });
    }
    var Lt = { backdrop: !0, keyboard: !0, focus: !0, show: !0 },
      Ct = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean",
      },
      xt = (function () {
        function t(t, e) {
          (this._config = this._getConfig(e)),
            (this._element = t),
            (this._dialog = ot.findOne(".modal-dialog", t)),
            (this._backdrop = null),
            (this._isShown = !1),
            (this._isBodyOverflowing = !1),
            (this._ignoreBackdropClick = !1),
            (this._isTransitioning = !1),
            (this._scrollbarWidth = 0),
            L(t, "bs.modal", this);
        }
        var e = t.prototype;
        return (
          (e.toggle = function (t) {
            return this._isShown ? this.hide() : this.show(t);
          }),
          (e.show = function (t) {
            var e = this;
            if (!this._isShown && !this._isTransitioning) {
              this._element.classList.contains("fade") &&
                (this._isTransitioning = !0);
              var n = K.trigger(this._element, "show.bs.modal", {
                relatedTarget: t,
              });
              this._isShown ||
                n.defaultPrevented ||
                ((this._isShown = !0),
                this._checkScrollbar(),
                this._setScrollbar(),
                this._adjustDialog(),
                this._setEscapeEvent(),
                this._setResizeEvent(),
                K.on(
                  this._element,
                  "click.dismiss.bs.modal",
                  '[data-dismiss="modal"]',
                  function (t) {
                    return e.hide(t);
                  }
                ),
                K.on(this._dialog, "mousedown.dismiss.bs.modal", function () {
                  K.one(e._element, "mouseup.dismiss.bs.modal", function (t) {
                    t.target === e._element && (e._ignoreBackdropClick = !0);
                  });
                }),
                this._showBackdrop(function () {
                  return e._showElement(t);
                }));
            }
          }),
          (e.hide = function (t) {
            var e = this;
            if (
              (t && t.preventDefault(),
              this._isShown && !this._isTransitioning) &&
              !K.trigger(this._element, "hide.bs.modal").defaultPrevented
            ) {
              this._isShown = !1;
              var n = this._element.classList.contains("fade");
              if (
                (n && (this._isTransitioning = !0),
                this._setEscapeEvent(),
                this._setResizeEvent(),
                K.off(document, "focusin.bs.modal"),
                this._element.classList.remove("show"),
                K.off(this._element, "click.dismiss.bs.modal"),
                K.off(this._dialog, "mousedown.dismiss.bs.modal"),
                n)
              ) {
                var i = v(this._element);
                K.one(this._element, "transitionend", function (t) {
                  return e._hideModal(t);
                }),
                  _(this._element, i);
              } else this._hideModal();
            }
          }),
          (e.dispose = function () {
            [window, this._element, this._dialog].forEach(function (t) {
              return K.off(t, ".bs.modal");
            }),
              K.off(document, "focusin.bs.modal"),
              x(this._element, "bs.modal"),
              (this._config = null),
              (this._element = null),
              (this._dialog = null),
              (this._backdrop = null),
              (this._isShown = null),
              (this._isBodyOverflowing = null),
              (this._ignoreBackdropClick = null),
              (this._isTransitioning = null),
              (this._scrollbarWidth = null);
          }),
          (e.handleUpdate = function () {
            this._adjustDialog();
          }),
          (e._getConfig = function (t) {
            return (t = c(c({}, Lt), t)), w("modal", t, Ct), t;
          }),
          (e._showElement = function (t) {
            var e = this,
              n = this._element.classList.contains("fade"),
              i = ot.findOne(".modal-body", this._dialog);
            (this._element.parentNode &&
              this._element.parentNode.nodeType === Node.ELEMENT_NODE) ||
              document.body.appendChild(this._element),
              (this._element.style.display = "block"),
              this._element.removeAttribute("aria-hidden"),
              this._element.setAttribute("aria-modal", !0),
              this._element.setAttribute("role", "dialog"),
              (this._element.scrollTop = 0),
              i && (i.scrollTop = 0),
              n && S(this._element),
              this._element.classList.add("show"),
              this._config.focus && this._enforceFocus();
            var r = function () {
              e._config.focus && e._element.focus(),
                (e._isTransitioning = !1),
                K.trigger(e._element, "shown.bs.modal", { relatedTarget: t });
            };
            if (n) {
              var o = v(this._dialog);
              K.one(this._dialog, "transitionend", r), _(this._dialog, o);
            } else r();
          }),
          (e._enforceFocus = function () {
            var t = this;
            K.off(document, "focusin.bs.modal"),
              K.on(document, "focusin.bs.modal", function (e) {
                document === e.target ||
                  t._element === e.target ||
                  t._element.contains(e.target) ||
                  t._element.focus();
              });
          }),
          (e._setEscapeEvent = function () {
            var t = this;
            this._isShown
              ? K.on(this._element, "keydown.dismiss.bs.modal", function (e) {
                  t._config.keyboard && "Escape" === e.key
                    ? (e.preventDefault(), t.hide())
                    : t._config.keyboard ||
                      "Escape" !== e.key ||
                      t._triggerBackdropTransition();
                })
              : K.off(this._element, "keydown.dismiss.bs.modal");
          }),
          (e._setResizeEvent = function () {
            var t = this;
            this._isShown
              ? K.on(window, "resize.bs.modal", function () {
                  return t._adjustDialog();
                })
              : K.off(window, "resize.bs.modal");
          }),
          (e._hideModal = function () {
            var t = this;
            (this._element.style.display = "none"),
              this._element.setAttribute("aria-hidden", !0),
              this._element.removeAttribute("aria-modal"),
              this._element.removeAttribute("role"),
              (this._isTransitioning = !1),
              this._showBackdrop(function () {
                document.body.classList.remove("modal-open"),
                  t._resetAdjustments(),
                  t._resetScrollbar(),
                  K.trigger(t._element, "hidden.bs.modal");
              });
          }),
          (e._removeBackdrop = function () {
            this._backdrop.parentNode.removeChild(this._backdrop),
              (this._backdrop = null);
          }),
          (e._showBackdrop = function (t) {
            var e = this,
              n = this._element.classList.contains("fade") ? "fade" : "";
            if (this._isShown && this._config.backdrop) {
              if (
                ((this._backdrop = document.createElement("div")),
                (this._backdrop.className = "modal-backdrop"),
                n && this._backdrop.classList.add(n),
                document.body.appendChild(this._backdrop),
                K.on(this._element, "click.dismiss.bs.modal", function (t) {
                  e._ignoreBackdropClick
                    ? (e._ignoreBackdropClick = !1)
                    : t.target === t.currentTarget &&
                      e._triggerBackdropTransition();
                }),
                n && S(this._backdrop),
                this._backdrop.classList.add("show"),
                !n)
              )
                return void t();
              var i = v(this._backdrop);
              K.one(this._backdrop, "transitionend", t), _(this._backdrop, i);
            } else if (!this._isShown && this._backdrop) {
              this._backdrop.classList.remove("show");
              var r = function () {
                e._removeBackdrop(), t();
              };
              if (this._element.classList.contains("fade")) {
                var o = v(this._backdrop);
                K.one(this._backdrop, "transitionend", r), _(this._backdrop, o);
              } else r();
            } else t();
          }),
          (e._triggerBackdropTransition = function () {
            var t = this;
            if ("static" === this._config.backdrop) {
              if (
                K.trigger(this._element, "hidePrevented.bs.modal")
                  .defaultPrevented
              )
                return;
              this._element.classList.add("modal-static");
              var e = v(this._element);
              K.one(this._element, "transitionend", function () {
                t._element.classList.remove("modal-static");
              }),
                _(this._element, e),
                this._element.focus();
            } else this.hide();
          }),
          (e._adjustDialog = function () {
            var t =
              this._element.scrollHeight >
              document.documentElement.clientHeight;
            !this._isBodyOverflowing &&
              t &&
              (this._element.style.paddingLeft = this._scrollbarWidth + "px"),
              this._isBodyOverflowing &&
                !t &&
                (this._element.style.paddingRight =
                  this._scrollbarWidth + "px");
          }),
          (e._resetAdjustments = function () {
            (this._element.style.paddingLeft = ""),
              (this._element.style.paddingRight = "");
          }),
          (e._checkScrollbar = function () {
            var t = document.body.getBoundingClientRect();
            (this._isBodyOverflowing =
              Math.round(t.left + t.right) < window.innerWidth),
              (this._scrollbarWidth = this._getScrollbarWidth());
          }),
          (e._setScrollbar = function () {
            var t = this;
            if (this._isBodyOverflowing) {
              ot
                .find(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")
                .forEach(function (e) {
                  var n = e.style.paddingRight,
                    i = window.getComputedStyle(e)["padding-right"];
                  rt.setDataAttribute(e, "padding-right", n),
                    (e.style.paddingRight =
                      parseFloat(i) + t._scrollbarWidth + "px");
                }),
                ot.find(".sticky-top").forEach(function (e) {
                  var n = e.style.marginRight,
                    i = window.getComputedStyle(e)["margin-right"];
                  rt.setDataAttribute(e, "margin-right", n),
                    (e.style.marginRight =
                      parseFloat(i) - t._scrollbarWidth + "px");
                });
              var e = document.body.style.paddingRight,
                n = window.getComputedStyle(document.body)["padding-right"];
              rt.setDataAttribute(document.body, "padding-right", e),
                (document.body.style.paddingRight =
                  parseFloat(n) + this._scrollbarWidth + "px");
            }
            document.body.classList.add("modal-open");
          }),
          (e._resetScrollbar = function () {
            ot
              .find(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")
              .forEach(function (t) {
                var e = rt.getDataAttribute(t, "padding-right");
                void 0 !== e &&
                  (rt.removeDataAttribute(t, "padding-right"),
                  (t.style.paddingRight = e));
              }),
              ot.find(".sticky-top").forEach(function (t) {
                var e = rt.getDataAttribute(t, "margin-right");
                void 0 !== e &&
                  (rt.removeDataAttribute(t, "margin-right"),
                  (t.style.marginRight = e));
              });
            var t = rt.getDataAttribute(document.body, "padding-right");
            void 0 === t
              ? (document.body.style.paddingRight = "")
              : (rt.removeDataAttribute(document.body, "padding-right"),
                (document.body.style.paddingRight = t));
          }),
          (e._getScrollbarWidth = function () {
            var t = document.createElement("div");
            (t.className = "modal-scrollbar-measure"),
              document.body.appendChild(t);
            var e = t.getBoundingClientRect().width - t.clientWidth;
            return document.body.removeChild(t), e;
          }),
          (t.jQueryInterface = function (e, n) {
            return this.each(function () {
              var i = C(this, "bs.modal"),
                r = c(
                  c(c({}, Lt), rt.getDataAttributes(this)),
                  "object" == typeof e && e ? e : {}
                );
              if ((i || (i = new t(this, r)), "string" == typeof e)) {
                if (void 0 === i[e])
                  throw new TypeError('No method named "' + e + '"');
                i[e](n);
              } else r.show && i.show(n);
            });
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.modal");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return Lt;
              },
            },
          ]),
          t
        );
      })();
    K.on(
      document,
      "click.bs.modal.data-api",
      '[data-toggle="modal"]',
      function (t) {
        var e = this,
          n = g(this);
        ("A" !== this.tagName && "AREA" !== this.tagName) || t.preventDefault(),
          K.one(n, "show.bs.modal", function (t) {
            t.defaultPrevented ||
              K.one(n, "hidden.bs.modal", function () {
                E(e) && e.focus();
              });
          });
        var i = C(n, "bs.modal");
        if (!i) {
          var r = c(c({}, rt.getDataAttributes(n)), rt.getDataAttributes(this));
          i = new xt(n, r);
        }
        i.show(this);
      }
    );
    var Ot = T();
    if (Ot) {
      var $t = Ot.fn.modal;
      (Ot.fn.modal = xt.jQueryInterface),
        (Ot.fn.modal.Constructor = xt),
        (Ot.fn.modal.noConflict = function () {
          return (Ot.fn.modal = $t), xt.jQueryInterface;
        });
    }
    var Pt = [
        "background",
        "cite",
        "href",
        "itemtype",
        "longdesc",
        "poster",
        "src",
        "xlink:href",
      ],
      It = /^(?:(?:https?|mailto|ftp|tel|file):|[^#&/:?]*(?:[#/?]|$))/gi,
      Rt =
        /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[\d+/a-z]+=*$/i,
      Mt = {
        "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
        a: ["target", "href", "title", "rel"],
        area: [],
        b: [],
        br: [],
        col: [],
        code: [],
        div: [],
        em: [],
        hr: [],
        h1: [],
        h2: [],
        h3: [],
        h4: [],
        h5: [],
        h6: [],
        i: [],
        img: ["src", "srcset", "alt", "title", "width", "height"],
        li: [],
        ol: [],
        p: [],
        pre: [],
        s: [],
        small: [],
        span: [],
        sub: [],
        sup: [],
        strong: [],
        u: [],
        ul: [],
      };
    function Nt(t, e, n) {
      var i;
      if (!t.length) return t;
      if (n && "function" == typeof n) return n(t);
      for (
        var r = new window.DOMParser().parseFromString(t, "text/html"),
          o = Object.keys(e),
          a = (i = []).concat.apply(i, r.body.querySelectorAll("*")),
          s = function (t, n) {
            var i,
              r = a[t],
              s = r.nodeName.toLowerCase();
            if (-1 === o.indexOf(s))
              return r.parentNode.removeChild(r), "continue";
            var c = (i = []).concat.apply(i, r.attributes),
              l = [].concat(e["*"] || [], e[s] || []);
            c.forEach(function (t) {
              (function (t, e) {
                var n = t.nodeName.toLowerCase();
                if (-1 !== e.indexOf(n))
                  return (
                    -1 === Pt.indexOf(n) ||
                    Boolean(t.nodeValue.match(It) || t.nodeValue.match(Rt))
                  );
                for (
                  var i = e.filter(function (t) {
                      return t instanceof RegExp;
                    }),
                    r = 0,
                    o = i.length;
                  r < o;
                  r++
                )
                  if (n.match(i[r])) return !0;
                return !1;
              })(t, l) || r.removeAttribute(t.nodeName);
            });
          },
          c = 0,
          l = a.length;
        c < l;
        c++
      )
        s(c);
      return r.body.innerHTML;
    }
    var Dt = "tooltip",
      qt = new RegExp("(^|\\s)bs-tooltip\\S+", "g"),
      jt = ["sanitize", "whiteList", "sanitizeFn"],
      Bt = {
        animation: "boolean",
        template: "string",
        title: "(string|element|function)",
        trigger: "string",
        delay: "(number|object)",
        html: "boolean",
        selector: "(string|boolean)",
        placement: "(string|function)",
        offset: "(number|string|function)",
        container: "(string|element|boolean)",
        fallbackPlacement: "(string|array)",
        boundary: "(string|element)",
        sanitize: "boolean",
        sanitizeFn: "(null|function)",
        whiteList: "object",
        popperConfig: "(null|object)",
      },
      Ht = {
        AUTO: "auto",
        TOP: "top",
        RIGHT: "right",
        BOTTOM: "bottom",
        LEFT: "left",
      },
      Ut = {
        animation: !0,
        template:
          '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        selector: !1,
        placement: "top",
        offset: 0,
        container: !1,
        fallbackPlacement: "flip",
        boundary: "scrollParent",
        sanitize: !0,
        sanitizeFn: null,
        whiteList: Mt,
        popperConfig: null,
      },
      Ft = {
        HIDE: "hide.bs.tooltip",
        HIDDEN: "hidden.bs.tooltip",
        SHOW: "show.bs.tooltip",
        SHOWN: "shown.bs.tooltip",
        INSERTED: "inserted.bs.tooltip",
        CLICK: "click.bs.tooltip",
        FOCUSIN: "focusin.bs.tooltip",
        FOCUSOUT: "focusout.bs.tooltip",
        MOUSEENTER: "mouseenter.bs.tooltip",
        MOUSELEAVE: "mouseleave.bs.tooltip",
      },
      Wt = (function () {
        function t(t, e) {
          if (void 0 === i.a)
            throw new TypeError(
              "Bootstrap's tooltips require Popper.js (https://popper.js.org)"
            );
          (this._isEnabled = !0),
            (this._timeout = 0),
            (this._hoverState = ""),
            (this._activeTrigger = {}),
            (this._popper = null),
            (this.element = t),
            (this.config = this._getConfig(e)),
            (this.tip = null),
            this._setListeners(),
            L(t, this.constructor.DATA_KEY, this);
        }
        var e = t.prototype;
        return (
          (e.enable = function () {
            this._isEnabled = !0;
          }),
          (e.disable = function () {
            this._isEnabled = !1;
          }),
          (e.toggleEnabled = function () {
            this._isEnabled = !this._isEnabled;
          }),
          (e.toggle = function (t) {
            if (this._isEnabled)
              if (t) {
                var e = this.constructor.DATA_KEY,
                  n = C(t.target, e);
                n ||
                  ((n = new this.constructor(
                    t.target,
                    this._getDelegateConfig()
                  )),
                  L(t.target, e, n)),
                  (n._activeTrigger.click = !n._activeTrigger.click),
                  n._isWithActiveTrigger()
                    ? n._enter(null, n)
                    : n._leave(null, n);
              } else {
                if (this.getTipElement().classList.contains("show"))
                  return void this._leave(null, this);
                this._enter(null, this);
              }
          }),
          (e.dispose = function () {
            clearTimeout(this._timeout),
              x(this.element, this.constructor.DATA_KEY),
              K.off(this.element, this.constructor.EVENT_KEY),
              K.off(
                this.element.closest(".modal"),
                "hide.bs.modal",
                this._hideModalHandler
              ),
              this.tip && this.tip.parentNode.removeChild(this.tip),
              (this._isEnabled = null),
              (this._timeout = null),
              (this._hoverState = null),
              (this._activeTrigger = null),
              this._popper && this._popper.destroy(),
              (this._popper = null),
              (this.element = null),
              (this.config = null),
              (this.tip = null);
          }),
          (e.show = function () {
            var t = this;
            if ("none" === this.element.style.display)
              throw new Error("Please use show on visible elements");
            if (this.isWithContent() && this._isEnabled) {
              var e = K.trigger(this.element, this.constructor.Event.SHOW),
                n = (function t(e) {
                  if (!document.documentElement.attachShadow) return null;
                  if ("function" == typeof e.getRootNode) {
                    var n = e.getRootNode();
                    return n instanceof ShadowRoot ? n : null;
                  }
                  return e instanceof ShadowRoot
                    ? e
                    : e.parentNode
                    ? t(e.parentNode)
                    : null;
                })(this.element),
                r =
                  null === n
                    ? this.element.ownerDocument.documentElement.contains(
                        this.element
                      )
                    : n.contains(this.element);
              if (e.defaultPrevented || !r) return;
              var o = this.getTipElement(),
                a = h(this.constructor.NAME);
              o.setAttribute("id", a),
                this.element.setAttribute("aria-describedby", a),
                this.setContent(),
                this.config.animation && o.classList.add("fade");
              var s =
                  "function" == typeof this.config.placement
                    ? this.config.placement.call(this, o, this.element)
                    : this.config.placement,
                c = this._getAttachment(s);
              this._addAttachmentClass(c);
              var l,
                u = this._getContainer();
              if (
                (L(o, this.constructor.DATA_KEY, this),
                this.element.ownerDocument.documentElement.contains(this.tip) ||
                  u.appendChild(o),
                K.trigger(this.element, this.constructor.Event.INSERTED),
                (this._popper = new i.a(
                  this.element,
                  o,
                  this._getPopperConfig(c)
                )),
                o.classList.add("show"),
                "ontouchstart" in document.documentElement)
              )
                (l = []).concat
                  .apply(l, document.body.children)
                  .forEach(function (t) {
                    K.on(t, "mouseover", function () {});
                  });
              var d = function () {
                t.config.animation && t._fixTransition();
                var e = t._hoverState;
                (t._hoverState = null),
                  K.trigger(t.element, t.constructor.Event.SHOWN),
                  "out" === e && t._leave(null, t);
              };
              if (this.tip.classList.contains("fade")) {
                var f = v(this.tip);
                K.one(this.tip, "transitionend", d), _(this.tip, f);
              } else d();
            }
          }),
          (e.hide = function () {
            var t = this,
              e = this.getTipElement(),
              n = function () {
                "show" !== t._hoverState &&
                  e.parentNode &&
                  e.parentNode.removeChild(e),
                  t._cleanTipClass(),
                  t.element.removeAttribute("aria-describedby"),
                  K.trigger(t.element, t.constructor.Event.HIDDEN),
                  t._popper.destroy();
              };
            if (
              !K.trigger(this.element, this.constructor.Event.HIDE)
                .defaultPrevented
            ) {
              var i;
              if (
                (e.classList.remove("show"),
                "ontouchstart" in document.documentElement)
              )
                (i = []).concat
                  .apply(i, document.body.children)
                  .forEach(function (t) {
                    return K.off(t, "mouseover", k);
                  });
              if (
                ((this._activeTrigger.click = !1),
                (this._activeTrigger.focus = !1),
                (this._activeTrigger.hover = !1),
                this.tip.classList.contains("fade"))
              ) {
                var r = v(e);
                K.one(e, "transitionend", n), _(e, r);
              } else n();
              this._hoverState = "";
            }
          }),
          (e.update = function () {
            null !== this._popper && this._popper.scheduleUpdate();
          }),
          (e.isWithContent = function () {
            return Boolean(this.getTitle());
          }),
          (e.getTipElement = function () {
            if (this.tip) return this.tip;
            var t = document.createElement("div");
            return (
              (t.innerHTML = this.config.template),
              (this.tip = t.children[0]),
              this.tip
            );
          }),
          (e.setContent = function () {
            var t = this.getTipElement();
            this.setElementContent(
              ot.findOne(".tooltip-inner", t),
              this.getTitle()
            ),
              t.classList.remove("fade", "show");
          }),
          (e.setElementContent = function (t, e) {
            if (null !== t)
              return "object" == typeof e && b(e)
                ? (e.jquery && (e = e[0]),
                  void (this.config.html
                    ? e.parentNode !== t &&
                      ((t.innerHTML = ""), t.appendChild(e))
                    : (t.textContent = e.textContent)))
                : void (this.config.html
                    ? (this.config.sanitize &&
                        (e = Nt(
                          e,
                          this.config.whiteList,
                          this.config.sanitizeFn
                        )),
                      (t.innerHTML = e))
                    : (t.textContent = e));
          }),
          (e.getTitle = function () {
            var t = this.element.getAttribute("data-original-title");
            return (
              t ||
                (t =
                  "function" == typeof this.config.title
                    ? this.config.title.call(this.element)
                    : this.config.title),
              t
            );
          }),
          (e._getPopperConfig = function (t) {
            var e = this;
            return c(
              c(
                {},
                {
                  placement: t,
                  modifiers: {
                    offset: this._getOffset(),
                    flip: { behavior: this.config.fallbackPlacement },
                    arrow: { element: "." + this.constructor.NAME + "-arrow" },
                    preventOverflow: {
                      boundariesElement: this.config.boundary,
                    },
                  },
                  onCreate: function (t) {
                    t.originalPlacement !== t.placement &&
                      e._handlePopperPlacementChange(t);
                  },
                  onUpdate: function (t) {
                    return e._handlePopperPlacementChange(t);
                  },
                }
              ),
              this.config.popperConfig
            );
          }),
          (e._addAttachmentClass = function (t) {
            this.getTipElement().classList.add("bs-tooltip-" + t);
          }),
          (e._getOffset = function () {
            var t = this,
              e = {};
            return (
              "function" == typeof this.config.offset
                ? (e.fn = function (e) {
                    return (
                      (e.offsets = c(
                        c({}, e.offsets),
                        t.config.offset(e.offsets, t.element) || {}
                      )),
                      e
                    );
                  })
                : (e.offset = this.config.offset),
              e
            );
          }),
          (e._getContainer = function () {
            return !1 === this.config.container
              ? document.body
              : b(this.config.container)
              ? this.config.container
              : ot.findOne(this.config.container);
          }),
          (e._getAttachment = function (t) {
            return Ht[t.toUpperCase()];
          }),
          (e._setListeners = function () {
            var t = this;
            this.config.trigger.split(" ").forEach(function (e) {
              if ("click" === e)
                K.on(
                  t.element,
                  t.constructor.Event.CLICK,
                  t.config.selector,
                  function (e) {
                    return t.toggle(e);
                  }
                );
              else if ("manual" !== e) {
                var n =
                    "hover" === e
                      ? t.constructor.Event.MOUSEENTER
                      : t.constructor.Event.FOCUSIN,
                  i =
                    "hover" === e
                      ? t.constructor.Event.MOUSELEAVE
                      : t.constructor.Event.FOCUSOUT;
                K.on(t.element, n, t.config.selector, function (e) {
                  return t._enter(e);
                }),
                  K.on(t.element, i, t.config.selector, function (e) {
                    return t._leave(e);
                  });
              }
            }),
              (this._hideModalHandler = function () {
                t.element && t.hide();
              }),
              K.on(
                this.element.closest(".modal"),
                "hide.bs.modal",
                this._hideModalHandler
              ),
              this.config.selector
                ? (this.config = c(
                    c({}, this.config),
                    {},
                    { trigger: "manual", selector: "" }
                  ))
                : this._fixTitle();
          }),
          (e._fixTitle = function () {
            var t = typeof this.element.getAttribute("data-original-title");
            (this.element.getAttribute("title") || "string" !== t) &&
              (this.element.setAttribute(
                "data-original-title",
                this.element.getAttribute("title") || ""
              ),
              this.element.setAttribute("title", ""));
          }),
          (e._enter = function (t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || C(t.target, n)) ||
              ((e = new this.constructor(t.target, this._getDelegateConfig())),
              L(t.target, n, e)),
              t &&
                (e._activeTrigger["focusin" === t.type ? "focus" : "hover"] =
                  !0),
              e.getTipElement().classList.contains("show") ||
              "show" === e._hoverState
                ? (e._hoverState = "show")
                : (clearTimeout(e._timeout),
                  (e._hoverState = "show"),
                  e.config.delay && e.config.delay.show
                    ? (e._timeout = setTimeout(function () {
                        "show" === e._hoverState && e.show();
                      }, e.config.delay.show))
                    : e.show());
          }),
          (e._leave = function (t, e) {
            var n = this.constructor.DATA_KEY;
            (e = e || C(t.target, n)) ||
              ((e = new this.constructor(t.target, this._getDelegateConfig())),
              L(t.target, n, e)),
              t &&
                (e._activeTrigger["focusout" === t.type ? "focus" : "hover"] =
                  !1),
              e._isWithActiveTrigger() ||
                (clearTimeout(e._timeout),
                (e._hoverState = "out"),
                e.config.delay && e.config.delay.hide
                  ? (e._timeout = setTimeout(function () {
                      "out" === e._hoverState && e.hide();
                    }, e.config.delay.hide))
                  : e.hide());
          }),
          (e._isWithActiveTrigger = function () {
            for (var t in this._activeTrigger)
              if (this._activeTrigger[t]) return !0;
            return !1;
          }),
          (e._getConfig = function (t) {
            var e = rt.getDataAttributes(this.element);
            return (
              Object.keys(e).forEach(function (t) {
                -1 !== jt.indexOf(t) && delete e[t];
              }),
              t &&
                "object" == typeof t.container &&
                t.container.jquery &&
                (t.container = t.container[0]),
              "number" ==
                typeof (t = c(
                  c(c({}, this.constructor.Default), e),
                  "object" == typeof t && t ? t : {}
                )).delay && (t.delay = { show: t.delay, hide: t.delay }),
              "number" == typeof t.title && (t.title = t.title.toString()),
              "number" == typeof t.content &&
                (t.content = t.content.toString()),
              w(Dt, t, this.constructor.DefaultType),
              t.sanitize &&
                (t.template = Nt(t.template, t.whiteList, t.sanitizeFn)),
              t
            );
          }),
          (e._getDelegateConfig = function () {
            var t = {};
            if (this.config)
              for (var e in this.config)
                this.constructor.Default[e] !== this.config[e] &&
                  (t[e] = this.config[e]);
            return t;
          }),
          (e._cleanTipClass = function () {
            var t = this.getTipElement(),
              e = t.getAttribute("class").match(qt);
            null !== e &&
              e.length > 0 &&
              e
                .map(function (t) {
                  return t.trim();
                })
                .forEach(function (e) {
                  return t.classList.remove(e);
                });
          }),
          (e._handlePopperPlacementChange = function (t) {
            var e = t.instance;
            (this.tip = e.popper),
              this._cleanTipClass(),
              this._addAttachmentClass(this._getAttachment(t.placement));
          }),
          (e._fixTransition = function () {
            var t = this.getTipElement(),
              e = this.config.animation;
            null === t.getAttribute("x-placement") &&
              (t.classList.remove("fade"),
              (this.config.animation = !1),
              this.hide(),
              this.show(),
              (this.config.animation = e));
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              var n = C(this, "bs.tooltip"),
                i = "object" == typeof e && e;
              if (
                (n || !/dispose|hide/.test(e)) &&
                (n || (n = new t(this, i)), "string" == typeof e)
              ) {
                if (void 0 === n[e])
                  throw new TypeError('No method named "' + e + '"');
                n[e]();
              }
            });
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.tooltip");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return Ut;
              },
            },
            {
              key: "NAME",
              get: function () {
                return Dt;
              },
            },
            {
              key: "DATA_KEY",
              get: function () {
                return "bs.tooltip";
              },
            },
            {
              key: "Event",
              get: function () {
                return Ft;
              },
            },
            {
              key: "EVENT_KEY",
              get: function () {
                return ".bs.tooltip";
              },
            },
            {
              key: "DefaultType",
              get: function () {
                return Bt;
              },
            },
          ]),
          t
        );
      })(),
      zt = T();
    if (zt) {
      var Yt = zt.fn[Dt];
      (zt.fn[Dt] = Wt.jQueryInterface),
        (zt.fn[Dt].Constructor = Wt),
        (zt.fn[Dt].noConflict = function () {
          return (zt.fn[Dt] = Yt), Wt.jQueryInterface;
        });
    }
    var Vt = "popover",
      Kt = new RegExp("(^|\\s)bs-popover\\S+", "g"),
      Qt = c(
        c({}, Wt.Default),
        {},
        {
          placement: "right",
          trigger: "click",
          content: "",
          template:
            '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
        }
      ),
      Gt = c(
        c({}, Wt.DefaultType),
        {},
        { content: "(string|element|function)" }
      ),
      Xt = {
        HIDE: "hide.bs.popover",
        HIDDEN: "hidden.bs.popover",
        SHOW: "show.bs.popover",
        SHOWN: "shown.bs.popover",
        INSERTED: "inserted.bs.popover",
        CLICK: "click.bs.popover",
        FOCUSIN: "focusin.bs.popover",
        FOCUSOUT: "focusout.bs.popover",
        MOUSEENTER: "mouseenter.bs.popover",
        MOUSELEAVE: "mouseleave.bs.popover",
      },
      Jt = (function (t) {
        var e, n;
        function i() {
          return t.apply(this, arguments) || this;
        }
        (n = t),
          ((e = i).prototype = Object.create(n.prototype)),
          (e.prototype.constructor = e),
          (e.__proto__ = n);
        var r = i.prototype;
        return (
          (r.isWithContent = function () {
            return this.getTitle() || this._getContent();
          }),
          (r.setContent = function () {
            var t = this.getTipElement();
            this.setElementContent(
              ot.findOne(".popover-header", t),
              this.getTitle()
            );
            var e = this._getContent();
            "function" == typeof e && (e = e.call(this.element)),
              this.setElementContent(ot.findOne(".popover-body", t), e),
              t.classList.remove("fade", "show");
          }),
          (r._addAttachmentClass = function (t) {
            this.getTipElement().classList.add("bs-popover-" + t);
          }),
          (r._getContent = function () {
            return (
              this.element.getAttribute("data-content") || this.config.content
            );
          }),
          (r._cleanTipClass = function () {
            var t = this.getTipElement(),
              e = t.getAttribute("class").match(Kt);
            null !== e &&
              e.length > 0 &&
              e
                .map(function (t) {
                  return t.trim();
                })
                .forEach(function (e) {
                  return t.classList.remove(e);
                });
          }),
          (i.jQueryInterface = function (t) {
            return this.each(function () {
              var e = C(this, "bs.popover"),
                n = "object" == typeof t ? t : null;
              if (
                (e || !/dispose|hide/.test(t)) &&
                (e || ((e = new i(this, n)), L(this, "bs.popover", e)),
                "string" == typeof t)
              ) {
                if (void 0 === e[t])
                  throw new TypeError('No method named "' + t + '"');
                e[t]();
              }
            });
          }),
          (i.getInstance = function (t) {
            return C(t, "bs.popover");
          }),
          o(i, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return Qt;
              },
            },
            {
              key: "NAME",
              get: function () {
                return Vt;
              },
            },
            {
              key: "DATA_KEY",
              get: function () {
                return "bs.popover";
              },
            },
            {
              key: "Event",
              get: function () {
                return Xt;
              },
            },
            {
              key: "EVENT_KEY",
              get: function () {
                return ".bs.popover";
              },
            },
            {
              key: "DefaultType",
              get: function () {
                return Gt;
              },
            },
          ]),
          i
        );
      })(Wt),
      Zt = T();
    if (Zt) {
      var te = Zt.fn[Vt];
      (Zt.fn[Vt] = Jt.jQueryInterface),
        (Zt.fn[Vt].Constructor = Jt),
        (Zt.fn[Vt].noConflict = function () {
          return (Zt.fn[Vt] = te), Jt.jQueryInterface;
        });
    }
    var ee = "scrollspy",
      ne = { offset: 10, method: "auto", target: "" },
      ie = { offset: "number", method: "string", target: "(string|element)" },
      re = (function () {
        function t(t, e) {
          var n = this;
          (this._element = t),
            (this._scrollElement = "BODY" === t.tagName ? window : t),
            (this._config = this._getConfig(e)),
            (this._selector =
              this._config.target +
              " .nav-link," +
              this._config.target +
              " .list-group-item," +
              this._config.target +
              " .dropdown-item"),
            (this._offsets = []),
            (this._targets = []),
            (this._activeTarget = null),
            (this._scrollHeight = 0),
            K.on(this._scrollElement, "scroll.bs.scrollspy", function (t) {
              return n._process(t);
            }),
            this.refresh(),
            this._process(),
            L(t, "bs.scrollspy", this);
        }
        var e = t.prototype;
        return (
          (e.refresh = function () {
            var t = this,
              e =
                this._scrollElement === this._scrollElement.window
                  ? "offset"
                  : "position",
              n = "auto" === this._config.method ? e : this._config.method,
              i = "position" === n ? this._getScrollTop() : 0;
            (this._offsets = []),
              (this._targets = []),
              (this._scrollHeight = this._getScrollHeight()),
              ot
                .find(this._selector)
                .map(function (t) {
                  var e,
                    r = m(t);
                  if ((r && (e = ot.findOne(r)), e)) {
                    var o = e.getBoundingClientRect();
                    if (o.width || o.height) return [rt[n](e).top + i, r];
                  }
                  return null;
                })
                .filter(function (t) {
                  return t;
                })
                .sort(function (t, e) {
                  return t[0] - e[0];
                })
                .forEach(function (e) {
                  t._offsets.push(e[0]), t._targets.push(e[1]);
                });
          }),
          (e.dispose = function () {
            x(this._element, "bs.scrollspy"),
              K.off(this._scrollElement, ".bs.scrollspy"),
              (this._element = null),
              (this._scrollElement = null),
              (this._config = null),
              (this._selector = null),
              (this._offsets = null),
              (this._targets = null),
              (this._activeTarget = null),
              (this._scrollHeight = null);
          }),
          (e._getConfig = function (t) {
            if (
              "string" !=
                typeof (t = c(c({}, ne), "object" == typeof t && t ? t : {}))
                  .target &&
              b(t.target)
            ) {
              var e = t.target.id;
              e || ((e = h(ee)), (t.target.id = e)), (t.target = "#" + e);
            }
            return w(ee, t, ie), t;
          }),
          (e._getScrollTop = function () {
            return this._scrollElement === window
              ? this._scrollElement.pageYOffset
              : this._scrollElement.scrollTop;
          }),
          (e._getScrollHeight = function () {
            return (
              this._scrollElement.scrollHeight ||
              Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight
              )
            );
          }),
          (e._getOffsetHeight = function () {
            return this._scrollElement === window
              ? window.innerHeight
              : this._scrollElement.getBoundingClientRect().height;
          }),
          (e._process = function () {
            var t = this._getScrollTop() + this._config.offset,
              e = this._getScrollHeight(),
              n = this._config.offset + e - this._getOffsetHeight();
            if ((this._scrollHeight !== e && this.refresh(), t >= n)) {
              var i = this._targets[this._targets.length - 1];
              this._activeTarget !== i && this._activate(i);
            } else {
              if (
                this._activeTarget &&
                t < this._offsets[0] &&
                this._offsets[0] > 0
              )
                return (this._activeTarget = null), void this._clear();
              for (var r = this._offsets.length; r--; ) {
                this._activeTarget !== this._targets[r] &&
                  t >= this._offsets[r] &&
                  (void 0 === this._offsets[r + 1] ||
                    t < this._offsets[r + 1]) &&
                  this._activate(this._targets[r]);
              }
            }
          }),
          (e._activate = function (t) {
            (this._activeTarget = t), this._clear();
            var e = this._selector.split(",").map(function (e) {
                return (
                  e + '[data-target="' + t + '"],' + e + '[href="' + t + '"]'
                );
              }),
              n = ot.findOne(e.join(","));
            n.classList.contains("dropdown-item")
              ? (ot
                  .findOne(".dropdown-toggle", n.closest(".dropdown"))
                  .classList.add("active"),
                n.classList.add("active"))
              : (n.classList.add("active"),
                ot.parents(n, ".nav, .list-group").forEach(function (t) {
                  ot
                    .prev(t, ".nav-link, .list-group-item")
                    .forEach(function (t) {
                      return t.classList.add("active");
                    }),
                    ot.prev(t, ".nav-item").forEach(function (t) {
                      ot.children(t, ".nav-link").forEach(function (t) {
                        return t.classList.add("active");
                      });
                    });
                })),
              K.trigger(this._scrollElement, "activate.bs.scrollspy", {
                relatedTarget: t,
              });
          }),
          (e._clear = function () {
            ot.find(this._selector)
              .filter(function (t) {
                return t.classList.contains("active");
              })
              .forEach(function (t) {
                return t.classList.remove("active");
              });
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              var n = C(this, "bs.scrollspy");
              if (
                (n || (n = new t(this, "object" == typeof e && e)),
                "string" == typeof e)
              ) {
                if (void 0 === n[e])
                  throw new TypeError('No method named "' + e + '"');
                n[e]();
              }
            });
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.scrollspy");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "Default",
              get: function () {
                return ne;
              },
            },
          ]),
          t
        );
      })();
    K.on(window, "load.bs.scrollspy.data-api", function () {
      ot.find('[data-spy="scroll"]').forEach(function (t) {
        return new re(t, rt.getDataAttributes(t));
      });
    });
    var oe = T();
    if (oe) {
      var ae = oe.fn[ee];
      (oe.fn[ee] = re.jQueryInterface),
        (oe.fn[ee].Constructor = re),
        (oe.fn[ee].noConflict = function () {
          return (oe.fn[ee] = ae), re.jQueryInterface;
        });
    }
    var se = (function () {
      function t(t) {
        (this._element = t), L(this._element, "bs.tab", this);
      }
      var e = t.prototype;
      return (
        (e.show = function () {
          var t = this;
          if (
            !(
              (this._element.parentNode &&
                this._element.parentNode.nodeType === Node.ELEMENT_NODE &&
                this._element.classList.contains("active")) ||
              this._element.classList.contains("disabled")
            )
          ) {
            var e,
              n = g(this._element),
              i = this._element.closest(".nav, .list-group");
            if (i) {
              var r =
                "UL" === i.nodeName || "OL" === i.nodeName
                  ? ":scope > li > .active"
                  : ".active";
              e = (e = ot.find(r, i))[e.length - 1];
            }
            var o = null;
            if (
              (e &&
                (o = K.trigger(e, "hide.bs.tab", {
                  relatedTarget: this._element,
                })),
              !(
                K.trigger(this._element, "show.bs.tab", { relatedTarget: e })
                  .defaultPrevented ||
                (null !== o && o.defaultPrevented)
              ))
            ) {
              this._activate(this._element, i);
              var a = function () {
                K.trigger(e, "hidden.bs.tab", { relatedTarget: t._element }),
                  K.trigger(t._element, "shown.bs.tab", { relatedTarget: e });
              };
              n ? this._activate(n, n.parentNode, a) : a();
            }
          }
        }),
        (e.dispose = function () {
          x(this._element, "bs.tab"), (this._element = null);
        }),
        (e._activate = function (t, e, n) {
          var i = this,
            r = (
              !e || ("UL" !== e.nodeName && "OL" !== e.nodeName)
                ? ot.children(e, ".active")
                : ot.find(":scope > li > .active", e)
            )[0],
            o = n && r && r.classList.contains("fade"),
            a = function () {
              return i._transitionComplete(t, r, n);
            };
          if (r && o) {
            var s = v(r);
            r.classList.remove("show"), K.one(r, "transitionend", a), _(r, s);
          } else a();
        }),
        (e._transitionComplete = function (t, e, n) {
          if (e) {
            e.classList.remove("active");
            var i = ot.findOne(":scope > .dropdown-menu .active", e.parentNode);
            i && i.classList.remove("active"),
              "tab" === e.getAttribute("role") &&
                e.setAttribute("aria-selected", !1);
          }
          (t.classList.add("active"),
          "tab" === t.getAttribute("role") &&
            t.setAttribute("aria-selected", !0),
          S(t),
          t.classList.contains("fade") && t.classList.add("show"),
          t.parentNode && t.parentNode.classList.contains("dropdown-menu")) &&
            (t.closest(".dropdown") &&
              ot.find(".dropdown-toggle").forEach(function (t) {
                return t.classList.add("active");
              }),
            t.setAttribute("aria-expanded", !0));
          n && n();
        }),
        (t.jQueryInterface = function (e) {
          return this.each(function () {
            var n = C(this, "bs.tab") || new t(this);
            if ("string" == typeof e) {
              if (void 0 === n[e])
                throw new TypeError('No method named "' + e + '"');
              n[e]();
            }
          });
        }),
        (t.getInstance = function (t) {
          return C(t, "bs.tab");
        }),
        o(t, null, [
          {
            key: "VERSION",
            get: function () {
              return "5.0.0-alpha1";
            },
          },
        ]),
        t
      );
    })();
    K.on(
      document,
      "click.bs.tab.data-api",
      '[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]',
      function (t) {
        t.preventDefault(), (C(this, "bs.tab") || new se(this)).show();
      }
    );
    var ce = T();
    if (ce) {
      var le = ce.fn.tab;
      (ce.fn.tab = se.jQueryInterface),
        (ce.fn.tab.Constructor = se),
        (ce.fn.tab.noConflict = function () {
          return (ce.fn.tab = le), se.jQueryInterface;
        });
    }
    var ue = { animation: "boolean", autohide: "boolean", delay: "number" },
      de = { animation: !0, autohide: !0, delay: 500 },
      fe = (function () {
        function t(t, e) {
          (this._element = t),
            (this._config = this._getConfig(e)),
            (this._timeout = null),
            this._setListeners(),
            L(t, "bs.toast", this);
        }
        var e = t.prototype;
        return (
          (e.show = function () {
            var t = this;
            if (!K.trigger(this._element, "show.bs.toast").defaultPrevented) {
              this._config.animation && this._element.classList.add("fade");
              var e = function () {
                t._element.classList.remove("showing"),
                  t._element.classList.add("show"),
                  K.trigger(t._element, "shown.bs.toast"),
                  t._config.autohide &&
                    (t._timeout = setTimeout(function () {
                      t.hide();
                    }, t._config.delay));
              };
              if (
                (this._element.classList.remove("hide"),
                S(this._element),
                this._element.classList.add("showing"),
                this._config.animation)
              ) {
                var n = v(this._element);
                K.one(this._element, "transitionend", e), _(this._element, n);
              } else e();
            }
          }),
          (e.hide = function () {
            var t = this;
            if (
              this._element.classList.contains("show") &&
              !K.trigger(this._element, "hide.bs.toast").defaultPrevented
            ) {
              var e = function () {
                t._element.classList.add("hide"),
                  K.trigger(t._element, "hidden.bs.toast");
              };
              if (
                (this._element.classList.remove("show"), this._config.animation)
              ) {
                var n = v(this._element);
                K.one(this._element, "transitionend", e), _(this._element, n);
              } else e();
            }
          }),
          (e.dispose = function () {
            clearTimeout(this._timeout),
              (this._timeout = null),
              this._element.classList.contains("show") &&
                this._element.classList.remove("show"),
              K.off(this._element, "click.dismiss.bs.toast"),
              x(this._element, "bs.toast"),
              (this._element = null),
              (this._config = null);
          }),
          (e._getConfig = function (t) {
            return (
              (t = c(
                c(c({}, de), rt.getDataAttributes(this._element)),
                "object" == typeof t && t ? t : {}
              )),
              w("toast", t, this.constructor.DefaultType),
              t
            );
          }),
          (e._setListeners = function () {
            var t = this;
            K.on(
              this._element,
              "click.dismiss.bs.toast",
              '[data-dismiss="toast"]',
              function () {
                return t.hide();
              }
            );
          }),
          (t.jQueryInterface = function (e) {
            return this.each(function () {
              var n = C(this, "bs.toast");
              if (
                (n || (n = new t(this, "object" == typeof e && e)),
                "string" == typeof e)
              ) {
                if (void 0 === n[e])
                  throw new TypeError('No method named "' + e + '"');
                n[e](this);
              }
            });
          }),
          (t.getInstance = function (t) {
            return C(t, "bs.toast");
          }),
          o(t, null, [
            {
              key: "VERSION",
              get: function () {
                return "5.0.0-alpha1";
              },
            },
            {
              key: "DefaultType",
              get: function () {
                return ue;
              },
            },
            {
              key: "Default",
              get: function () {
                return de;
              },
            },
          ]),
          t
        );
      })(),
      he = T();
    if (he) {
      var pe = he.fn.toast;
      (he.fn.toast = fe.jQueryInterface),
        (he.fn.toast.Constructor = fe),
        (he.fn.toast.noConflict = function () {
          return (he.fn.toast = pe), fe.jQueryInterface;
        });
    }
  },
  function (t, e, n) {
    t.exports = n(22);
  },
  function (t, e) {
    function n() {
      var t = document.getElementById("as-new-duration-day");
      (this._$duration = t && parseFloat(t.value)),
        this._$tagContainer,
        this._$newTag,
        this._$tags,
        this._$tmpTag,
        this._maxNum;
    }
    (n.prototype = {
      _init: function (t) {
        t &&
          this._$duration > 0 &&
          ((this._$tagContainer = t),
          (this._$newTag = t.querySelector(".as-product-new-tag")),
          (this._$tags = t.querySelectorAll(".as-product-tag")),
          (this._$tmpTag = this._$tags && this._$tags[0]),
          (this._maxNum = parseInt(t.dataset.limit) || 2),
          this._processTag(
            (this._$newTag && this._$newTag.dataset.publishedTime) || ""
          ));
      },
      _processTag: function (t) {
        if (t) {
          var e = new Date().getTime(),
            n = new Date(t).getTime(),
            i = 24 * this._$duration * 60 * 60 * 1e3;
          e - n > 0 && e - n <= i
            ? this._$newTag && this._$newTag.classList.add("show")
            : this._$newTag && this._$newTag.remove();
        } else this._$newTag && this._$newTag.remove();
        if (this._$tags && this._$tags.length > 0)
          for (var r = 0, o = this._$tags.length; r < o; r++)
            r < this._maxNum
              ? this._$tags[r].classList.add("show")
              : this._$tags[r].remove();
        var a = this._$tagContainer.querySelectorAll(".as-product-tag");
        a &&
          0 === a.length &&
          (this._$tmpTag && (this._$tmpTag.innerHTML = ""),
          this._$tmpTag && this._$tagContainer.appendChild(this._$tmpTag));
      },
    }),
      (t.exports = n);
    for (
      var i = document.querySelectorAll(".as-product-tag-container"), r = 0;
      r < i.length;
      r++
    )
      new n()._init(i[r]);
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t, e) {
      return function () {
        for (var n = new Array(arguments.length), i = 0; i < n.length; i++)
          n[i] = arguments[i];
        return t.apply(e, n);
      };
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    function r(t) {
      return encodeURIComponent(t)
        .replace(/%3A/gi, ":")
        .replace(/%24/g, "$")
        .replace(/%2C/gi, ",")
        .replace(/%20/g, "+")
        .replace(/%5B/gi, "[")
        .replace(/%5D/gi, "]");
    }
    t.exports = function (t, e, n) {
      if (!e) return t;
      var o;
      if (n) o = n(e);
      else if (i.isURLSearchParams(e)) o = e.toString();
      else {
        var a = [];
        i.forEach(e, function (t, e) {
          null != t &&
            (i.isArray(t) ? (e += "[]") : (t = [t]),
            i.forEach(t, function (t) {
              i.isDate(t)
                ? (t = t.toISOString())
                : i.isObject(t) && (t = JSON.stringify(t)),
                a.push(r(e) + "=" + r(t));
            }));
        }),
          (o = a.join("&"));
      }
      if (o) {
        var s = t.indexOf("#");
        -1 !== s && (t = t.slice(0, s)),
          (t += (-1 === t.indexOf("?") ? "?" : "&") + o);
      }
      return t;
    };
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return !(!t || !t.__CANCEL__);
    };
  },
  function (t, e, n) {
    "use strict";
    (function (e) {
      var i = n(0),
        r = n(28),
        o = { "Content-Type": "application/x-www-form-urlencoded" };
      function a(t, e) {
        !i.isUndefined(t) &&
          i.isUndefined(t["Content-Type"]) &&
          (t["Content-Type"] = e);
      }
      var s,
        c = {
          adapter:
            (("undefined" != typeof XMLHttpRequest ||
              (void 0 !== e &&
                "[object process]" === Object.prototype.toString.call(e))) &&
              (s = n(12)),
            s),
          transformRequest: [
            function (t, e) {
              return (
                r(e, "Accept"),
                r(e, "Content-Type"),
                i.isFormData(t) ||
                i.isArrayBuffer(t) ||
                i.isBuffer(t) ||
                i.isStream(t) ||
                i.isFile(t) ||
                i.isBlob(t)
                  ? t
                  : i.isArrayBufferView(t)
                  ? t.buffer
                  : i.isURLSearchParams(t)
                  ? (a(e, "application/x-www-form-urlencoded;charset=utf-8"),
                    t.toString())
                  : i.isObject(t)
                  ? (a(e, "application/json;charset=utf-8"), JSON.stringify(t))
                  : t
              );
            },
          ],
          transformResponse: [
            function (t) {
              if ("string" == typeof t)
                try {
                  t = JSON.parse(t);
                } catch (t) {}
              return t;
            },
          ],
          timeout: 0,
          xsrfCookieName: "XSRF-TOKEN",
          xsrfHeaderName: "X-XSRF-TOKEN",
          maxContentLength: -1,
          maxBodyLength: -1,
          validateStatus: function (t) {
            return t >= 200 && t < 300;
          },
        };
      (c.headers = { common: { Accept: "application/json, text/plain, */*" } }),
        i.forEach(["delete", "get", "head"], function (t) {
          c.headers[t] = {};
        }),
        i.forEach(["post", "put", "patch"], function (t) {
          c.headers[t] = i.merge(o);
        }),
        (t.exports = c);
    }).call(this, n(27));
  },
  function (t, e, n) {
    "use strict";
    var i = n(0),
      r = n(29),
      o = n(31),
      a = n(9),
      s = n(32),
      c = n(35),
      l = n(36),
      u = n(13);
    t.exports = function (t) {
      return new Promise(function (e, n) {
        var d = t.data,
          f = t.headers;
        i.isFormData(d) && delete f["Content-Type"],
          (i.isBlob(d) || i.isFile(d)) && d.type && delete f["Content-Type"];
        var h = new XMLHttpRequest();
        if (t.auth) {
          var p = t.auth.username || "",
            m = unescape(encodeURIComponent(t.auth.password)) || "";
          f.Authorization = "Basic " + btoa(p + ":" + m);
        }
        var g = s(t.baseURL, t.url);
        if (
          (h.open(
            t.method.toUpperCase(),
            a(g, t.params, t.paramsSerializer),
            !0
          ),
          (h.timeout = t.timeout),
          (h.onreadystatechange = function () {
            if (
              h &&
              4 === h.readyState &&
              (0 !== h.status ||
                (h.responseURL && 0 === h.responseURL.indexOf("file:")))
            ) {
              var i =
                  "getAllResponseHeaders" in h
                    ? c(h.getAllResponseHeaders())
                    : null,
                o = {
                  data:
                    t.responseType && "text" !== t.responseType
                      ? h.response
                      : h.responseText,
                  status: h.status,
                  statusText: h.statusText,
                  headers: i,
                  config: t,
                  request: h,
                };
              r(e, n, o), (h = null);
            }
          }),
          (h.onabort = function () {
            h && (n(u("Request aborted", t, "ECONNABORTED", h)), (h = null));
          }),
          (h.onerror = function () {
            n(u("Network Error", t, null, h)), (h = null);
          }),
          (h.ontimeout = function () {
            var e = "timeout of " + t.timeout + "ms exceeded";
            t.timeoutErrorMessage && (e = t.timeoutErrorMessage),
              n(u(e, t, "ECONNABORTED", h)),
              (h = null);
          }),
          i.isStandardBrowserEnv())
        ) {
          var v =
            (t.withCredentials || l(g)) && t.xsrfCookieName
              ? o.read(t.xsrfCookieName)
              : void 0;
          v && (f[t.xsrfHeaderName] = v);
        }
        if (
          ("setRequestHeader" in h &&
            i.forEach(f, function (t, e) {
              void 0 === d && "content-type" === e.toLowerCase()
                ? delete f[e]
                : h.setRequestHeader(e, t);
            }),
          i.isUndefined(t.withCredentials) ||
            (h.withCredentials = !!t.withCredentials),
          t.responseType)
        )
          try {
            h.responseType = t.responseType;
          } catch (e) {
            if ("json" !== t.responseType) throw e;
          }
        "function" == typeof t.onDownloadProgress &&
          h.addEventListener("progress", t.onDownloadProgress),
          "function" == typeof t.onUploadProgress &&
            h.upload &&
            h.upload.addEventListener("progress", t.onUploadProgress),
          t.cancelToken &&
            t.cancelToken.promise.then(function (t) {
              h && (h.abort(), n(t), (h = null));
            }),
          d || (d = null),
          h.send(d);
      });
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(30);
    t.exports = function (t, e, n, r, o) {
      var a = new Error(t);
      return i(a, e, n, r, o);
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    t.exports = function (t, e) {
      e = e || {};
      var n = {},
        r = ["url", "method", "data"],
        o = ["headers", "auth", "proxy", "params"],
        a = [
          "baseURL",
          "transformRequest",
          "transformResponse",
          "paramsSerializer",
          "timeout",
          "timeoutMessage",
          "withCredentials",
          "adapter",
          "responseType",
          "xsrfCookieName",
          "xsrfHeaderName",
          "onUploadProgress",
          "onDownloadProgress",
          "decompress",
          "maxContentLength",
          "maxBodyLength",
          "maxRedirects",
          "transport",
          "httpAgent",
          "httpsAgent",
          "cancelToken",
          "socketPath",
          "responseEncoding",
        ],
        s = ["validateStatus"];
      function c(t, e) {
        return i.isPlainObject(t) && i.isPlainObject(e)
          ? i.merge(t, e)
          : i.isPlainObject(e)
          ? i.merge({}, e)
          : i.isArray(e)
          ? e.slice()
          : e;
      }
      function l(r) {
        i.isUndefined(e[r])
          ? i.isUndefined(t[r]) || (n[r] = c(void 0, t[r]))
          : (n[r] = c(t[r], e[r]));
      }
      i.forEach(r, function (t) {
        i.isUndefined(e[t]) || (n[t] = c(void 0, e[t]));
      }),
        i.forEach(o, l),
        i.forEach(a, function (r) {
          i.isUndefined(e[r])
            ? i.isUndefined(t[r]) || (n[r] = c(void 0, t[r]))
            : (n[r] = c(void 0, e[r]));
        }),
        i.forEach(s, function (i) {
          i in e ? (n[i] = c(t[i], e[i])) : i in t && (n[i] = c(void 0, t[i]));
        });
      var u = r.concat(o).concat(a).concat(s),
        d = Object.keys(t)
          .concat(Object.keys(e))
          .filter(function (t) {
            return -1 === u.indexOf(t);
          });
      return i.forEach(d, l), n;
    };
  },
  function (t, e, n) {
    "use strict";
    function i(t) {
      this.message = t;
    }
    (i.prototype.toString = function () {
      return "Cancel" + (this.message ? ": " + this.message : "");
    }),
      (i.prototype.__CANCEL__ = !0),
      (t.exports = i);
  },
  function (t, e, n) {
    var i = n(1),
      r = n(2);
    t.exports = {
      getOnlyCookie: function () {
        return (
          "true" === i.get(window.COOKIE_ONLY_NAME) ||
          (void 0 === i.get(window.COOKIE_ONLY_NAME) &&
            !0 === window.cookie_only)
        );
      },
      handleHoganRending: function (t, e) {
        var n = document.querySelector("#tpl-".concat(t));
        if (!n) return !1;
        var i = r.compile(n.innerHTML, { delimiters: "@{ }@" }),
          o = document.querySelector(".as-".concat(t));
        o && (o.innerHTML = i.render(e));
      },
    };
  },
  function (t, e, n) {
    "use strict";
    n.r(e),
      n.d(e, "formatMoney", function () {
        return i;
      });
    function i(t, e) {
      "string" == typeof t && (t = t.replace(".", ""));
      let n = "";
      const i = /\{\{\s*(\w+)\s*\}\}/,
        r = e || "${{amount}}";
      function o(t, e = 2, n = ",", i = ".") {
        if (isNaN(t) || null == t) return 0;
        const r = (t = (t / 100).toFixed(e)).split(".");
        return (
          r[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + n) +
          (r[1] ? i + r[1] : "")
        );
      }
      switch (r.match(i)[1]) {
        case "amount":
          n = o(t, 2);
          break;
        case "amount_no_decimals":
          n = o(t, 0);
          break;
        case "amount_with_comma_separator":
          n = o(t, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          n = o(t, 0, ".", ",");
      }
      return r.replace(i, n);
    }
  },
  function (t, e) {
    function n(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var i = (function () {
      function t(e) {
        var n;
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.$parent = e),
          this.$parent &&
            ((this.$input = this.$parent.querySelectorAll(".as-address-input")),
            (this.len =
              null === (n = this.$input) || void 0 === n ? void 0 : n.length),
            (this.FORMAT = "format"),
            (this.EMPTY = "empty"),
            this.init());
      }
      var e, i, r;
      return (
        (e = t),
        (i = [
          {
            key: "init",
            value: function () {
              this.handleSubmit();
            },
          },
          {
            key: "handleSubmit",
            value: function () {
              var t = this;
              this.$parent.onsubmit = function (e) {
                (e = e || window.event), t.handleBlur();
                for (var n = 0; n < t.len; n++)
                  t.validateForm(t.$input[n]) ||
                    (e.stopPropagation(), e.preventDefault());
              };
            },
          },
          {
            key: "handleBlur",
            value: function () {
              for (
                var t = this,
                  e = function (e) {
                    var n = t.$input[e];
                    n &&
                      n.addEventListener("blur", function () {
                        t.validateForm(n);
                      });
                  },
                  n = 0;
                n < this.len;
                n++
              )
                e(n);
            },
          },
          {
            key: "handleFormErrorTips",
            value: function (t, e) {
              var n = t.parentNode.querySelector(".as-error-tips");
              e && n
                ? n.dataset && (n.innerHTML = n.dataset[e])
                : (n.innerHTML = "");
            },
          },
          {
            key: "validateForm",
            value: function (t) {
              var e = t.value,
                n = t.required,
                i = t.pattern,
                r = (i && new RegExp(i)) || void 0;
              return "string" != typeof e
                ? (this.handleFormErrorTips(t, this.FORMAT), !1)
                : 0 == e.length && n
                ? (this.handleFormErrorTips(t, this.EMPTY), !1)
                : r && !r.test(e)
                ? (this.handleFormErrorTips(t, this.FORMAT), !1)
                : (this.handleFormErrorTips(t), !0);
            },
          },
        ]) && n(e.prototype, i),
        r && n(e, r),
        t
      );
    })();
    t.exports = i;
  },
  function (t, e, n) {
    "use strict";
    n.r(e),
      n.d(e, "tns", function () {
        return q;
      });
    var i = window,
      r =
        i.requestAnimationFrame ||
        i.webkitRequestAnimationFrame ||
        i.mozRequestAnimationFrame ||
        i.msRequestAnimationFrame ||
        function (t) {
          return setTimeout(t, 16);
        },
      o = window,
      a =
        o.cancelAnimationFrame ||
        o.mozCancelAnimationFrame ||
        function (t) {
          clearTimeout(t);
        };
    function s() {
      for (
        var t, e, n, i = arguments[0] || {}, r = 1, o = arguments.length;
        r < o;
        r++
      )
        if (null !== (t = arguments[r]))
          for (e in t) i !== (n = t[e]) && void 0 !== n && (i[e] = n);
      return i;
    }
    function c(t) {
      return ["true", "false"].indexOf(t) >= 0 ? JSON.parse(t) : t;
    }
    function l(t, e, n, i) {
      if (i)
        try {
          t.setItem(e, n);
        } catch (t) {}
      return n;
    }
    function u() {
      var t = document,
        e = t.body;
      return e || ((e = t.createElement("body")).fake = !0), e;
    }
    var d = document.documentElement;
    function f(t) {
      var e = "";
      return (
        t.fake &&
          ((e = d.style.overflow),
          (t.style.background = ""),
          (t.style.overflow = d.style.overflow = "hidden"),
          d.appendChild(t)),
        e
      );
    }
    function h(t, e) {
      t.fake && (t.remove(), (d.style.overflow = e), d.offsetHeight);
    }
    function p(t, e, n, i) {
      "insertRule" in t
        ? t.insertRule(e + "{" + n + "}", i)
        : t.addRule(e, n, i);
    }
    function m(t) {
      return ("insertRule" in t ? t.cssRules : t.rules).length;
    }
    function g(t, e, n) {
      for (var i = 0, r = t.length; i < r; i++) e.call(n, t[i], i);
    }
    var v = "classList" in document.createElement("_"),
      y = v
        ? function (t, e) {
            return t.classList.contains(e);
          }
        : function (t, e) {
            return t.className.indexOf(e) >= 0;
          },
      b = v
        ? function (t, e) {
            y(t, e) || t.classList.add(e);
          }
        : function (t, e) {
            y(t, e) || (t.className += " " + e);
          },
      _ = v
        ? function (t, e) {
            y(t, e) && t.classList.remove(e);
          }
        : function (t, e) {
            y(t, e) && (t.className = t.className.replace(e, ""));
          };
    function w(t, e) {
      return t.hasAttribute(e);
    }
    function E(t, e) {
      return t.getAttribute(e);
    }
    function k(t) {
      return t && (void 0 !== t.item);
    }
    function S(t, e) {
      if (
        ((t = k(t) || t instanceof Array ? t : [t]),
        "[object Object]" === Object.prototype.toString.call(e))
      )
        for (var n = t.length; n--; )
          for (var i in e) t[n].setAttribute(i, e[i]);
    }
    function T(t, e) {
      t = k(t) || t instanceof Array ? t : [t];
      for (
        var n = (e = e instanceof Array ? e : [e]).length, i = t.length;
        i--;

      )
        for (var r = n; r--; ) t[i].removeAttribute(e[r]);
    }
    function A(t) {
      for (var e = [], n = 0, i = t.length; n < i; n++) e.push(t[n]);
      return e;
    }
    function L(t, e) {
      "none" !== t.style.display && (t.style.display = "none");
    }
    function C(t, e) {
      "none" === t.style.display && (t.style.display = "");
    }
    function x(t) {
      return "none" !== window.getComputedStyle(t).display;
    }
    function O(t) {
      if ("string" == typeof t) {
        var e = [t],
          n = t.charAt(0).toUpperCase() + t.substr(1);
        ["Webkit", "Moz", "ms", "O"].forEach(function (i) {
          ("ms" === i && "transform" !== t) || e.push(i + n);
        }),
          (t = e);
      }
      for (
        var i = document.createElement("fakeelement"), r = (t.length, 0);
        r < t.length;
        r++
      ) {
        var o = t[r];
        if (void 0 !== i.style[o]) return o;
      }
      return !1;
    }
    function $(t, e) {
      var n = !1;
      return (
        /^Webkit/.test(t)
          ? (n = "webkit" + e + "End")
          : /^O/.test(t)
          ? (n = "o" + e + "End")
          : t && (n = e.toLowerCase() + "end"),
        n
      );
    }
    var P = !1;
    try {
      var I = Object.defineProperty({}, "passive", {
        get: function () {
          P = !0;
        },
      });
      window.addEventListener("test", null, I);
    } catch (t) {}
    var R = !!P && { passive: !0 };
    function M(t, e, n) {
      for (var i in e) {
        var r = ["touchstart", "touchmove"].indexOf(i) >= 0 && !n && R;
        t.addEventListener(i, e[i], r);
      }
    }
    function N(t, e) {
      for (var n in e) {
        var i = ["touchstart", "touchmove"].indexOf(n) >= 0 && R;
        t.removeEventListener(n, e[n], i);
      }
    }
    function D() {
      return {
        topics: {},
        on: function (t, e) {
          (this.topics[t] = this.topics[t] || []), this.topics[t].push(e);
        },
        off: function (t, e) {
          if (this.topics[t])
            for (var n = 0; n < this.topics[t].length; n++)
              if (this.topics[t][n] === e) {
                this.topics[t].splice(n, 1);
                break;
              }
        },
        emit: function (t, e) {
          (e.type = t),
            this.topics[t] &&
              this.topics[t].forEach(function (n) {
                n(e, t);
              });
        },
      };
    }
    Object.keys ||
      (Object.keys = function (t) {
        var e = [];
        for (var n in t)
          Object.prototype.hasOwnProperty.call(t, n) && e.push(n);
        return e;
      }),
      "remove" in Element.prototype ||
        (Element.prototype.remove = function () {
          this.parentNode && this.parentNode.removeChild(this);
        });
    var q = function (t) {
      t = s(
        {
          container: ".slider",
          mode: "carousel",
          axis: "horizontal",
          items: 1,
          gutter: 0,
          edgePadding: 0,
          fixedWidth: !1,
          autoWidth: !1,
          viewportMax: !1,
          slideBy: 1,
          center: !1,
          controls: !0,
          controlsPosition: "top",
          controlsText: ["prev", "next"],
          controlsContainer: !1,
          prevButton: !1,
          nextButton: !1,
          nav: !0,
          navPosition: "top",
          navContainer: !1,
          navAsThumbnails: !1,
          arrowKeys: !1,
          speed: 300,
          autoplay: !1,
          autoplayPosition: "top",
          autoplayTimeout: 5e3,
          autoplayDirection: "forward",
          autoplayText: ["start", "stop"],
          autoplayHoverPause: !1,
          autoplayButton: !1,
          autoplayButtonOutput: !0,
          autoplayResetOnVisibility: !0,
          animateIn: "tns-fadeIn",
          animateOut: "tns-fadeOut",
          animateNormal: "tns-normal",
          animateDelay: !1,
          loop: !0,
          rewind: !1,
          autoHeight: !1,
          responsive: !1,
          lazyload: !1,
          lazyloadSelector: ".tns-lazy-img",
          touch: !0,
          mouseDrag: !1,
          swipeAngle: 15,
          nested: !1,
          preventActionWhenRunning: !1,
          preventScrollOnTouch: !1,
          freezable: !0,
          onInit: !1,
          useLocalStorage: !0,
          nonce: !1,
        },
        t || {}
      );
      var e = document,
        n = window,
        i = { ENTER: 13, SPACE: 32, LEFT: 37, RIGHT: 39 },
        o = {},
        d = t.useLocalStorage;
      if (d) {
        var v = navigator.userAgent,
          k = new Date();
        try {
          (o = n.localStorage)
            ? (o.setItem(k, k), (d = o.getItem(k) == k), o.removeItem(k))
            : (d = !1),
            d || (o = {});
        } catch (t) {
          d = !1;
        }
        d &&
          (o.tnsApp &&
            o.tnsApp !== v &&
            [
              "tC",
              "tPL",
              "tMQ",
              "tTf",
              "t3D",
              "tTDu",
              "tTDe",
              "tADu",
              "tADe",
              "tTE",
              "tAE",
            ].forEach(function (t) {
              o.removeItem(t);
            }),
          (localStorage.tnsApp = v));
      }
      var P = o.tC
          ? c(o.tC)
          : l(
              o,
              "tC",
              (function () {
                var t = document,
                  e = u(),
                  n = f(e),
                  i = t.createElement("div"),
                  r = !1;
                e.appendChild(i);
                try {
                  for (
                    var o,
                      a = "(10px * 10)",
                      s = ["calc" + a, "-moz-calc" + a, "-webkit-calc" + a],
                      c = 0;
                    c < 3;
                    c++
                  )
                    if (
                      ((o = s[c]), (i.style.width = o), 100 === i.offsetWidth)
                    ) {
                      r = o.replace(a, "");
                      break;
                    }
                } catch (t) {}
                return e.fake ? h(e, n) : i.remove(), r;
              })(),
              d
            ),
        I = o.tPL
          ? c(o.tPL)
          : l(
              o,
              "tPL",
              (function () {
                var t,
                  e = document,
                  n = u(),
                  i = f(n),
                  r = e.createElement("div"),
                  o = e.createElement("div"),
                  a = "";
                (r.className = "tns-t-subp2"), (o.className = "tns-t-ct");
                for (var s = 0; s < 70; s++) a += "<div></div>";
                return (
                  (o.innerHTML = a),
                  r.appendChild(o),
                  n.appendChild(r),
                  (t =
                    Math.abs(
                      r.getBoundingClientRect().left -
                        o.children[67].getBoundingClientRect().left
                    ) < 2),
                  n.fake ? h(n, i) : r.remove(),
                  t
                );
              })(),
              d
            ),
        R = o.tMQ
          ? c(o.tMQ)
          : l(
              o,
              "tMQ",
              (function () {
                if (window.matchMedia || window.msMatchMedia) return !0;
                var t,
                  e = document,
                  n = u(),
                  i = f(n),
                  r = e.createElement("div"),
                  o = e.createElement("style"),
                  a =
                    "@media all and (min-width:1px){.tns-mq-test{position:absolute}}";
                return (
                  (o.type = "text/css"),
                  (r.className = "tns-mq-test"),
                  n.appendChild(o),
                  n.appendChild(r),
                  o.styleSheet
                    ? (o.styleSheet.cssText = a)
                    : o.appendChild(e.createTextNode(a)),
                  (t = window.getComputedStyle
                    ? window.getComputedStyle(r).position
                    : r.currentStyle.position),
                  n.fake ? h(n, i) : r.remove(),
                  "absolute" === t
                );
              })(),
              d
            ),
        j = o.tTf ? c(o.tTf) : l(o, "tTf", O("transform"), d),
        B = o.t3D
          ? c(o.t3D)
          : l(
              o,
              "t3D",
              (function (t) {
                if (!t) return !1;
                if (!window.getComputedStyle) return !1;
                var e,
                  n = document,
                  i = u(),
                  r = f(i),
                  o = n.createElement("p"),
                  a =
                    t.length > 9
                      ? "-" + t.slice(0, -9).toLowerCase() + "-"
                      : "";
                return (
                  (a += "transform"),
                  i.insertBefore(o, null),
                  (o.style[t] = "translate3d(1px,1px,1px)"),
                  (e = window.getComputedStyle(o).getPropertyValue(a)),
                  i.fake ? h(i, r) : o.remove(),
                  void 0 !== e && e.length > 0 && "none" !== e
                );
              })(j),
              d
            ),
        H = o.tTDu ? c(o.tTDu) : l(o, "tTDu", O("transitionDuration"), d),
        U = o.tTDe ? c(o.tTDe) : l(o, "tTDe", O("transitionDelay"), d),
        F = o.tADu ? c(o.tADu) : l(o, "tADu", O("animationDuration"), d),
        W = o.tADe ? c(o.tADe) : l(o, "tADe", O("animationDelay"), d),
        z = o.tTE ? c(o.tTE) : l(o, "tTE", $(H, "Transition"), d),
        Y = o.tAE ? c(o.tAE) : l(o, "tAE", $(F, "Animation"), d),
        V = n.console && "function" == typeof n.console.warn,
        K = [
          "container",
          "controlsContainer",
          "prevButton",
          "nextButton",
          "navContainer",
          "autoplayButton",
        ],
        Q = {};
      if (
        (K.forEach(function (n) {
          if ("string" == typeof t[n]) {
            var i = t[n],
              r = e.querySelector(i);
            if (((Q[n] = i), !r || !r.nodeName))
              return void (V && console.warn("Can't find", t[n]));
            t[n] = r;
          }
        }),
        !(t.container.children.length < 1))
      ) {
        var G = t.responsive,
          X = t.nested,
          J = "carousel" === t.mode;
        if (G) {
          0 in G && ((t = s(t, G[0])), delete G[0]);
          var Z = {};
          for (var tt in G) {
            var et = G[tt];
            (et = "number" == typeof et ? { items: et } : et), (Z[tt] = et);
          }
          (G = Z), (Z = null);
        }
        if (
          (J ||
            (function t(e) {
              for (var n in e)
                J ||
                  ("slideBy" === n && (e[n] = "page"),
                  "edgePadding" === n && (e[n] = !1),
                  "autoHeight" === n && (e[n] = !1)),
                  "responsive" === n && t(e[n]);
            })(t),
          !J)
        ) {
          (t.axis = "horizontal"), (t.slideBy = "page"), (t.edgePadding = !1);
          var nt = t.animateIn,
            it = t.animateOut,
            rt = t.animateDelay,
            ot = t.animateNormal;
        }
        var at,
          st,
          ct = "horizontal" === t.axis,
          lt = e.createElement("div"),
          ut = e.createElement("div"),
          dt = t.container,
          ft = dt.parentNode,
          ht = dt.outerHTML,
          pt = dt.children,
          mt = pt.length,
          gt = Pn(),
          vt = !1;
        G && Jn(), J && (dt.className += " tns-vpfix");
        var yt,
          bt,
          _t,
          wt,
          Et,
          kt,
          St,
          Tt,
          At,
          Lt = t.autoWidth,
          Ct = Nn("fixedWidth"),
          xt = Nn("edgePadding"),
          Ot = Nn("gutter"),
          $t = Rn(),
          Pt = Nn("center"),
          It = Lt ? 1 : Math.floor(Nn("items")),
          Rt = Nn("slideBy"),
          Mt = t.viewportMax || t.fixedWidthViewportWidth,
          Nt = Nn("arrowKeys"),
          Dt = Nn("speed"),
          qt = t.rewind,
          jt = !qt && t.loop,
          Bt = Nn("autoHeight"),
          Ht = Nn("controls"),
          Ut = Nn("controlsText"),
          Ft = Nn("nav"),
          Wt = Nn("touch"),
          zt = Nn("mouseDrag"),
          Yt = Nn("autoplay"),
          Vt = Nn("autoplayTimeout"),
          Kt = Nn("autoplayText"),
          Qt = Nn("autoplayHoverPause"),
          Gt = Nn("autoplayResetOnVisibility"),
          Xt =
            ((St = null),
            (Tt = Nn("nonce")),
            (At = document.createElement("style")),
            St && At.setAttribute("media", St),
            Tt && At.setAttribute("nonce", Tt),
            document.querySelector("head").appendChild(At),
            At.sheet ? At.sheet : At.styleSheet),
          Jt = t.lazyload,
          Zt = t.lazyloadSelector,
          te = [],
          ee = jt
            ? ((Et = (function () {
                if (Lt || (Ct && !Mt)) return mt - 1;
                var e = Ct ? "fixedWidth" : "items",
                  n = [];
                if (((Ct || t[e] < mt) && n.push(t[e]), G))
                  for (var i in G) {
                    var r = G[i][e];
                    r && (Ct || r < mt) && n.push(r);
                  }
                return (
                  n.length || n.push(0),
                  Math.ceil(
                    Ct ? Mt / Math.min.apply(null, n) : Math.max.apply(null, n)
                  )
                );
              })()),
              (kt = J ? Math.ceil((5 * Et - mt) / 2) : 4 * Et - mt),
              (kt = Math.max(Et, kt)),
              Mn("edgePadding") ? kt + 1 : kt)
            : 0,
          ne = J ? mt + 2 * ee : mt + ee,
          ie = !((!Ct && !Lt) || jt),
          re = Ct ? Si() : null,
          oe = !J || !jt,
          ae = ct ? "left" : "top",
          se = "",
          ce = "",
          le = Ct
            ? function () {
                return Pt && !jt ? mt - 1 : Math.ceil(-re / (Ct + Ot));
              }
            : Lt
            ? function () {
                for (var t = 0; t < ne; t++) if (yt[t] >= -re) return t;
              }
            : function () {
                return Pt && J && !jt
                  ? mt - 1
                  : jt || J
                  ? Math.max(0, ne - Math.ceil(It))
                  : ne - 1;
              },
          ue = xn(Nn("startIndex")),
          de = ue,
          fe = (Cn(), 0),
          he = Lt ? null : le(),
          pe = t.preventActionWhenRunning,
          me = t.swipeAngle,
          ge = !me || "?",
          ve = !1,
          ye = t.onInit,
          be = new D(),
          _e = " tns-slider tns-" + t.mode,
          we =
            dt.id ||
            ((wt = window.tnsId),
            (window.tnsId = wt ? wt + 1 : 1),
            "tns" + window.tnsId),
          Ee = Nn("disable"),
          ke = !1,
          Se = t.freezable,
          Te = !(!Se || Lt) && Xn(),
          Ae = !1,
          Le = {
            click: Ii,
            keydown: function (t) {
              t = Hi(t);
              var e = [i.LEFT, i.RIGHT].indexOf(t.keyCode);
              e >= 0 &&
                (0 === e ? Ke.disabled || Ii(t, -1) : Qe.disabled || Ii(t, 1));
            },
          },
          Ce = {
            click: function (t) {
              if (ve) {
                if (pe) return;
                $i();
              }
              var e = Ui((t = Hi(t)));
              for (; e !== Ze && !w(e, "data-nav"); ) e = e.parentNode;
              if (w(e, "data-nav")) {
                var n = (rn = Number(E(e, "data-nav"))),
                  i = Ct || Lt ? (n * mt) / en : n * It;
                Pi(Ne ? n : Math.min(Math.ceil(i), mt - 1), t),
                  on === n && (dn && qi(), (rn = -1));
              }
            },
            keydown: function (t) {
              t = Hi(t);
              var n = e.activeElement;
              if (!w(n, "data-nav")) return;
              var r = [i.LEFT, i.RIGHT, i.ENTER, i.SPACE].indexOf(t.keyCode),
                o = Number(E(n, "data-nav"));
              r >= 0 &&
                (0 === r
                  ? o > 0 && Bi(Je[o - 1])
                  : 1 === r
                  ? o < en - 1 && Bi(Je[o + 1])
                  : ((rn = o), Pi(o, t)));
            },
          },
          xe = {
            mouseover: function () {
              dn && (Mi(), (fn = !0));
            },
            mouseout: function () {
              fn && (Ri(), (fn = !1));
            },
          },
          Oe = {
            visibilitychange: function () {
              e.hidden ? dn && (Mi(), (pn = !0)) : pn && (Ri(), (pn = !1));
            },
          },
          $e = {
            keydown: function (t) {
              t = Hi(t);
              var e = [i.LEFT, i.RIGHT].indexOf(t.keyCode);
              e >= 0 && Ii(t, 0 === e ? -1 : 1);
            },
          },
          Pe = { touchstart: Yi, touchmove: Vi, touchend: Ki, touchcancel: Ki },
          Ie = { mousedown: Yi, mousemove: Vi, mouseup: Ki, mouseleave: Ki },
          Re = Mn("controls"),
          Me = Mn("nav"),
          Ne = !!Lt || t.navAsThumbnails,
          De = Mn("autoplay"),
          qe = Mn("touch"),
          je = Mn("mouseDrag"),
          Be = "tns-slide-active",
          He = "tns-complete",
          Ue = {
            load: function (t) {
              si(Ui(t));
            },
            error: function (t) {
              (e = Ui(t)), b(e, "failed"), ci(e);
              var e;
            },
          },
          Fe = "force" === t.preventScrollOnTouch;
        if (Re)
          var We,
            ze,
            Ye = t.controlsContainer,
            Ve = t.controlsContainer ? t.controlsContainer.outerHTML : "",
            Ke = t.prevButton,
            Qe = t.nextButton,
            Ge = t.prevButton ? t.prevButton.outerHTML : "",
            Xe = t.nextButton ? t.nextButton.outerHTML : "";
        if (Me)
          var Je,
            Ze = t.navContainer,
            tn = t.navContainer ? t.navContainer.outerHTML : "",
            en = Lt ? mt : Gi(),
            nn = 0,
            rn = -1,
            on = $n(),
            an = on,
            sn = "tns-nav-active",
            cn = "Carousel Page ",
            ln = " (Current Slide)";
        if (De)
          var un,
            dn,
            fn,
            hn,
            pn,
            mn = "forward" === t.autoplayDirection ? 1 : -1,
            gn = t.autoplayButton,
            vn = t.autoplayButton ? t.autoplayButton.outerHTML : "",
            yn = ["<span class='tns-visually-hidden'>", " animation</span>"];
        if (qe || je)
          var bn,
            _n,
            wn = {},
            En = {},
            kn = !1,
            Sn = ct
              ? function (t, e) {
                  return t.x - e.x;
                }
              : function (t, e) {
                  return t.y - e.y;
                };
        Lt || Ln(Ee || Te),
          j &&
            ((ae = j),
            (se = "translate"),
            B
              ? ((se += ct ? "3d(" : "3d(0px, "),
                (ce = ct ? ", 0px, 0px)" : ", 0px)"))
              : ((se += ct ? "X(" : "Y("), (ce = ")"))),
          J && (dt.className = dt.className.replace("tns-vpfix", "")),
          (function () {
            Mn("gutter");
            (lt.className = "tns-outer"),
              (ut.className = "tns-inner"),
              (lt.id = we + "-ow"),
              (ut.id = we + "-iw"),
              "" === dt.id && (dt.id = we);
            (_e += I || Lt ? " tns-subpixel" : " tns-no-subpixel"),
              (_e += P ? " tns-calc" : " tns-no-calc"),
              Lt && (_e += " tns-autowidth");
            (_e += " tns-" + t.axis),
              (dt.className += _e),
              J
                ? (((at = e.createElement("div")).id = we + "-mw"),
                  (at.className = "tns-ovh"),
                  lt.appendChild(at),
                  at.appendChild(ut))
                : lt.appendChild(ut);
            if (Bt) {
              (at || ut).className += " tns-ah";
            }
            if (
              (ft.insertBefore(lt, dt),
              ut.appendChild(dt),
              g(pt, function (t, e) {
                b(t, "tns-item"),
                  t.id || (t.id = we + "-item" + e),
                  !J && ot && b(t, ot),
                  S(t, { "aria-hidden": "true", tabindex: "-1" });
              }),
              ee)
            ) {
              for (
                var n = e.createDocumentFragment(),
                  i = e.createDocumentFragment(),
                  r = ee;
                r--;

              ) {
                var o = r % mt,
                  a = pt[o].cloneNode(!0);
                if (
                  (b(a, "tns-slide-cloned"),
                  T(a, "id"),
                  i.insertBefore(a, i.firstChild),
                  J)
                ) {
                  var s = pt[mt - 1 - o].cloneNode(!0);
                  b(s, "tns-slide-cloned"), T(s, "id"), n.appendChild(s);
                }
              }
              dt.insertBefore(n, dt.firstChild),
                dt.appendChild(i),
                (pt = dt.children);
            }
          })(),
          (function () {
            if (!J)
              for (var e = ue, i = ue + Math.min(mt, It); e < i; e++) {
                var r = pt[e];
                (r.style.left = (100 * (e - ue)) / It + "%"),
                  b(r, nt),
                  _(r, ot);
              }
            ct &&
              (I || Lt
                ? (p(
                    Xt,
                    "#" + we + " > .tns-item",
                    "font-size:" + n.getComputedStyle(pt[0]).fontSize + ";",
                    m(Xt)
                  ),
                  p(Xt, "#" + we, "font-size:0;", m(Xt)))
                : J &&
                  g(pt, function (t, e) {
                    t.style.marginLeft = (function (t) {
                      return P
                        ? P + "(" + 100 * t + "% / " + ne + ")"
                        : (100 * t) / ne + "%";
                    })(e);
                  }));
            if (R) {
              if (H) {
                var o = at && t.autoHeight ? Un(t.speed) : "";
                p(Xt, "#" + we + "-mw", o, m(Xt));
              }
              (o = Dn(
                t.edgePadding,
                t.gutter,
                t.fixedWidth,
                t.speed,
                t.autoHeight
              )),
                p(Xt, "#" + we + "-iw", o, m(Xt)),
                J &&
                  ((o =
                    ct && !Lt
                      ? "width:" + qn(t.fixedWidth, t.gutter, t.items) + ";"
                      : ""),
                  H && (o += Un(Dt)),
                  p(Xt, "#" + we, o, m(Xt))),
                (o = ct && !Lt ? jn(t.fixedWidth, t.gutter, t.items) : ""),
                t.gutter && (o += Bn(t.gutter)),
                J || (H && (o += Un(Dt)), F && (o += Fn(Dt))),
                o && p(Xt, "#" + we + " > .tns-item", o, m(Xt));
            } else {
              J && Bt && (at.style[H] = Dt / 1e3 + "s"),
                (ut.style.cssText = Dn(xt, Ot, Ct, Bt)),
                J && ct && !Lt && (dt.style.width = qn(Ct, Ot, It));
              o = ct && !Lt ? jn(Ct, Ot, It) : "";
              Ot && (o += Bn(Ot)),
                o && p(Xt, "#" + we + " > .tns-item", o, m(Xt));
            }
            if (G && R)
              for (var a in G) {
                a = parseInt(a);
                var s = G[a],
                  c = ((o = ""), ""),
                  l = "",
                  u = "",
                  d = "",
                  f = Lt ? null : Nn("items", a),
                  h = Nn("fixedWidth", a),
                  v = Nn("speed", a),
                  y = Nn("edgePadding", a),
                  w = Nn("autoHeight", a),
                  E = Nn("gutter", a);
                H &&
                  at &&
                  Nn("autoHeight", a) &&
                  "speed" in s &&
                  (c = "#" + we + "-mw{" + Un(v) + "}"),
                  ("edgePadding" in s || "gutter" in s) &&
                    (l = "#" + we + "-iw{" + Dn(y, E, h, v, w) + "}"),
                  J &&
                    ct &&
                    !Lt &&
                    ("fixedWidth" in s ||
                      "items" in s ||
                      (Ct && "gutter" in s)) &&
                    (u = "width:" + qn(h, E, f) + ";"),
                  H && "speed" in s && (u += Un(v)),
                  u && (u = "#" + we + "{" + u + "}"),
                  ("fixedWidth" in s ||
                    (Ct && "gutter" in s) ||
                    (!J && "items" in s)) &&
                    (d += jn(h, E, f)),
                  "gutter" in s && (d += Bn(E)),
                  !J && "speed" in s && (H && (d += Un(v)), F && (d += Fn(v))),
                  d && (d = "#" + we + " > .tns-item{" + d + "}"),
                  (o = c + l + u + d) &&
                    Xt.insertRule(
                      "@media (min-width: " + a / 16 + "em) {" + o + "}",
                      Xt.cssRules.length
                    );
              }
          })(),
          Wn();
        var Tn = jt
            ? J
              ? function () {
                  var t = fe,
                    e = he;
                  (t += Rt),
                    (e -= Rt),
                    xt
                      ? ((t += 1), (e -= 1))
                      : Ct && ($t + Ot) % (Ct + Ot) && (e -= 1),
                    ee && (ue > e ? (ue -= mt) : ue < t && (ue += mt));
                }
              : function () {
                  if (ue > he) for (; ue >= fe + mt; ) ue -= mt;
                  else if (ue < fe) for (; ue <= he - mt; ) ue += mt;
                }
            : function () {
                ue = Math.max(fe, Math.min(he, ue));
              },
          An = J
            ? function () {
                var t, e, n, i, r, o, a, s, c, l, u;
                Ei(dt, ""),
                  H || !Dt
                    ? (Li(), (Dt && x(dt)) || $i())
                    : ((t = dt),
                      (e = ae),
                      (n = se),
                      (i = ce),
                      (r = Ti()),
                      (o = Dt),
                      (a = $i),
                      (s = Math.min(o, 10)),
                      (c = r.indexOf("%") >= 0 ? "%" : "px"),
                      (r = r.replace(c, "")),
                      (l = Number(
                        t.style[e].replace(n, "").replace(i, "").replace(c, "")
                      )),
                      (u = ((r - l) / o) * s),
                      setTimeout(function r() {
                        (o -= s),
                          (l += u),
                          (t.style[e] = n + l + c + i),
                          o > 0 ? setTimeout(r, s) : a();
                      }, s)),
                  ct || Qi();
              }
            : function () {
                te = [];
                var t = {};
                (t[z] = t[Y] = $i),
                  N(pt[de], t),
                  M(pt[ue], t),
                  Ci(de, nt, it, !0),
                  Ci(ue, ot, nt),
                  (z && Y && Dt && x(dt)) || $i();
              };
        return {
          version: "2.9.3",
          getInfo: Ji,
          events: be,
          goTo: Pi,
          play: function () {
            Yt && !dn && (Di(), (hn = !1));
          },
          pause: function () {
            dn && (qi(), (hn = !0));
          },
          isOn: vt,
          updateSliderHeight: pi,
          refresh: Wn,
          destroy: function () {
            if (
              ((Xt.disabled = !0),
              Xt.ownerNode && Xt.ownerNode.remove(),
              N(n, { resize: Qn }),
              Nt && N(e, $e),
              Ye && N(Ye, Le),
              Ze && N(Ze, Ce),
              N(dt, xe),
              N(dt, Oe),
              gn && N(gn, { click: ji }),
              Yt && clearInterval(un),
              J && z)
            ) {
              var i = {};
              (i[z] = $i), N(dt, i);
            }
            Wt && N(dt, Pe), zt && N(dt, Ie);
            var r = [ht, Ve, Ge, Xe, tn, vn];
            for (var o in (K.forEach(function (e, n) {
              var i = "container" === e ? lt : t[e];
              if ("object" == typeof i && i) {
                var o = !!i.previousElementSibling && i.previousElementSibling,
                  a = i.parentNode;
                (i.outerHTML = r[n]),
                  (t[e] = o ? o.nextElementSibling : a.firstElementChild);
              }
            }),
            (K =
              nt =
              it =
              rt =
              ot =
              ct =
              lt =
              ut =
              dt =
              ft =
              ht =
              pt =
              mt =
              st =
              gt =
              Lt =
              Ct =
              xt =
              Ot =
              $t =
              It =
              Rt =
              Mt =
              Nt =
              Dt =
              qt =
              jt =
              Bt =
              Xt =
              Jt =
              yt =
              te =
              ee =
              ne =
              ie =
              re =
              oe =
              ae =
              se =
              ce =
              le =
              ue =
              de =
              fe =
              he =
              me =
              ge =
              ve =
              ye =
              be =
              _e =
              we =
              Ee =
              ke =
              Se =
              Te =
              Ae =
              Le =
              Ce =
              xe =
              Oe =
              $e =
              Pe =
              Ie =
              Re =
              Me =
              Ne =
              De =
              qe =
              je =
              Be =
              He =
              Ue =
              bt =
              Ht =
              Ut =
              Ye =
              Ve =
              Ke =
              Qe =
              We =
              ze =
              Ft =
              Ze =
              tn =
              Je =
              en =
              nn =
              rn =
              on =
              an =
              sn =
              cn =
              ln =
              Yt =
              Vt =
              mn =
              Kt =
              Qt =
              gn =
              vn =
              Gt =
              yn =
              un =
              dn =
              fn =
              hn =
              pn =
              wn =
              En =
              bn =
              kn =
              _n =
              Sn =
              Wt =
              zt =
                null),
            this))
              "rebuild" !== o && (this[o] = null);
            vt = !1;
          },
          rebuild: function () {
            return q(s(t, Q));
          },
        };
      }
      function Ln(t) {
        t && (Ht = Ft = Wt = zt = Nt = Yt = Qt = Gt = !1);
      }
      function Cn() {
        for (var t = J ? ue - ee : ue; t < 0; ) t += mt;
        return (t % mt) + 1;
      }
      function xn(t) {
        return (
          (t = t ? Math.max(0, Math.min(jt ? mt - 1 : mt - It, t)) : 0),
          J ? t + ee : t
        );
      }
      function On(t) {
        for (null == t && (t = ue), J && (t -= ee); t < 0; ) t += mt;
        return Math.floor(t % mt);
      }
      function $n() {
        var t,
          e = On();
        return (
          (t = Ne
            ? e
            : Ct || Lt
            ? Math.ceil(((e + 1) * en) / mt - 1)
            : Math.floor(e / It)),
          !jt && J && ue === he && (t = en - 1),
          t
        );
      }
      function Pn() {
        return (
          n.innerWidth || e.documentElement.clientWidth || e.body.clientWidth
        );
      }
      function In(t) {
        return "top" === t ? "afterbegin" : "beforeend";
      }
      function Rn() {
        var t = xt ? 2 * xt - Ot : 0;
        return (
          (function t(n) {
            if (null != n) {
              var i,
                r,
                o = e.createElement("div");
              return (
                n.appendChild(o),
                (r = (i = o.getBoundingClientRect()).right - i.left),
                o.remove(),
                r || t(n.parentNode)
              );
            }
          })(ft) - t
        );
      }
      function Mn(e) {
        if (t[e]) return !0;
        if (G) for (var n in G) if (G[n][e]) return !0;
        return !1;
      }
      function Nn(e, n) {
        if ((null == n && (n = gt), "items" === e && Ct))
          return Math.floor(($t + Ot) / (Ct + Ot)) || 1;
        var i = t[e];
        if (G) for (var r in G) n >= parseInt(r) && e in G[r] && (i = G[r][e]);
        return (
          "slideBy" === e && "page" === i && (i = Nn("items")),
          J || ("slideBy" !== e && "items" !== e) || (i = Math.floor(i)),
          i
        );
      }
      function Dn(t, e, n, i, r) {
        var o = "";
        if (void 0 !== t) {
          var a = t;
          e && (a -= e),
            (o = ct
              ? "margin: 0 " + a + "px 0 " + t + "px;"
              : "margin: " + t + "px 0 " + a + "px 0;");
        } else if (e && !n) {
          var s = "-" + e + "px";
          o = "margin: 0 " + (ct ? s + " 0 0" : "0 " + s + " 0") + ";";
        }
        return !J && r && H && i && (o += Un(i)), o;
      }
      function qn(t, e, n) {
        return t
          ? (t + e) * ne + "px"
          : P
          ? P + "(" + 100 * ne + "% / " + n + ")"
          : (100 * ne) / n + "%";
      }
      function jn(t, e, n) {
        var i;
        if (t) i = t + e + "px";
        else {
          J || (n = Math.floor(n));
          var r = J ? ne : n;
          i = P ? P + "(100% / " + r + ")" : 100 / r + "%";
        }
        return (i = "width:" + i), "inner" !== X ? i + ";" : i + " !important;";
      }
      function Bn(t) {
        var e = "";
        !1 !== t &&
          (e =
            (ct ? "padding-" : "margin-") +
            (ct ? "right" : "bottom") +
            ": " +
            t +
            "px;");
        return e;
      }
      function Hn(t, e) {
        var n = t.substring(0, t.length - e).toLowerCase();
        return n && (n = "-" + n + "-"), n;
      }
      function Un(t) {
        return Hn(H, 18) + "transition-duration:" + t / 1e3 + "s;";
      }
      function Fn(t) {
        return Hn(F, 17) + "animation-duration:" + t / 1e3 + "s;";
      }
      function Wn() {
        if (Mn("autoHeight") || Lt || !ct) {
          var t = dt.querySelectorAll("img");
          g(t, function (t) {
            var e = t.src;
            Jt ||
              (e && e.indexOf("data:image") < 0
                ? ((t.src = ""), M(t, Ue), b(t, "loading"), (t.src = e))
                : si(t));
          }),
            r(function () {
              di(A(t), function () {
                bt = !0;
              });
            }),
            Mn("autoHeight") && (t = li(ue, Math.min(ue + It - 1, ne - 1))),
            Jt
              ? zn()
              : r(function () {
                  di(A(t), zn);
                });
        } else J && Ai(), Vn(), Kn();
      }
      function zn() {
        if (Lt && mt > 1) {
          var t = jt ? ue : mt - 1;
          !(function e() {
            var n = pt[t].getBoundingClientRect().left,
              i = pt[t - 1].getBoundingClientRect().right;
            Math.abs(n - i) <= 1
              ? Yn()
              : setTimeout(function () {
                  e();
                }, 16);
          })();
        } else Yn();
      }
      function Yn() {
        (ct && !Lt) ||
          (mi(),
          Lt
            ? ((re = Si()), Se && (Te = Xn()), (he = le()), Ln(Ee || Te))
            : Qi()),
          J && Ai(),
          Vn(),
          Kn();
      }
      function Vn() {
        if (
          (gi(),
          lt.insertAdjacentHTML(
            "afterbegin",
            '<div class="tns-liveregion tns-visually-hidden" aria-live="polite" aria-atomic="true">slide <span class="current">' +
              ri() +
              "</span>  of " +
              mt +
              "</div>"
          ),
          (_t = lt.querySelector(".tns-liveregion .current")),
          De)
        ) {
          var e = Yt ? "stop" : "start";
          gn
            ? S(gn, { "data-action": e })
            : t.autoplayButtonOutput &&
              (lt.insertAdjacentHTML(
                In(t.autoplayPosition),
                '<button type="button" data-action="' +
                  e +
                  '">' +
                  yn[0] +
                  e +
                  yn[1] +
                  Kt[0] +
                  "</button>"
              ),
              (gn = lt.querySelector("[data-action]"))),
            gn && M(gn, { click: ji }),
            Yt && (Di(), Qt && M(dt, xe), Gt && M(dt, Oe));
        }
        if (Me) {
          if (Ze)
            S(Ze, { "aria-label": "Carousel Pagination" }),
              g((Je = Ze.children), function (t, e) {
                S(t, {
                  "data-nav": e,
                  tabindex: "-1",
                  "aria-label": cn + (e + 1),
                  "aria-controls": we,
                });
              });
          else {
            for (
              var n = "", i = Ne ? "" : 'style="display:none"', r = 0;
              r < mt;
              r++
            )
              n +=
                '<button type="button" data-nav="' +
                r +
                '" tabindex="-1" aria-controls="' +
                we +
                '" ' +
                i +
                ' aria-label="' +
                cn +
                (r + 1) +
                '"></button>';
            (n =
              '<div class="tns-nav" aria-label="Carousel Pagination">' +
              n +
              "</div>"),
              lt.insertAdjacentHTML(In(t.navPosition), n),
              (Ze = lt.querySelector(".tns-nav")),
              (Je = Ze.children);
          }
          if ((Xi(), H)) {
            var o = H.substring(0, H.length - 18).toLowerCase(),
              a = "transition: all " + Dt / 1e3 + "s";
            o && (a = "-" + o + "-" + a),
              p(Xt, "[aria-controls^=" + we + "-item]", a, m(Xt));
          }
          S(Je[on], { "aria-label": cn + (on + 1) + ln }),
            T(Je[on], "tabindex"),
            b(Je[on], sn),
            M(Ze, Ce);
        }
        Re &&
          (Ye ||
            (Ke && Qe) ||
            (lt.insertAdjacentHTML(
              In(t.controlsPosition),
              '<div class="tns-controls" aria-label="Carousel Navigation" tabindex="0"><button type="button" data-controls="prev" tabindex="-1" aria-controls="' +
                we +
                '">' +
                Ut[0] +
                '</button><button type="button" data-controls="next" tabindex="-1" aria-controls="' +
                we +
                '">' +
                Ut[1] +
                "</button></div>"
            ),
            (Ye = lt.querySelector(".tns-controls"))),
          (Ke && Qe) || ((Ke = Ye.children[0]), (Qe = Ye.children[1])),
          t.controlsContainer &&
            S(Ye, { "aria-label": "Carousel Navigation", tabindex: "0" }),
          (t.controlsContainer || (t.prevButton && t.nextButton)) &&
            S([Ke, Qe], { "aria-controls": we, tabindex: "-1" }),
          (t.controlsContainer || (t.prevButton && t.nextButton)) &&
            (S(Ke, { "data-controls": "prev" }),
            S(Qe, { "data-controls": "next" })),
          (We = yi(Ke)),
          (ze = yi(Qe)),
          wi(),
          Ye ? M(Ye, Le) : (M(Ke, Le), M(Qe, Le))),
          Zn();
      }
      function Kn() {
        if (J && z) {
          var i = {};
          (i[z] = $i), M(dt, i);
        }
        Wt && M(dt, Pe, t.preventScrollOnTouch),
          zt && M(dt, Ie),
          Nt && M(e, $e),
          "inner" === X
            ? be.on("outerResized", function () {
                Gn(), be.emit("innerLoaded", Ji());
              })
            : (G || Ct || Lt || Bt || !ct) && M(n, { resize: Qn }),
          Bt && ("outer" === X ? be.on("innerLoaded", ui) : Ee || ui()),
          ai(),
          Ee ? ni() : Te && ei(),
          be.on("indexChanged", fi),
          "inner" === X && be.emit("innerLoaded", Ji()),
          "function" == typeof ye && ye(Ji()),
          (vt = !0);
      }
      function Qn(t) {
        r(function () {
          Gn(Hi(t));
        });
      }
      function Gn(n) {
        if (vt) {
          "outer" === X && be.emit("outerResized", Ji(n)), (gt = Pn());
          var i,
            r = st,
            o = !1;
          G && (Jn(), (i = r !== st) && be.emit("newBreakpointStart", Ji(n)));
          var a,
            s,
            c = It,
            l = Ee,
            u = Te,
            d = Nt,
            f = Ht,
            h = Ft,
            v = Wt,
            y = zt,
            w = Yt,
            E = Qt,
            k = Gt,
            S = ue;
          if (i) {
            var T = Ct,
              A = Bt,
              x = Ut,
              O = Pt,
              $ = Kt;
            if (!R)
              var P = Ot,
                I = xt;
          }
          if (
            ((Nt = Nn("arrowKeys")),
            (Ht = Nn("controls")),
            (Ft = Nn("nav")),
            (Wt = Nn("touch")),
            (Pt = Nn("center")),
            (zt = Nn("mouseDrag")),
            (Yt = Nn("autoplay")),
            (Qt = Nn("autoplayHoverPause")),
            (Gt = Nn("autoplayResetOnVisibility")),
            i &&
              ((Ee = Nn("disable")),
              (Ct = Nn("fixedWidth")),
              (Dt = Nn("speed")),
              (Bt = Nn("autoHeight")),
              (Ut = Nn("controlsText")),
              (Kt = Nn("autoplayText")),
              (Vt = Nn("autoplayTimeout")),
              R || ((xt = Nn("edgePadding")), (Ot = Nn("gutter")))),
            Ln(Ee),
            ($t = Rn()),
            (ct && !Lt) || Ee || (mi(), ct || (Qi(), (o = !0))),
            (Ct || Lt) && ((re = Si()), (he = le())),
            (i || Ct) &&
              ((It = Nn("items")),
              (Rt = Nn("slideBy")),
              (s = It !== c) && (Ct || Lt || (he = le()), Tn())),
            i &&
              Ee !== l &&
              (Ee
                ? ni()
                : (function () {
                    if (!ke) return;
                    if (((Xt.disabled = !1), (dt.className += _e), Ai(), jt))
                      for (var t = ee; t--; ) J && C(pt[t]), C(pt[ne - t - 1]);
                    if (!J)
                      for (var e = ue, n = ue + mt; e < n; e++) {
                        var i = pt[e],
                          r = e < ue + It ? nt : ot;
                        (i.style.left = (100 * (e - ue)) / It + "%"), b(i, r);
                      }
                    ti(), (ke = !1);
                  })()),
            Se &&
              (i || Ct || Lt) &&
              (Te = Xn()) !== u &&
              (Te
                ? (Li(Ti(xn(0))), ei())
                : (!(function () {
                    if (!Ae) return;
                    xt && R && (ut.style.margin = "");
                    if (ee)
                      for (var t = "tns-transparent", e = ee; e--; )
                        J && _(pt[e], t), _(pt[ne - e - 1], t);
                    ti(), (Ae = !1);
                  })(),
                  (o = !0))),
            Ln(Ee || Te),
            Yt || (Qt = Gt = !1),
            Nt !== d && (Nt ? M(e, $e) : N(e, $e)),
            Ht !== f &&
              (Ht
                ? Ye
                  ? C(Ye)
                  : (Ke && C(Ke), Qe && C(Qe))
                : Ye
                ? L(Ye)
                : (Ke && L(Ke), Qe && L(Qe))),
            Ft !== h && (Ft ? (C(Ze), Xi()) : L(Ze)),
            Wt !== v && (Wt ? M(dt, Pe, t.preventScrollOnTouch) : N(dt, Pe)),
            zt !== y && (zt ? M(dt, Ie) : N(dt, Ie)),
            Yt !== w &&
              (Yt
                ? (gn && C(gn), dn || hn || Di())
                : (gn && L(gn), dn && qi())),
            Qt !== E && (Qt ? M(dt, xe) : N(dt, xe)),
            Gt !== k && (Gt ? M(e, Oe) : N(e, Oe)),
            i)
          ) {
            if (
              ((Ct === T && Pt === O) || (o = !0),
              Bt !== A && (Bt || (ut.style.height = "")),
              Ht &&
                Ut !== x &&
                ((Ke.innerHTML = Ut[0]), (Qe.innerHTML = Ut[1])),
              gn && Kt !== $)
            ) {
              var D = Yt ? 1 : 0,
                q = gn.innerHTML,
                j = q.length - $[D].length;
              q.substring(j) === $[D] &&
                (gn.innerHTML = q.substring(0, j) + Kt[D]);
            }
          } else Pt && (Ct || Lt) && (o = !0);
          if (
            ((s || (Ct && !Lt)) && ((en = Gi()), Xi()),
            (a = ue !== S)
              ? (be.emit("indexChanged", Ji()), (o = !0))
              : s
              ? a || fi()
              : (Ct || Lt) && (ai(), gi(), ii()),
            s &&
              !J &&
              (function () {
                for (var t = ue + Math.min(mt, It), e = ne; e--; ) {
                  var n = pt[e];
                  e >= ue && e < t
                    ? (b(n, "tns-moving"),
                      (n.style.left = (100 * (e - ue)) / It + "%"),
                      b(n, nt),
                      _(n, ot))
                    : n.style.left && ((n.style.left = ""), b(n, ot), _(n, nt)),
                    _(n, it);
                }
                setTimeout(function () {
                  g(pt, function (t) {
                    _(t, "tns-moving");
                  });
                }, 300);
              })(),
            !Ee && !Te)
          ) {
            if (
              i &&
              !R &&
              ((xt === I && Ot === P) ||
                (ut.style.cssText = Dn(xt, Ot, Ct, Dt, Bt)),
              ct)
            ) {
              J && (dt.style.width = qn(Ct, Ot, It));
              var B = jn(Ct, Ot, It) + Bn(Ot);
              !(function (t, e) {
                "deleteRule" in t ? t.deleteRule(e) : t.removeRule(e);
              })(Xt, m(Xt) - 1),
                p(Xt, "#" + we + " > .tns-item", B, m(Xt));
            }
            Bt && ui(), o && (Ai(), (de = ue));
          }
          i && be.emit("newBreakpointEnd", Ji(n));
        }
      }
      function Xn() {
        if (!Ct && !Lt) return mt <= (Pt ? It - (It - 1) / 2 : It);
        var t = Ct ? (Ct + Ot) * mt : yt[mt],
          e = xt ? $t + 2 * xt : $t + Ot;
        return (
          Pt &&
            (e -= Ct ? ($t - Ct) / 2 : ($t - (yt[ue + 1] - yt[ue] - Ot)) / 2),
          t <= e
        );
      }
      function Jn() {
        for (var t in ((st = 0), G)) (t = parseInt(t)), gt >= t && (st = t);
      }
      function Zn() {
        !Yt && gn && L(gn),
          !Ft && Ze && L(Ze),
          Ht || (Ye ? L(Ye) : (Ke && L(Ke), Qe && L(Qe)));
      }
      function ti() {
        Yt && gn && C(gn),
          Ft && Ze && C(Ze),
          Ht && (Ye ? C(Ye) : (Ke && C(Ke), Qe && C(Qe)));
      }
      function ei() {
        if (!Ae) {
          if ((xt && (ut.style.margin = "0px"), ee))
            for (var t = "tns-transparent", e = ee; e--; )
              J && b(pt[e], t), b(pt[ne - e - 1], t);
          Zn(), (Ae = !0);
        }
      }
      function ni() {
        if (!ke) {
          if (
            ((Xt.disabled = !0),
            (dt.className = dt.className.replace(_e.substring(1), "")),
            T(dt, ["style"]),
            jt)
          )
            for (var t = ee; t--; ) J && L(pt[t]), L(pt[ne - t - 1]);
          if (((ct && J) || T(ut, ["style"]), !J))
            for (var e = ue, n = ue + mt; e < n; e++) {
              var i = pt[e];
              T(i, ["style"]), _(i, nt), _(i, ot);
            }
          Zn(), (ke = !0);
        }
      }
      function ii() {
        var t = ri();
        _t.innerHTML !== t && (_t.innerHTML = t);
      }
      function ri() {
        var t = oi(),
          e = t[0] + 1,
          n = t[1] + 1;
        return e === n ? e + "" : e + " to " + n;
      }
      function oi(t) {
        null == t && (t = Ti());
        var e,
          n,
          i,
          r = ue;
        if (
          (Pt || xt
            ? (Lt || Ct) && ((n = -(parseFloat(t) + xt)), (i = n + $t + 2 * xt))
            : Lt && ((n = yt[ue]), (i = n + $t)),
          Lt)
        )
          yt.forEach(function (t, o) {
            o < ne &&
              ((Pt || xt) && t <= n + 0.5 && (r = o), i - t >= 0.5 && (e = o));
          });
        else {
          if (Ct) {
            var o = Ct + Ot;
            Pt || xt
              ? ((r = Math.floor(n / o)), (e = Math.ceil(i / o - 1)))
              : (e = r + Math.ceil($t / o) - 1);
          } else if (Pt || xt) {
            var a = It - 1;
            if ((Pt ? ((r -= a / 2), (e = ue + a / 2)) : (e = ue + a), xt)) {
              var s = (xt * It) / $t;
              (r -= s), (e += s);
            }
            (r = Math.floor(r)), (e = Math.ceil(e));
          } else e = r + It - 1;
          (r = Math.max(r, 0)), (e = Math.min(e, ne - 1));
        }
        return [r, e];
      }
      function ai() {
        if (Jt && !Ee) {
          var t = oi();
          t.push(Zt),
            li.apply(null, t).forEach(function (t) {
              if (!y(t, He)) {
                var e = {};
                (e[z] = function (t) {
                  t.stopPropagation();
                }),
                  M(t, e),
                  M(t, Ue),
                  (t.src = E(t, "data-src"));
                var n = E(t, "data-srcset");
                n && (t.srcset = n), b(t, "loading");
              }
            });
        }
      }
      function si(t) {
        b(t, "loaded"), ci(t);
      }
      function ci(t) {
        b(t, He), _(t, "loading"), N(t, Ue);
      }
      function li(t, e, n) {
        var i = [];
        for (n || (n = "img"); t <= e; )
          g(pt[t].querySelectorAll(n), function (t) {
            i.push(t);
          }),
            t++;
        return i;
      }
      function ui() {
        var t = li.apply(null, oi());
        r(function () {
          di(t, pi);
        });
      }
      function di(t, e) {
        return bt
          ? e()
          : (t.forEach(function (e, n) {
              !Jt && e.complete && ci(e), y(e, He) && t.splice(n, 1);
            }),
            t.length
              ? void r(function () {
                  di(t, e);
                })
              : e());
      }
      function fi() {
        ai(),
          gi(),
          ii(),
          wi(),
          (function () {
            if (Ft && ((on = rn >= 0 ? rn : $n()), (rn = -1), on !== an)) {
              var t = Je[an],
                e = Je[on];
              S(t, { tabindex: "-1", "aria-label": cn + (an + 1) }),
                _(t, sn),
                S(e, { "aria-label": cn + (on + 1) + ln }),
                T(e, "tabindex"),
                b(e, sn),
                (an = on);
            }
          })();
      }
      function hi(t, e) {
        for (var n = [], i = t, r = Math.min(t + e, ne); i < r; i++)
          n.push(pt[i].offsetHeight);
        return Math.max.apply(null, n);
      }
      function pi() {
        var t = Bt ? hi(ue, It) : hi(ee, mt),
          e = at || ut;
        e.style.height !== t && (e.style.height = t + "px");
      }
      function mi() {
        yt = [0];
        var t = ct ? "left" : "top",
          e = ct ? "right" : "bottom",
          n = pt[0].getBoundingClientRect()[t];
        g(pt, function (i, r) {
          r && yt.push(i.getBoundingClientRect()[t] - n),
            r === ne - 1 && yt.push(i.getBoundingClientRect()[e] - n);
        });
      }
      function gi() {
        var t = oi(),
          e = t[0],
          n = t[1];
        g(pt, function (t, i) {
          i >= e && i <= n
            ? w(t, "aria-hidden") &&
              (T(t, ["aria-hidden", "tabindex"]), b(t, Be))
            : w(t, "aria-hidden") ||
              (S(t, { "aria-hidden": "true", tabindex: "-1" }), _(t, Be));
        });
      }
      function vi(t) {
        return t.nodeName.toLowerCase();
      }
      function yi(t) {
        return "button" === vi(t);
      }
      function bi(t) {
        return "true" === t.getAttribute("aria-disabled");
      }
      function _i(t, e, n) {
        t ? (e.disabled = n) : e.setAttribute("aria-disabled", n.toString());
      }
      function wi() {
        if (Ht && !qt && !jt) {
          var t = We ? Ke.disabled : bi(Ke),
            e = ze ? Qe.disabled : bi(Qe),
            n = ue <= fe,
            i = !qt && ue >= he;
          n && !t && _i(We, Ke, !0),
            !n && t && _i(We, Ke, !1),
            i && !e && _i(ze, Qe, !0),
            !i && e && _i(ze, Qe, !1);
        }
      }
      function Ei(t, e) {
        H && (t.style[H] = e);
      }
      function ki(t) {
        return (
          null == t && (t = ue),
          Lt
            ? ($t - (xt ? Ot : 0) - (yt[t + 1] - yt[t] - Ot)) / 2
            : Ct
            ? ($t - Ct) / 2
            : (It - 1) / 2
        );
      }
      function Si() {
        var t = $t + (xt ? Ot : 0) - (Ct ? (Ct + Ot) * ne : yt[ne]);
        return (
          Pt &&
            !jt &&
            (t = Ct ? -(Ct + Ot) * (ne - 1) - ki() : ki(ne - 1) - yt[ne - 1]),
          t > 0 && (t = 0),
          t
        );
      }
      function Ti(t) {
        var e;
        if ((null == t && (t = ue), ct && !Lt))
          if (Ct) (e = -(Ct + Ot) * t), Pt && (e += ki());
          else {
            var n = j ? ne : It;
            Pt && (t -= ki()), (e = (100 * -t) / n);
          }
        else (e = -yt[t]), Pt && Lt && (e += ki());
        return ie && (e = Math.max(e, re)), (e += !ct || Lt || Ct ? "px" : "%");
      }
      function Ai(t) {
        Ei(dt, "0s"), Li(t);
      }
      function Li(t) {
        null == t && (t = Ti()), (dt.style[ae] = se + t + ce);
      }
      function Ci(t, e, n, i) {
        var r = t + It;
        jt || (r = Math.min(r, ne));
        for (var o = t; o < r; o++) {
          var a = pt[o];
          i || (a.style.left = (100 * (o - ue)) / It + "%"),
            rt && U && (a.style[U] = a.style[W] = (rt * (o - t)) / 1e3 + "s"),
            _(a, e),
            b(a, n),
            i && te.push(a);
        }
      }
      function xi(t, e) {
        oe && Tn(),
          (ue !== de || e) &&
            (be.emit("indexChanged", Ji()),
            be.emit("transitionStart", Ji()),
            Bt && ui(),
            dn && t && ["click", "keydown"].indexOf(t.type) >= 0 && qi(),
            (ve = !0),
            An());
      }
      function Oi(t) {
        return t.toLowerCase().replace(/-/g, "");
      }
      function $i(t) {
        if (J || ve) {
          if ((be.emit("transitionEnd", Ji(t)), !J && te.length > 0))
            for (var e = 0; e < te.length; e++) {
              var n = te[e];
              (n.style.left = ""),
                W && U && ((n.style[W] = ""), (n.style[U] = "")),
                _(n, it),
                b(n, ot);
            }
          if (
            !t ||
            (!J && t.target.parentNode === dt) ||
            (t.target === dt && Oi(t.propertyName) === Oi(ae))
          ) {
            if (!oe) {
              var i = ue;
              Tn(), ue !== i && (be.emit("indexChanged", Ji()), Ai());
            }
            "inner" === X && be.emit("innerLoaded", Ji()), (ve = !1), (de = ue);
          }
        }
      }
      function Pi(t, e) {
        if (!Te)
          if ("prev" === t) Ii(e, -1);
          else if ("next" === t) Ii(e, 1);
          else {
            if (ve) {
              if (pe) return;
              $i();
            }
            var n = On(),
              i = 0;
            if (
              ("first" === t
                ? (i = -n)
                : "last" === t
                ? (i = J ? mt - It - n : mt - 1 - n)
                : ("number" != typeof t && (t = parseInt(t)),
                  isNaN(t) ||
                    (e || (t = Math.max(0, Math.min(mt - 1, t))), (i = t - n))),
              !J && i && Math.abs(i) < It)
            ) {
              var r = i > 0 ? 1 : -1;
              i += ue + i - mt >= fe ? mt * r : 2 * mt * r * -1;
            }
            (ue += i),
              J && jt && (ue < fe && (ue += mt), ue > he && (ue -= mt)),
              On(ue) !== On(de) && xi(e);
          }
      }
      function Ii(t, e) {
        if (ve) {
          if (pe) return;
          $i();
        }
        var n;
        if (!e) {
          for (var i = Ui((t = Hi(t))); i !== Ye && [Ke, Qe].indexOf(i) < 0; )
            i = i.parentNode;
          var r = [Ke, Qe].indexOf(i);
          r >= 0 && ((n = !0), (e = 0 === r ? -1 : 1));
        }
        if (qt) {
          if (ue === fe && -1 === e) return void Pi("last", t);
          if (ue === he && 1 === e) return void Pi("first", t);
        }
        e &&
          ((ue += Rt * e),
          Lt && (ue = Math.floor(ue)),
          xi(n || (t && "keydown" === t.type) ? t : null));
      }
      function Ri() {
        (un = setInterval(function () {
          Ii(null, mn);
        }, Vt)),
          (dn = !0);
      }
      function Mi() {
        clearInterval(un), (dn = !1);
      }
      function Ni(t, e) {
        S(gn, { "data-action": t }), (gn.innerHTML = yn[0] + t + yn[1] + e);
      }
      function Di() {
        Ri(), gn && Ni("stop", Kt[1]);
      }
      function qi() {
        Mi(), gn && Ni("start", Kt[0]);
      }
      function ji() {
        dn ? (qi(), (hn = !0)) : (Di(), (hn = !1));
      }
      function Bi(t) {
        t.focus();
      }
      function Hi(t) {
        return Fi((t = t || n.event)) ? t.changedTouches[0] : t;
      }
      function Ui(t) {
        return t.target || n.event.srcElement;
      }
      function Fi(t) {
        return t.type.indexOf("touch") >= 0;
      }
      function Wi(t) {
        t.preventDefault ? t.preventDefault() : (t.returnValue = !1);
      }
      function zi() {
        return (
          (o = En.y - wn.y),
          (a = En.x - wn.x),
          (e = Math.atan2(o, a) * (180 / Math.PI)),
          (n = me),
          (i = !1),
          (r = Math.abs(90 - Math.abs(e))) >= 90 - n
            ? (i = "horizontal")
            : r <= n && (i = "vertical"),
          i === t.axis
        );
        var e, n, i, r, o, a;
      }
      function Yi(t) {
        if (ve) {
          if (pe) return;
          $i();
        }
        Yt && dn && Mi(), (kn = !0), _n && (a(_n), (_n = null));
        var e = Hi(t);
        be.emit(Fi(t) ? "touchStart" : "dragStart", Ji(t)),
          !Fi(t) && ["img", "a"].indexOf(vi(Ui(t))) >= 0 && Wi(t),
          (En.x = wn.x = e.clientX),
          (En.y = wn.y = e.clientY),
          J && ((bn = parseFloat(dt.style[ae].replace(se, ""))), Ei(dt, "0s"));
      }
      function Vi(t) {
        if (kn) {
          var e = Hi(t);
          (En.x = e.clientX),
            (En.y = e.clientY),
            J
              ? _n ||
                (_n = r(function () {
                  !(function t(e) {
                    if (!ge) return void (kn = !1);
                    a(_n),
                      kn &&
                        (_n = r(function () {
                          t(e);
                        }));
                    "?" === ge && (ge = zi());
                    if (ge) {
                      !Fe && Fi(e) && (Fe = !0);
                      try {
                        e.type &&
                          be.emit(Fi(e) ? "touchMove" : "dragMove", Ji(e));
                      } catch (t) {}
                      var n = bn,
                        i = Sn(En, wn);
                      if (!ct || Ct || Lt) (n += i), (n += "px");
                      else
                        (n += j
                          ? (i * It * 100) / (($t + Ot) * ne)
                          : (100 * i) / ($t + Ot)),
                          (n += "%");
                      dt.style[ae] = se + n + ce;
                    }
                  })(t);
                }))
              : ("?" === ge && (ge = zi()), ge && (Fe = !0)),
            ("boolean" != typeof t.cancelable || t.cancelable) &&
              Fe &&
              t.preventDefault();
        }
      }
      function Ki(e) {
        if (kn) {
          _n && (a(_n), (_n = null)), J && Ei(dt, ""), (kn = !1);
          var n = Hi(e);
          (En.x = n.clientX), (En.y = n.clientY);
          var i = Sn(En, wn);
          if (Math.abs(i)) {
            if (!Fi(e)) {
              var o = Ui(e);
              M(o, {
                click: function t(e) {
                  Wi(e), N(o, { click: t });
                },
              });
            }
            J
              ? (_n = r(function () {
                  if (ct && !Lt) {
                    var t = (-i * It) / ($t + Ot);
                    (t = i > 0 ? Math.floor(t) : Math.ceil(t)), (ue += t);
                  } else {
                    var n = -(bn + i);
                    if (n <= 0) ue = fe;
                    else if (n >= yt[ne - 1]) ue = he;
                    else
                      for (var r = 0; r < ne && n >= yt[r]; )
                        (ue = r), n > yt[r] && i < 0 && (ue += 1), r++;
                  }
                  xi(e, i), be.emit(Fi(e) ? "touchEnd" : "dragEnd", Ji(e));
                }))
              : ge && Ii(e, i > 0 ? -1 : 1);
          }
        }
        "auto" === t.preventScrollOnTouch && (Fe = !1),
          me && (ge = "?"),
          Yt && !dn && Ri();
      }
      function Qi() {
        (at || ut).style.height = yt[ue + It] - yt[ue] + "px";
      }
      function Gi() {
        var t = Ct ? ((Ct + Ot) * mt) / $t : mt / It;
        return Math.min(Math.ceil(t), mt);
      }
      function Xi() {
        if (Ft && !Ne && en !== nn) {
          var t = nn,
            e = en,
            n = C;
          for (nn > en && ((t = en), (e = nn), (n = L)); t < e; ) n(Je[t]), t++;
          nn = en;
        }
      }
      function Ji(t) {
        return {
          container: dt,
          slideItems: pt,
          navContainer: Ze,
          navItems: Je,
          controlsContainer: Ye,
          hasControls: Re,
          prevButton: Ke,
          nextButton: Qe,
          items: It,
          slideBy: Rt,
          cloneCount: ee,
          slideCount: mt,
          slideCountNew: ne,
          index: ue,
          indexCached: de,
          displayIndex: Cn(),
          navCurrentIndex: on,
          navCurrentIndexCached: an,
          pages: en,
          pagesCached: nn,
          sheet: Xt,
          isOn: vt,
          event: t || {},
        };
      }
      V && console.warn("No slides found in", t.container);
    };
  },
  function (t, e, n) {
    "use strict";
    n.r(e), (e.default = n.p + "theme.css");
  },
  function (t, e) {
    var n;
    n = (function () {
      return this;
    })();
    try {
      n = n || new Function("return this")();
    } catch (t) {
      "object" == typeof window && (n = window);
    }
    t.exports = n;
  },
  function (t, e, n) {
    "use strict";
    var i = n(0),
      r = n(8),
      o = n(23),
      a = n(14);
    function s(t) {
      var e = new o(t),
        n = r(o.prototype.request, e);
      return i.extend(n, o.prototype, e), i.extend(n, e), n;
    }
    var c = s(n(11));
    (c.Axios = o),
      (c.create = function (t) {
        return s(a(c.defaults, t));
      }),
      (c.Cancel = n(15)),
      (c.CancelToken = n(37)),
      (c.isCancel = n(10)),
      (c.all = function (t) {
        return Promise.all(t);
      }),
      (c.spread = n(38)),
      (t.exports = c),
      (t.exports.default = c);
  },
  function (t, e, n) {
    "use strict";
    var i = n(0),
      r = n(9),
      o = n(24),
      a = n(25),
      s = n(14);
    function c(t) {
      (this.defaults = t),
        (this.interceptors = { request: new o(), response: new o() });
    }
    (c.prototype.request = function (t) {
      "string" == typeof t
        ? ((t = arguments[1] || {}).url = arguments[0])
        : (t = t || {}),
        (t = s(this.defaults, t)).method
          ? (t.method = t.method.toLowerCase())
          : this.defaults.method
          ? (t.method = this.defaults.method.toLowerCase())
          : (t.method = "get");
      var e = [a, void 0],
        n = Promise.resolve(t);
      for (
        this.interceptors.request.forEach(function (t) {
          e.unshift(t.fulfilled, t.rejected);
        }),
          this.interceptors.response.forEach(function (t) {
            e.push(t.fulfilled, t.rejected);
          });
        e.length;

      )
        n = n.then(e.shift(), e.shift());
      return n;
    }),
      (c.prototype.getUri = function (t) {
        return (
          (t = s(this.defaults, t)),
          r(t.url, t.params, t.paramsSerializer).replace(/^\?/, "")
        );
      }),
      i.forEach(["delete", "get", "head", "options"], function (t) {
        c.prototype[t] = function (e, n) {
          return this.request(s(n || {}, { method: t, url: e }));
        };
      }),
      i.forEach(["post", "put", "patch"], function (t) {
        c.prototype[t] = function (e, n, i) {
          return this.request(s(i || {}, { method: t, url: e, data: n }));
        };
      }),
      (t.exports = c);
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    function r() {
      this.handlers = [];
    }
    (r.prototype.use = function (t, e) {
      return (
        this.handlers.push({ fulfilled: t, rejected: e }),
        this.handlers.length - 1
      );
    }),
      (r.prototype.eject = function (t) {
        this.handlers[t] && (this.handlers[t] = null);
      }),
      (r.prototype.forEach = function (t) {
        i.forEach(this.handlers, function (e) {
          null !== e && t(e);
        });
      }),
      (t.exports = r);
  },
  function (t, e, n) {
    "use strict";
    var i = n(0),
      r = n(26),
      o = n(10),
      a = n(11);
    function s(t) {
      t.cancelToken && t.cancelToken.throwIfRequested();
    }
    t.exports = function (t) {
      return (
        s(t),
        (t.headers = t.headers || {}),
        (t.data = r(t.data, t.headers, t.transformRequest)),
        (t.headers = i.merge(
          t.headers.common || {},
          t.headers[t.method] || {},
          t.headers
        )),
        i.forEach(
          ["delete", "get", "head", "post", "put", "patch", "common"],
          function (e) {
            delete t.headers[e];
          }
        ),
        (t.adapter || a.adapter)(t).then(
          function (e) {
            return (
              s(t), (e.data = r(e.data, e.headers, t.transformResponse)), e
            );
          },
          function (e) {
            return (
              o(e) ||
                (s(t),
                e &&
                  e.response &&
                  (e.response.data = r(
                    e.response.data,
                    e.response.headers,
                    t.transformResponse
                  ))),
              Promise.reject(e)
            );
          }
        )
      );
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    t.exports = function (t, e, n) {
      return (
        i.forEach(n, function (n) {
          t = n(t, e);
        }),
        t
      );
    };
  },
  function (t, e) {
    var n,
      i,
      r = (t.exports = {});
    function o() {
      throw new Error("setTimeout has not been defined");
    }
    function a() {
      throw new Error("clearTimeout has not been defined");
    }
    function s(t) {
      if (n === setTimeout) return setTimeout(t, 0);
      if ((n === o || !n) && setTimeout)
        return (n = setTimeout), setTimeout(t, 0);
      try {
        return n(t, 0);
      } catch (e) {
        try {
          return n.call(null, t, 0);
        } catch (e) {
          return n.call(this, t, 0);
        }
      }
    }
    !(function () {
      try {
        n = "function" == typeof setTimeout ? setTimeout : o;
      } catch (t) {
        n = o;
      }
      try {
        i = "function" == typeof clearTimeout ? clearTimeout : a;
      } catch (t) {
        i = a;
      }
    })();
    var c,
      l = [],
      u = !1,
      d = -1;
    function f() {
      u &&
        c &&
        ((u = !1), c.length ? (l = c.concat(l)) : (d = -1), l.length && h());
    }
    function h() {
      if (!u) {
        var t = s(f);
        u = !0;
        for (var e = l.length; e; ) {
          for (c = l, l = []; ++d < e; ) c && c[d].run();
          (d = -1), (e = l.length);
        }
        (c = null),
          (u = !1),
          (function (t) {
            if (i === clearTimeout) return clearTimeout(t);
            if ((i === a || !i) && clearTimeout)
              return (i = clearTimeout), clearTimeout(t);
            try {
              i(t);
            } catch (e) {
              try {
                return i.call(null, t);
              } catch (e) {
                return i.call(this, t);
              }
            }
          })(t);
      }
    }
    function p(t, e) {
      (this.fun = t), (this.array = e);
    }
    function m() {}
    (r.nextTick = function (t) {
      var e = new Array(arguments.length - 1);
      if (arguments.length > 1)
        for (var n = 1; n < arguments.length; n++) e[n - 1] = arguments[n];
      l.push(new p(t, e)), 1 !== l.length || u || s(h);
    }),
      (p.prototype.run = function () {
        this.fun.apply(null, this.array);
      }),
      (r.title = "browser"),
      (r.browser = !0),
      (r.env = {}),
      (r.argv = []),
      (r.version = ""),
      (r.versions = {}),
      (r.on = m),
      (r.addListener = m),
      (r.once = m),
      (r.off = m),
      (r.removeListener = m),
      (r.removeAllListeners = m),
      (r.emit = m),
      (r.prependListener = m),
      (r.prependOnceListener = m),
      (r.listeners = function (t) {
        return [];
      }),
      (r.binding = function (t) {
        throw new Error("process.binding is not supported");
      }),
      (r.cwd = function () {
        return "/";
      }),
      (r.chdir = function (t) {
        throw new Error("process.chdir is not supported");
      }),
      (r.umask = function () {
        return 0;
      });
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    t.exports = function (t, e) {
      i.forEach(t, function (n, i) {
        i !== e &&
          i.toUpperCase() === e.toUpperCase() &&
          ((t[e] = n), delete t[i]);
      });
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(13);
    t.exports = function (t, e, n) {
      var r = n.config.validateStatus;
      n.status && r && !r(n.status)
        ? e(
            i(
              "Request failed with status code " + n.status,
              n.config,
              null,
              n.request,
              n
            )
          )
        : t(n);
    };
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t, e, n, i, r) {
      return (
        (t.config = e),
        n && (t.code = n),
        (t.request = i),
        (t.response = r),
        (t.isAxiosError = !0),
        (t.toJSON = function () {
          return {
            message: this.message,
            name: this.name,
            description: this.description,
            number: this.number,
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            config: this.config,
            code: this.code,
          };
        }),
        t
      );
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    t.exports = i.isStandardBrowserEnv()
      ? {
          write: function (t, e, n, r, o, a) {
            var s = [];
            s.push(t + "=" + encodeURIComponent(e)),
              i.isNumber(n) && s.push("expires=" + new Date(n).toGMTString()),
              i.isString(r) && s.push("path=" + r),
              i.isString(o) && s.push("domain=" + o),
              !0 === a && s.push("secure"),
              (document.cookie = s.join("; "));
          },
          read: function (t) {
            var e = document.cookie.match(
              new RegExp("(^|;\\s*)(" + t + ")=([^;]*)")
            );
            return e ? decodeURIComponent(e[3]) : null;
          },
          remove: function (t) {
            this.write(t, "", Date.now() - 864e5);
          },
        }
      : {
          write: function () {},
          read: function () {
            return null;
          },
          remove: function () {},
        };
  },
  function (t, e, n) {
    "use strict";
    var i = n(33),
      r = n(34);
    t.exports = function (t, e) {
      return t && !i(e) ? r(t, e) : e;
    };
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(t);
    };
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t, e) {
      return e ? t.replace(/\/+$/, "") + "/" + e.replace(/^\/+/, "") : t;
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0),
      r = [
        "age",
        "authorization",
        "content-length",
        "content-type",
        "etag",
        "expires",
        "from",
        "host",
        "if-modified-since",
        "if-unmodified-since",
        "last-modified",
        "location",
        "max-forwards",
        "proxy-authorization",
        "referer",
        "retry-after",
        "user-agent",
      ];
    t.exports = function (t) {
      var e,
        n,
        o,
        a = {};
      return t
        ? (i.forEach(t.split("\n"), function (t) {
            if (
              ((o = t.indexOf(":")),
              (e = i.trim(t.substr(0, o)).toLowerCase()),
              (n = i.trim(t.substr(o + 1))),
              e)
            ) {
              if (a[e] && r.indexOf(e) >= 0) return;
              a[e] =
                "set-cookie" === e
                  ? (a[e] ? a[e] : []).concat([n])
                  : a[e]
                  ? a[e] + ", " + n
                  : n;
            }
          }),
          a)
        : a;
    };
  },
  function (t, e, n) {
    "use strict";
    var i = n(0);
    t.exports = i.isStandardBrowserEnv()
      ? (function () {
          var t,
            e = /(msie|trident)/i.test(navigator.userAgent),
            n = document.createElement("a");
          function r(t) {
            var i = t;
            return (
              e && (n.setAttribute("href", i), (i = n.href)),
              n.setAttribute("href", i),
              {
                href: n.href,
                protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                host: n.host,
                search: n.search ? n.search.replace(/^\?/, "") : "",
                hash: n.hash ? n.hash.replace(/^#/, "") : "",
                hostname: n.hostname,
                port: n.port,
                pathname:
                  "/" === n.pathname.charAt(0) ? n.pathname : "/" + n.pathname,
              }
            );
          }
          return (
            (t = r(window.location.href)),
            function (e) {
              var n = i.isString(e) ? r(e) : e;
              return n.protocol === t.protocol && n.host === t.host;
            }
          );
        })()
      : function () {
          return !0;
        };
  },
  function (t, e, n) {
    "use strict";
    var i = n(15);
    function r(t) {
      if ("function" != typeof t)
        throw new TypeError("executor must be a function.");
      var e;
      this.promise = new Promise(function (t) {
        e = t;
      });
      var n = this;
      t(function (t) {
        n.reason || ((n.reason = new i(t)), e(n.reason));
      });
    }
    (r.prototype.throwIfRequested = function () {
      if (this.reason) throw this.reason;
    }),
      (r.source = function () {
        var t;
        return {
          token: new r(function (e) {
            t = e;
          }),
          cancel: t,
        };
      }),
      (t.exports = r);
  },
  function (t, e, n) {
    "use strict";
    t.exports = function (t) {
      return function (e) {
        return t.apply(null, e);
      };
    };
  },
  function (t, e, n) {
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var r = n(2),
      o = n(1),
      a = n(5);
    new ((function () {
      function t() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.$parent = document.querySelector(".as-cookie")),
          this.$parent &&
            ((this.$cookieOnly = this.$parent.querySelector(".as-cookie-only")),
            (window.cookie_only = !!this.$cookieOnly),
            (this.$cookieBar = this.$parent.querySelector(".as-cookie-bar")),
            (this.$cookiePopup =
              this.$parent.querySelector(".as-cookie-popup")),
            (this.$asd = document.querySelector("#as-show-cookie-popup")),
            (window.COOKIE_ONLY_NAME = "cookieonly"),
            (this.COOKIE_NAME = "sectioncookie"),
            this.init());
      }
      var e, n, s;
      return (
        (e = t),
        (n = [
          {
            key: "init",
            value: function () {
              this.handleShowBar(), this.bindCookiePopup(), this.isAcceptAll();
            },
          },
          {
            key: "bindCookiePopup",
            value: function () {
              var t = this;
              this.$asd &&
                this.$asd.addEventListener("click", function () {
                  (t.cookiePopup = new a.Modal(
                    document.getElementById("as-cookie-popup"),
                    { keyboard: !1 }
                  )),
                    t.handleHoganRending(
                      "cookie-popup",
                      t.$parent.querySelector(".as-cookie-popup-dialog")
                    ),
                    t.cookiePopup.show(),
                    t.closeCookiePopup(),
                    t.handleAcceptAll(),
                    t.handleRequiredOnly();
                });
            },
          },
          {
            key: "handleShowBar",
            value: function () {
              void 0 === o.get(window.COOKIE_ONLY_NAME) &&
                void 0 === o.get(this.COOKIE_NAME) &&
                this.showCookieBar();
            },
          },
          {
            key: "closeCookieBar",
            value: function () {
              var t = this;
              (this.$closeBtn = this.$parent.querySelectorAll(
                ".as-close-cookie-bar"
              )),
                Array.from(this.$closeBtn).map(function (e) {
                  e.addEventListener("click", function () {
                    t.$cookieBar.classList.remove("is-active");
                  });
                });
            },
          },
          {
            key: "showCookieBar",
            value: function () {
              this.handleHoganRending("cookie-bar", this.$cookieBar),
                this.$cookieBar.classList.add("is-active"),
                this.handleRecordingSectionCookie(),
                this.closeCookieBar(),
                this.showCookiePopup(),
                this.handleAcceptAll();
            },
          },
          {
            key: "handleRecordingSectionCookie",
            value: function () {
              var t = this;
              (this.$recordingSectionCookie = this.$parent.querySelectorAll(
                ".as-recording-section-cookie"
              )),
                Array.from(this.$recordingSectionCookie).map(function (e) {
                  e.addEventListener("click", function () {
                    o.set(t.COOKIE_NAME, !0, {
                      domain: window.location.hostname,
                    });
                  });
                });
            },
          },
          {
            key: "showCookiePopup",
            value: function () {
              var t = this;
              (this.$popupEntrance = this.$parent.querySelector(
                ".as-cookie-popup-entrance"
              )),
                (this.cookiePopup = new a.Modal(
                  document.getElementById("as-cookie-popup"),
                  { keyboard: !1 }
                )),
                this.$popupEntrance &&
                  this.$popupEntrance.addEventListener("click", function () {
                    t.handleHoganRending(
                      "cookie-popup",
                      t.$parent.querySelector(".as-cookie-popup-dialog")
                    ),
                      t.cookiePopup.show(),
                      t.closeCookiePopup(),
                      t.handleAcceptAll(),
                      t.handleRequiredOnly();
                  });
            },
          },
          {
            key: "closeCookiePopup",
            value: function () {
              var t = this;
              (this.$closePopup = this.$parent.querySelectorAll(
                ".as-close-cookie-popup"
              )),
                Array.from(this.$closePopup).map(function (e) {
                  e.addEventListener("click", function () {
                    t.cookiePopup.hide();
                  });
                });
            },
          },
          {
            key: "handleAcceptAll",
            value: function () {
              var t = this;
              (this.$acceptAll = this.$parent.querySelectorAll(
                ".as-cookie-accept-all"
              )),
                Array.from(this.$acceptAll).map(function (e) {
                  e.addEventListener("click", function () {
                    o.set(window.COOKIE_ONLY_NAME, !1, {
                      domain: window.location.hostname,
                      expires: 365,
                    }),
                      window.Shopify.customerPrivacy.setTrackingConsent(
                        !0,
                        t.acceptCallback.bind(t)
                      ),
                      document.addEventListener(
                        "trackingConsentAccepted",
                        function () {
                          console.log("trackingConsentAccepted event fired");
                        }
                      ),
                      document
                        .querySelectorAll(".as-ico-is-checked")
                        .forEach(function (t) {
                          t.classList.remove("ico-unchecked"),
                            t.classList.add("ico-checked");
                        });
                  });
                });
            },
          },
          { key: "acceptCallback", value: function () {} },
          { key: "refuseCallback", value: function () {} },
          {
            key: "handleRequiredOnly",
            value: function () {
              var t = this;
              (this.$requiredOnly = this.$parent.querySelector(
                ".as-cookie-required-only"
              )),
                this.$requiredOnly &&
                  this.$requiredOnly.addEventListener("click", function () {
                    o.set(window.COOKIE_ONLY_NAME, !0, {
                      domain: window.location.hostname,
                      expires: 365,
                    }),
                      window.Shopify.customerPrivacy.setTrackingConsent(
                        !1,
                        t.refuseCallback.bind(t)
                      ),
                      document
                        .querySelectorAll(".as-ico-is-checked")
                        .forEach(function (t) {
                          t.classList.remove("ico-checked"),
                            t.classList.add("ico-unchecked");
                        });
                  });
            },
          },
          {
            key: "handleIfRefresh",
            value: function (t) {
              !!t == !this.$cookieOnly &&
                (window.location.href = window.location.href);
            },
          },
          {
            key: "handleHoganRending",
            value: function (t, e) {
              var n = document.querySelector("#tpl-".concat(t));
              if (!n) return !1;
              var i = r.compile(n.innerHTML, { delimiters: "@{ }@" });
              e.innerHTML = i.render();
            },
          },
          {
            key: "isAcceptAll",
            value: function () {
              "false" === o.get(window.COOKIE_ONLY_NAME) &&
                document
                  .querySelectorAll(".as-ico-is-checked")
                  .forEach(function (t) {
                    t.classList.remove("ico-unchecked"),
                      t.classList.add("ico-checked");
                  }),
                "true" === o.get(window.COOKIE_ONLY_NAME) &&
                  document
                    .querySelectorAll(".as-ico-is-checked")
                    .forEach(function (t) {
                      t.classList.add("ico-unchecked"),
                        t.classList.remove("ico-checked");
                    });
            },
          },
        ]) && i(e.prototype, n),
        s && i(e, s),
        t
      );
    })())();
  },
  function (t, e, n) {
    !(function (t) {
      var e = /\S/,
        n = /\"/g,
        i = /\n/g,
        r = /\r/g,
        o = /\\/g,
        a = /\u2028/,
        s = /\u2029/;
      function c(t) {
        "}" === t.n.substr(t.n.length - 1) &&
          (t.n = t.n.substring(0, t.n.length - 1));
      }
      function l(t) {
        return t.trim ? t.trim() : t.replace(/^\s*|\s*$/g, "");
      }
      function u(t, e, n) {
        if (e.charAt(n) != t.charAt(0)) return !1;
        for (var i = 1, r = t.length; i < r; i++)
          if (e.charAt(n + i) != t.charAt(i)) return !1;
        return !0;
      }
      (t.tags = {
        "#": 1,
        "^": 2,
        "<": 3,
        $: 4,
        "/": 5,
        "!": 6,
        ">": 7,
        "=": 8,
        _v: 9,
        "{": 10,
        "&": 11,
        _t: 12,
      }),
        (t.scan = function (n, i) {
          var r = n.length,
            o = 0,
            a = null,
            s = null,
            d = "",
            f = [],
            h = !1,
            p = 0,
            m = 0,
            g = "{{",
            v = "}}";
          function y() {
            d.length > 0 &&
              (f.push({ tag: "_t", text: new String(d) }), (d = ""));
          }
          function b(n, i) {
            if (
              (y(),
              n &&
                (function () {
                  for (var n = !0, i = m; i < f.length; i++)
                    if (
                      !(n =
                        t.tags[f[i].tag] < t.tags._v ||
                        ("_t" == f[i].tag && null === f[i].text.match(e)))
                    )
                      return !1;
                  return n;
                })())
            )
              for (var r, o = m; o < f.length; o++)
                f[o].text &&
                  ((r = f[o + 1]) &&
                    ">" == r.tag &&
                    (r.indent = f[o].text.toString()),
                  f.splice(o, 1));
            else i || f.push({ tag: "\n" });
            (h = !1), (m = f.length);
          }
          function _(t, e) {
            var n = "=" + v,
              i = t.indexOf(n, e),
              r = l(t.substring(t.indexOf("=", e) + 1, i)).split(" ");
            return (g = r[0]), (v = r[r.length - 1]), i + n.length - 1;
          }
          for (
            i && ((i = i.split(" ")), (g = i[0]), (v = i[1])), p = 0;
            p < r;
            p++
          )
            0 == o
              ? u(g, n, p)
                ? (--p, y(), (o = 1))
                : "\n" == n.charAt(p)
                ? b(h)
                : (d += n.charAt(p))
              : 1 == o
              ? ((p += g.length - 1),
                "=" ==
                (a = (s = t.tags[n.charAt(p + 1)]) ? n.charAt(p + 1) : "_v")
                  ? ((p = _(n, p)), (o = 0))
                  : (s && p++, (o = 2)),
                (h = p))
              : u(v, n, p)
              ? (f.push({
                  tag: a,
                  n: l(d),
                  otag: g,
                  ctag: v,
                  i: "/" == a ? h - g.length : p + v.length,
                }),
                (d = ""),
                (p += v.length - 1),
                (o = 0),
                "{" == a && ("}}" == v ? p++ : c(f[f.length - 1])))
              : (d += n.charAt(p));
          return b(h, !0), f;
        });
      var d = { _t: !0, "\n": !0, $: !0, "/": !0 };
      function f(t, e) {
        for (var n = 0, i = e.length; n < i; n++)
          if (e[n].o == t.n) return (t.tag = "#"), !0;
      }
      function h(t, e, n) {
        for (var i = 0, r = n.length; i < r; i++)
          if (n[i].c == t && n[i].o == e) return !0;
      }
      function p(t) {
        var e = [];
        for (var n in t.partials)
          e.push(
            '"' +
              g(n) +
              '":{name:"' +
              g(t.partials[n].name) +
              '", ' +
              p(t.partials[n]) +
              "}"
          );
        return (
          "partials: {" +
          e.join(",") +
          "}, subs: " +
          (function (t) {
            var e = [];
            for (var n in t)
              e.push('"' + g(n) + '": function(c,p,t,i) {' + t[n] + "}");
            return "{ " + e.join(",") + " }";
          })(t.subs)
        );
      }
      t.stringify = function (e, n, i) {
        return (
          "{code: function (c,p,i) { " + t.wrapMain(e.code) + " }," + p(e) + "}"
        );
      };
      var m = 0;
      function g(t) {
        return t
          .replace(o, "\\\\")
          .replace(n, '\\"')
          .replace(i, "\\n")
          .replace(r, "\\r")
          .replace(a, "\\u2028")
          .replace(s, "\\u2029");
      }
      function v(t) {
        return ~t.indexOf(".") ? "d" : "f";
      }
      function y(t, e) {
        var n = "<" + (e.prefix || "") + t.n + m++;
        return (
          (e.partials[n] = { name: t.n, partials: {} }),
          (e.code +=
            't.b(t.rp("' + g(n) + '",c,p,"' + (t.indent || "") + '"));'),
          n
        );
      }
      function b(t, e) {
        e.code += "t.b(t.t(t." + v(t.n) + '("' + g(t.n) + '",c,p,0)));';
      }
      function _(t) {
        return "t.b(" + t + ");";
      }
      (t.generate = function (e, n, i) {
        m = 0;
        var r = { code: "", subs: {}, partials: {} };
        return (
          t.walk(e, r),
          i.asString ? this.stringify(r, n, i) : this.makeTemplate(r, n, i)
        );
      }),
        (t.wrapMain = function (t) {
          return 'var t=this;t.b(i=i||"");' + t + "return t.fl();";
        }),
        (t.template = t.Template),
        (t.makeTemplate = function (t, e, n) {
          var i = this.makePartials(t);
          return (
            (i.code = new Function("c", "p", "i", this.wrapMain(t.code))),
            new this.template(i, e, this, n)
          );
        }),
        (t.makePartials = function (t) {
          var e,
            n = { subs: {}, partials: t.partials, name: t.name };
          for (e in n.partials)
            n.partials[e] = this.makePartials(n.partials[e]);
          for (e in t.subs)
            n.subs[e] = new Function("c", "p", "t", "i", t.subs[e]);
          return n;
        }),
        (t.codegen = {
          "#": function (e, n) {
            (n.code +=
              "if(t.s(t." +
              v(e.n) +
              '("' +
              g(e.n) +
              '",c,p,1),c,p,0,' +
              e.i +
              "," +
              e.end +
              ',"' +
              e.otag +
              " " +
              e.ctag +
              '")){t.rs(c,p,function(c,p,t){'),
              t.walk(e.nodes, n),
              (n.code += "});c.pop();}");
          },
          "^": function (e, n) {
            (n.code +=
              "if(!t.s(t." +
              v(e.n) +
              '("' +
              g(e.n) +
              '",c,p,1),c,p,1,0,0,"")){'),
              t.walk(e.nodes, n),
              (n.code += "};");
          },
          ">": y,
          "<": function (e, n) {
            var i = { partials: {}, code: "", subs: {}, inPartial: !0 };
            t.walk(e.nodes, i);
            var r = n.partials[y(e, n)];
            (r.subs = i.subs), (r.partials = i.partials);
          },
          $: function (e, n) {
            var i = { subs: {}, code: "", partials: n.partials, prefix: e.n };
            t.walk(e.nodes, i),
              (n.subs[e.n] = i.code),
              n.inPartial || (n.code += 't.sub("' + g(e.n) + '",c,p,i);');
          },
          "\n": function (t, e) {
            e.code += _('"\\n"' + (t.last ? "" : " + i"));
          },
          _v: function (t, e) {
            e.code += "t.b(t.v(t." + v(t.n) + '("' + g(t.n) + '",c,p,0)));';
          },
          _t: function (t, e) {
            e.code += _('"' + g(t.text) + '"');
          },
          "{": b,
          "&": b,
        }),
        (t.walk = function (e, n) {
          for (var i, r = 0, o = e.length; r < o; r++)
            (i = t.codegen[e[r].tag]) && i(e[r], n);
          return n;
        }),
        (t.parse = function (e, n, i) {
          return (function e(n, i, r, o) {
            var a,
              s = [],
              c = null,
              l = null;
            for (a = r[r.length - 1]; n.length > 0; ) {
              if (((l = n.shift()), a && "<" == a.tag && !(l.tag in d)))
                throw new Error("Illegal content in < super tag.");
              if (t.tags[l.tag] <= t.tags.$ || f(l, o))
                r.push(l), (l.nodes = e(n, l.tag, r, o));
              else {
                if ("/" == l.tag) {
                  if (0 === r.length)
                    throw new Error("Closing tag without opener: /" + l.n);
                  if (((c = r.pop()), l.n != c.n && !h(l.n, c.n, o)))
                    throw new Error("Nesting error: " + c.n + " vs. " + l.n);
                  return (c.end = l.i), s;
                }
                "\n" == l.tag && (l.last = 0 == n.length || "\n" == n[0].tag);
              }
              s.push(l);
            }
            if (r.length > 0)
              throw new Error("missing closing tag: " + r.pop().n);
            return s;
          })(e, 0, [], (i = i || {}).sectionTags || []);
        }),
        (t.cache = {}),
        (t.cacheKey = function (t, e) {
          return [
            t,
            !!e.asString,
            !!e.disableLambda,
            e.delimiters,
            !!e.modelGet,
          ].join("||");
        }),
        (t.compile = function (e, n) {
          n = n || {};
          var i = t.cacheKey(e, n),
            r = this.cache[i];
          if (r) {
            var o = r.partials;
            for (var a in o) delete o[a].instance;
            return r;
          }
          return (
            (r = this.generate(
              this.parse(this.scan(e, n.delimiters), e, n),
              e,
              n
            )),
            (this.cache[i] = r)
          );
        });
    })(e);
  },
  function (t, e, n) {
    !(function (t) {
      function e(t, e, n) {
        var i;
        return (
          e &&
            "object" == typeof e &&
            (void 0 !== e[t]
              ? (i = e[t])
              : n && e.get && "function" == typeof e.get && (i = e.get(t))),
          i
        );
      }
      (t.Template = function (t, e, n, i) {
        (t = t || {}),
          (this.r = t.code || this.r),
          (this.c = n),
          (this.options = i || {}),
          (this.text = e || ""),
          (this.partials = t.partials || {}),
          (this.subs = t.subs || {}),
          (this.buf = "");
      }),
        (t.Template.prototype = {
          r: function (t, e, n) {
            return "";
          },
          v: function (t) {
            return (
              (t = c(t)),
              s.test(t)
                ? t
                    .replace(n, "&amp;")
                    .replace(i, "&lt;")
                    .replace(r, "&gt;")
                    .replace(o, "&#39;")
                    .replace(a, "&quot;")
                : t
            );
          },
          t: c,
          render: function (t, e, n) {
            return this.ri([t], e || {}, n);
          },
          ri: function (t, e, n) {
            return this.r(t, e, n);
          },
          ep: function (t, e) {
            var n = this.partials[t],
              i = e[n.name];
            if (n.instance && n.base == i) return n.instance;
            if ("string" == typeof i) {
              if (!this.c) throw new Error("No compiler available.");
              i = this.c.compile(i, this.options);
            }
            if (!i) return null;
            if (((this.partials[t].base = i), n.subs)) {
              for (key in (e.stackText || (e.stackText = {}), n.subs))
                e.stackText[key] ||
                  (e.stackText[key] =
                    void 0 !== this.activeSub && e.stackText[this.activeSub]
                      ? e.stackText[this.activeSub]
                      : this.text);
              i = (function (t, e, n, i, r, o) {
                function a() {}
                function s() {}
                var c;
                (a.prototype = t), (s.prototype = t.subs);
                var l = new a();
                for (c in ((l.subs = new s()),
                (l.subsText = {}),
                (l.buf = ""),
                (i = i || {}),
                (l.stackSubs = i),
                (l.subsText = o),
                e))
                  i[c] || (i[c] = e[c]);
                for (c in i) l.subs[c] = i[c];
                for (c in ((r = r || {}), (l.stackPartials = r), n))
                  r[c] || (r[c] = n[c]);
                for (c in r) l.partials[c] = r[c];
                return l;
              })(
                i,
                n.subs,
                n.partials,
                this.stackSubs,
                this.stackPartials,
                e.stackText
              );
            }
            return (this.partials[t].instance = i), i;
          },
          rp: function (t, e, n, i) {
            var r = this.ep(t, n);
            return r ? r.ri(e, n, i) : "";
          },
          rs: function (t, e, n) {
            var i = t[t.length - 1];
            if (l(i))
              for (var r = 0; r < i.length; r++)
                t.push(i[r]), n(t, e, this), t.pop();
            else n(t, e, this);
          },
          s: function (t, e, n, i, r, o, a) {
            var s;
            return (
              (!l(t) || 0 !== t.length) &&
              ("function" == typeof t && (t = this.ms(t, e, n, i, r, o, a)),
              (s = !!t),
              !i &&
                s &&
                e &&
                e.push("object" == typeof t ? t : e[e.length - 1]),
              s)
            );
          },
          d: function (t, n, i, r) {
            var o,
              a = t.split("."),
              s = this.f(a[0], n, i, r),
              c = this.options.modelGet,
              u = null;
            if ("." === t && l(n[n.length - 2])) s = n[n.length - 1];
            else
              for (var d = 1; d < a.length; d++)
                void 0 !== (o = e(a[d], s, c)) ? ((u = s), (s = o)) : (s = "");
            return (
              !(r && !s) &&
              (r ||
                "function" != typeof s ||
                (n.push(u), (s = this.mv(s, n, i)), n.pop()),
              s)
            );
          },
          f: function (t, n, i, r) {
            for (
              var o = !1, a = !1, s = this.options.modelGet, c = n.length - 1;
              c >= 0;
              c--
            )
              if (void 0 !== (o = e(t, n[c], s))) {
                a = !0;
                break;
              }
            return a
              ? (r || "function" != typeof o || (o = this.mv(o, n, i)), o)
              : !r && "";
          },
          ls: function (t, e, n, i, r) {
            var o = this.options.delimiters;
            return (
              (this.options.delimiters = r),
              this.b(this.ct(c(t.call(e, i)), e, n)),
              (this.options.delimiters = o),
              !1
            );
          },
          ct: function (t, e, n) {
            if (this.options.disableLambda)
              throw new Error("Lambda features disabled.");
            return this.c.compile(t, this.options).render(e, n);
          },
          b: function (t) {
            this.buf += t;
          },
          fl: function () {
            var t = this.buf;
            return (this.buf = ""), t;
          },
          ms: function (t, e, n, i, r, o, a) {
            var s,
              c = e[e.length - 1],
              l = t.call(c);
            return "function" == typeof l
              ? !!i ||
                  ((s =
                    this.activeSub &&
                    this.subsText &&
                    this.subsText[this.activeSub]
                      ? this.subsText[this.activeSub]
                      : this.text),
                  this.ls(l, c, n, s.substring(r, o), a))
              : l;
          },
          mv: function (t, e, n) {
            var i = e[e.length - 1],
              r = t.call(i);
            return "function" == typeof r ? this.ct(c(r.call(i)), i, n) : r;
          },
          sub: function (t, e, n, i) {
            var r = this.subs[t];
            r &&
              ((this.activeSub = t), r(e, n, this, i), (this.activeSub = !1));
          },
        });
      var n = /&/g,
        i = /</g,
        r = />/g,
        o = /\'/g,
        a = /\"/g,
        s = /[&<>\"\']/;
      function c(t) {
        return String(null == t ? "" : t);
      }
      var l =
        Array.isArray ||
        function (t) {
          return "[object Array]" === Object.prototype.toString.call(t);
        };
    })(e);
  },
  function (t, e, n) {
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    n(2), n(5);
    var r = n(1),
      o = n(43),
      a = n(16).handleHoganRending;
    new ((function () {
      function t() {
        if (
          ((function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
          (this.$parent = document.querySelector("#as-choose-country")),
          this.$parent)
        ) {
          (this.COOKIE_NAME = "storename"),
            (this.SEPARATE = "&&&"),
            (this.ALLSTORE = "fr&de&en-uk");
          var e = "https://store-na.hasselblad.com/",
            n = "https://store-eu.hasselblad.com/",
            rr  = 'https://store-jp.hasselblad.com/',
            ac = 'https://store-apac.hasselblad.com/';
          e.includes(window.location.origin)
            ? (console.log("United States"),
              (this.DEFAULT_STORE = "United States"))
            : n.includes(window.location.origin)
            ? (console.log("Österreich"), (this.DEFAULT_STORE = "Österreich"))
            : "https://store-uk.hasselblad.com/".includes(
                window.location.origin
              )
            ? ((this.DEFAULT_STORE = "United Kingdom"),
              console.log("United Kingdom"))
            : ((this.DEFAULT_STORE = "United States"),
              console.log("United States2")),
            (this.$headerCountry = document.querySelector(
              ".as-country-header-name"
            )),
            // (this.$headerCountry.innerHTML = this.DEFAULT_STORE),
            (this.countryJson = {
              data: [
                {
                  continent: "Americas",
                  country: [
                    {
                      name: "United States",
                      currency: "USD",
                      language: "English / $ USD",
                      link: "",
                      code: 'US',
                      locale: 'en',
                      domain: e,
                    },
                    {
                      name: "Canada",
                      currency: "USD",
                      language: "English / $ USD",
                      link: "",
                      locale: 'en',
                      code: 'CA',
                      domain: e,
                    },
                    {
                      name: "Canada",
                      currency: "USD",
                      language: "Français / $ USD",
                      link: "/fr",
                      locale: 'fr',
                      code: 'CA',
                      domain: e,
                    },
                  ],
                },
                {
                  continent: "Asia Pacific",
                  country: [
                    {
                      name: "日本",
                      currency: "JPY",
                      language: "日本語/¥JPY",
                      link: "/ja-jp",
                      locale: 'ja',
                      code: 'JA',
                      domain: rr,
                    },
                    {
                      name: "香港",
                      currency: "HKD",
                      language: "繁體中文/HK$ HKD",
                      link: "/zh-hk",
                      locale: 'zh-TW',
                      code: 'HKD',
                      domain: ac,
                    },
                    {
                      name: "台灣",
                      currency: "TWD",
                      language: "繁體中文 / NT$ TWD",
                      link: "/zh-tw",
                      locale: 'zh-TW',
                      code: 'TWD',
                      domain: ac,
                    },
                    {
                      name: "Singapore",
                      currency: "SGD",
                      language: "English / S$ SGD",
                      link: "/en-sg",
                      locale: 'en',
                      code: 'SGD',
                      domain: ac,
                    },
                    {
                      name: "Australia",
                      currency: "AUD",
                      language: "English / $ AUD",
                      link: "/en-au",
                      locale: 'en',
                      code: 'AUD',
                      domain: ac,
                    },
                    {
                      name: "한국",
                      currency: "KRW",
                      language: "한국어 / ₩ KRW",
                      link: "/ko-kr",
                      locale: 'ko',
                      code: 'KRW',
                      domain: ac,
                    }
                  ]
                },
                {
                  continent: "Europe",
                  country: [
                    {
                      name: "United Kingdom",
                      currency: "GBP",
                      language: "English / £ GBP",
                      link: "/en-uk",
                      locale: 'en',
                      code: 'GB',
                      domain: n,
                    },
                    {
                      name: "Österreich",
                      currency: "EUR",
                      language: "Deutsch / € EUR",
                      link: "/de",
                      locale: 'de',
                      code: 'AT',
                      domain: n,
                    },
                    {
                      name: "Belgium",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'BE',
                      domain: n,
                    },
                    {
                      name: "Bulgaria",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'BG',
                      domain: n,
                    },
                    {
                      name: "Cyprus",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'CY',
                      domain: n,
                    },
                    {
                      name: "Croatia",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'HR',
                      domain: n,
                    },
                    {
                      name: "Czech Republic",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'CZ',
                      domain: n,
                    },
                    {
                      name: "Denmark",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'DK',
                      domain: n,
                    },
                    {
                      name: "Deutschland",
                      currency: "EUR",
                      language: "Deutsch / € EUR",
                      link: "/de",
                      locale: 'de',
                      code: 'DE',
                      domain: n,
                    },
                    {
                      name: "Estonia",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'EE',
                      domain: n,
                    },
                    {
                      name: "Finland",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'FI',
                      domain: n,
                    },
                    {
                      name: "France",
                      currency: "EUR",
                      language: "Français / € EUR",
                      link: "/fr",
                      locale: 'fr',
                      code: 'FR',
                      domain: n,
                    },
                    {
                      name: "Greece",
                      currency: "EUR",
                      language: "Français / € EUR",
                      link: "/fr",
                      locale: 'fr',
                      code: 'GR',
                      domain: n,
                    },
                    {
                      name: "Hungary",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'HU',
                      domain: n,
                    },
                    {
                      name: "Ireland",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'IE',
                      domain: n,
                    },
                    {
                      name: "Italy",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'IT',
                      domain: n,
                    },
                    {
                      name: "Latvia",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'LV',
                      domain: n,
                    },
                    {
                      name: "Lithuania",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'LT',
                      domain: n,
                    },
                    {
                      name: "Luxembourg",
                      currency: "EUR",
                      language: "Français / € EUR",
                      link: "/fr",
                      locale: 'fr',
                      code: 'LU',
                      domain: n,
                    },
                    {
                      name: "Malta",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'MT',
                      domain: n,
                    },
                    {
                      name: "Netherlands",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'NL',
                      domain: n,
                    },
                    {
                      name: "Poland",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'PL',
                      domain: n,
                    },
                    {
                      name: "Portugal",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'PT',
                      domain: n,
                    },
                    {
                      name: "Romania",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'RO',
                      domain: n,
                    },
                    {
                      name: "Slovakia",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'SK',
                      domain: n,
                    },
                    {
                      name: "Slovenia",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'SI',
                      domain: n,
                    },
                    {
                      name: "España",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'ES',
                      domain: n,
                    },
                    {
                      name: "Sweden",
                      currency: "EUR",
                      language: "English / € EUR",
                      link: "",
                      locale: 'en',
                      code: 'SE',
                      domain: n,
                    },
                  ],
                }
              ],
            }),
            this.init();
        }
      }
      var e, n, s;
      return (
        (e = t),
        (n = [
          {
            key: "init",
            value: function () {
              this.renderCountryOptions(),
                this.handleCookie(),
                this.bindChooseCountry();
            },
          },
          {
            key: "renderCountryOptions",
            value: function () {
              a("choose-country", this.countryJson);
            },
          },
          {
            key: "handleCookie",
            value: function () {
              var t = this.COOKIE_NAME && r.get(this.COOKIE_NAME);
              if (t) {
                var e = t.split(this.SEPARATE)[0] || this.DEFAULT_STORE;
                // this.$headerCountry.innerHTML = e;
                var n = t.split(this.SEPARATE)[1],
                  i = window.location.pathname,
                  o = window.location.origin,
                  a = window.location.search,
                  s =
                    i.length <= 1
                      ? ""
                      : this.ALLSTORE.includes(i.split("/")[1])
                      ? i.split("/")[1]
                      : "";
                if (n != s) {
                  var c =
                    0 == s.length
                      ? "".concat(o, "/").concat(n).concat(i).concat(a)
                      : ""
                          .concat(o, "/")
                          .concat(n, "/")
                          .concat(i.split("/").slice(2).join("/"))
                          .concat(a);
                  // (c = c.replace(/\/\//g, "/").replace("/", "//")),
                  //   (window.location.href = c);
                }
              }
            },
          },
          {
            key: "bindChooseCountry",
            value: function () {
              var t = this;
              (this.$list = this.$parent.querySelectorAll(".as-country-list")),
                Array.from(this.$list).map(function (e) {
                  e.addEventListener("click", function () {
                    var n,
                      i = e.dataset,
                      o = ""
                        .concat(null == i ? void 0 : i.country)
                        .concat(t.SEPARATE)
                        .concat(null == i ? void 0 : i.store)
                        .replace(/\//g, "");
                        localStorage.setItem('country', i.country);
                    t.COOKIE_NAME &&
                      r.set(t.COOKIE_NAME, o, {
                        domain: ".hasselblad.com",
                        expires: 365,
                      });
                    var a = document.querySelector("#currency_form"),
                      s = a.querySelector("#currency_value");
                    s &&
                      (s.value =
                        null === (n = e.dataset) || void 0 === n
                          ? void 0
                          : n.currency);
                    var c = null == i ? void 0 : i.href;
                    (c = c.replace(/\/\//g, "/").replace("/", "//")),
                    t.changeCurrency(a, c, i);
                  });
                });
            },
          },
          {
            key: "changeCurrency",
            value: function (t, e, j) {
              if (t) {
                var n = o(t),
                  i = new window.XMLHttpRequest();
                i.open("POST", "/cart/update.js"),
                  i.setRequestHeader(
                    "Content-Type",
                    "multipart/form-data; charset=UTF-8"
                  ),
                  (i.onload = function () {
                    if (200 === i.status && i.responseText) {
                      if (j.domain.includes(window.location.hostname)) {
                        document.querySelector('#my-localization [name=country_code]').value = j.code;
                        document.querySelector('#my-localization [name=locale_code]').value = j.locale;
                        var localizationForm = document.querySelector('#my-localization');
                        if (window.ImpactReferral) {
                          var returnTo = localizationForm.querySelector('[name=return_to]');
                          var returnUrl = new URL(window.ImpactReferral.decorateUrl(
                            returnTo && returnTo.value ? returnTo.value : window.location.href
                          ), window.location.origin);
                          if (returnUrl.origin === window.location.origin && returnUrl.searchParams.has('im_ref')) {
                            if (!returnTo) {
                              returnTo = document.createElement('input');
                              returnTo.type = 'hidden';
                              returnTo.name = 'return_to';
                              localizationForm.appendChild(returnTo);
                            }
                            returnTo.value = returnUrl.pathname + returnUrl.search + returnUrl.hash;
                          }
                        }
                        document.querySelector('#my-localization').submit();
                      } else {
                        var destination = j.domain + j.store.replace('/', '');
                        window.location.href = window.ImpactReferral
                          ? window.ImpactReferral.decorateUrl(destination)
                          : destination;
                      }
                    }
                  }),
                  i.send(decodeURI(n));
              }
            },
          },
        ]) && i(e.prototype, n),
        s && i(e, s),
        t
      );
    })())();
  },
  function (t, e) {
    t.exports = function (t) {
      if (t && "FORM" === t.nodeName) {
        var e,
          n,
          i = [];
        for (e = t.elements.length - 1; e >= 0; e -= 1)
          if ("" !== t.elements[e].name)
            switch (t.elements[e].nodeName) {
              case "INPUT":
                switch (t.elements[e].type) {
                  case "text":
                  case "email":
                  case "hidden":
                  case "password":
                  case "button":
                  case "reset":
                  case "submit":
                  case "number":
                    i.push(
                      t.elements[e].name +
                        "=" +
                        encodeURIComponent(t.elements[e].value)
                    );
                    break;
                  case "checkbox":
                  case "radio":
                    t.elements[e].checked &&
                      i.push(
                        t.elements[e].name +
                          "=" +
                          encodeURIComponent(t.elements[e].value)
                      );
                }
                break;
              case "TEXTAREA":
                i.push(
                  t.elements[e].name +
                    "=" +
                    encodeURIComponent(t.elements[e].value)
                );
                break;
              case "SELECT":
                switch (t.elements[e].type) {
                  case "select-one":
                    i.push(
                      t.elements[e].name +
                        "=" +
                        encodeURIComponent(t.elements[e].value)
                    );
                    break;
                  case "select-multiple":
                    for (n = t.elements[e].options.length - 1; n >= 0; n -= 1)
                      t.elements[e].options[n].selected &&
                        i.push(
                          t.elements[e].name +
                            "=" +
                            encodeURIComponent(t.elements[e].options[n].value)
                        );
                }
                break;
              case "BUTTON":
                switch (t.elements[e].type) {
                  case "reset":
                  case "submit":
                  case "button":
                    i.push(
                      t.elements[e].name +
                        "=" +
                        encodeURIComponent(t.elements[e].value)
                    );
                }
            }
        return i.join("&");
      }
    };
  },
  function (t, e, n) {
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var r = n(2),
      o = n(1);
    new ((function () {
      function t() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.$parent = document.querySelector(".as-announcement-bar")),
          this.$parent && ((this.COOKIE_NAME = "announcement"), this.init());
      }
      var e, n, a;
      return (
        (e = t),
        (n = [
          {
            key: "init",
            value: function () {
              this.handleCookie();
            },
          },
          {
            key: "handleCookie",
            value: function () {
              o.get(this.COOKIE_NAME) || this.show();
            },
          },
          {
            key: "show",
            value: function () {
              this.handleHoganRending("announcement-bar"),
                this.$parent.classList.add("is-active"),
                this.bindClose();
            },
          },
          {
            key: "bindClose",
            value: function () {
              var t = this;
              (this.$close = this.$parent.querySelector(
                ".as-announcement-close"
              )),
                this.$close &&
                  this.$close.addEventListener("click", function () {
                    t.$parent.classList.remove("is-active"),
                      o.set(t.COOKIE_NAME, !0, {
                        domain: window.location.hostname,
                      });
                  });
            },
          },
          {
            key: "handleHoganRending",
            value: function (t, e) {
              var n = document.querySelector("#tpl-".concat(t));
              if (!n) return !1;
              var i = r.compile(n.innerHTML, { delimiters: "@{ }@" });
              this.$parent.innerHTML = i.render(e);
            },
          },
        ]) && i(e.prototype, n),
        a && i(e, a),
        t
      );
    })())();
  },
  function (t, e) {
    document.addEventListener("DOMContentLoaded", function () {
      document.body.classList.remove("invisible"),
        document.querySelector(".as-page-loading") &&
          document.querySelector(".as-page-loading").classList.add("hidden"),
        document.querySelector(".as-page-loading") &&
          document.querySelector(".as-page-loading").remove();
    });
  },
  function (t, e, n) {
    var i,
      r,
      o,
      a = n(6),
      s = n(17),
      c = n(3).default,
      l = n(47),
      u = n(2),
      d = document.getElementById("site-cart"),
      f = d && d.querySelector(".as-cart-items-list"),
      h = d && d.querySelector(".as-cart-summary"),
       sectionId = d.dataset.sectionId;
    function p(t) {
      var e = (function (t) {
          let items = [];
          for (var e, n = 0; n < t.items.length; n++){
            e = t.items[n];
        
            if (e.final_line_price > 0) {
              let discount = e.line_level_discount_allocations;
              let discount_name = discount.length > 0 ? discount[0].discount_application.title : '';
              let isHaveGift = false;
              let arr = []
              for (var i, j = 0; j < t.items.length; j++){
                i = t.items[j];
                let discount = i.line_level_discount_allocations;
                let discount_chlld = discount.length > 0 ? discount[0].discount_application.title : '';
                if (i.final_line_price == 0 && discount_name == discount_chlld) {
                  i.class = "cart-gift-item";
                  i.isGift = true;
                  i.colspan = 2;
                  i.gap = 2;
                  i.gift_key = e.key
                  arr.push(i);
                  isHaveGift = true;
                }
              }
              if (isHaveGift) {
                e.class = "cart-item cart-item-gifts";
              } else {
                e.class = "cart-item";
              }
              e.isGift = false;
              e.colspan = 1;
              e.gap = 4;

              items.push(e);
              arr.forEach(j => {
                items.push(j);
              })
            }
          }

          for (var e, n = 0; n < items.length; n++) {
            e = items[n];
            e.gtm_item_id = e.sku || String(e.product_id);
            e.gtm_item_name = e.product_title || "";
            e.gtm_currency = t.currency || "USD";
            e.gtm_item_brand = e.vendor || "";
            e.gtm_item_category = e.product_type || "";
            e.gtm_item_variant = e.variant_title || "";
            e.gtm_price = parseFloat((e.final_price / 100).toFixed(2));
            e.gtm_quantity = e.quantity;
            e.original_line_price =
            e.original_line_price > e.final_line_price
              ? s.formatMoney(e.original_line_price, window.theme.moneyFormat)
              : 0;
            e.final_line_price = s.formatMoney(
              e.final_line_price,
              window.theme.moneyFormat
            );
            e.original_price =
              e.original_price > e.final_price
                ? s.formatMoney(e.original_price, window.theme.moneyFormat)
                : 0;
            e.final_price = s.formatMoney(
              e.final_price,
              window.theme.moneyFormat
            );
            e.line_index = n + 1;
            for (var i = 0; i < e.line_level_discount_allocations.length; i++) {
              e.line_level_discount_allocations[i].amount_format =
                s.formatMoney(
                  e.line_level_discount_allocations[i].amount,
                  window.theme.moneyFormat
                );
            }

            window.CART_SHIPPING_METAFILEDS &&
              (e.variant_metafields =
                window.CART_SHIPPING_METAFILEDS[e.variant_id]);
            e.option_values = "";
            e.options_with_values.forEach(function (t, n) {
              e.option_values += t.value;
              n != e.options_with_values.length - 1 && (e.option_values += "; ");
            });
          }
          t.items = items.filter(item => item.quantity > 0);
          return (
            (t.original_total_price =
              t.original_total_price > t.items_subtotal_price
                ? s.formatMoney(
                    t.original_total_price,
                    window.theme.moneyFormat
                  )
                : 0),
            (t.items_subtotal_price =
              t.items_subtotal_price > t.total_price
                ? s.formatMoney(
                    t.items_subtotal_price,
                    window.theme.moneyFormat
                  )
                : 0),
            (t.total_price = s.formatMoney(
              t.total_price,
              window.theme.moneyFormat
            )),
            t
          );
        })(t),
        n = m("tpl-cart-items", e);
      if (f) {
        f.innerHTML = n;
        var i = f.querySelectorAll(".as-input-group-number");
        i &&
          Array.prototype.forEach.call(i, function (t) {
            new l(t).init();
          });
      }
      h && (h.innerHTML = m("tpl-cart-summary", e)),
        d &&
          (e.items.length > 0
            ? d.classList.remove("empty")
            : d.classList.add("empty")),
        c.trigger(document, "cart.updated", { detail: e });
    }
    function m(t, e) {
      if (t) {
        var n = document.getElementById(t),
          i = n && u.compile(n.innerHTML);
        return i && i.render(e);
      }
    }

    function p1(t) {
      const tt = document.querySelector("#shopify-section-" + sectionId);
      tt.innerHTML = t.sections[sectionId];
      
      var i = tt.querySelectorAll(".as-input-group-number");
      i &&
        Array.prototype.forEach.call(i, function (j) {
          new l(j).init();
        });
       d &&
          (t.items.length > 0
            ? d.classList.remove("empty")
            : d.classList.add("empty")),
        c.trigger(document, "cart.updated", { detail: t });
    
    }

    if (document.getElementById('cart-recommendation') && document.querySelector('.template-cart')) {
      // 购物加购逻辑
      document.addEventListener('click', function(e) {
        if (e.target.classList.contains('btn-column')) {
          var btn = e.target;
          var id = btn.dataset.id;
          var itemName = btn.dataset.gtmItemName || "";
          var position = btn.dataset.gtmPosition || "cart_recommendation";

          let gift = {};
          let giftAttr = {};
          let giftElems = e.target.closest('.card-wrapper').querySelectorAll('.as-gift-product-id');
          giftElems.forEach(function(e) {
            let qty = e.dataset.stock;
            let val = e.dataset.id;
            let num = Number(qty) - window.getProductStock(id, val);

            if (num > 0) {
              gift[val] = num;
            }
            let giftNum = window.getGiftStock(val);
            if (giftNum >= qty) {
              gift = {};
            }

          })

          if (Object.keys(gift).length > 0) {
            giftAttr = {
              "properties": {
                "_gift": JSON.stringify(gift)
              }
            }
          }
          let curProduct = window.getCurrentProduct(id, giftAttr);
          if (curProduct) {
            a.post("/cart/change.js", { id: curProduct.id, quantity: curProduct.quantity })
            .then(function () {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "custom_add_to_cart",
                product_name: itemName,
                position: position
              });
              if (typeof window.pushGtmAddToCart === "function") {
                var yhCents = parseInt((btn.dataset && btn.dataset.gtmPriceCents) || "0", 10) || 0;
                var yhPri = yhCents / 100;
                var yhCur = window.__shopCurrencyCode || "USD";
                window.pushGtmAddToCart({
                  value: yhPri,
                  currency: yhCur,
                  items: [
                    {
                      item_id: String(id || ""),
                      item_name: itemName || "",
                      currency: yhCur,
                      item_brand: "",
                      item_category: "",
                      item_variant: "",
                      price: yhPri,
                      quantity: 1,
                      index: 1
                    }
                  ]
                });
              }
              window.location.reload();
            }).catch(function (err) {
              console.log(err)
              window.handleErrMsg(err)
            })
          } else {
            a.post("/cart/add.js", { items: [{ id: id, quantity: 1, ...giftAttr }] })
            .then(function () {
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "custom_add_to_cart",
                product_name: itemName,
                position: position
              });
              if (typeof window.pushGtmAddToCart === "function") {
                var yhCents = parseInt((btn.dataset && btn.dataset.gtmPriceCents) || "0", 10) || 0;
                var yhPri = yhCents / 100;
                var yhCur = window.__shopCurrencyCode || "USD";
                window.pushGtmAddToCart({
                  value: yhPri,
                  currency: yhCur,
                  items: [
                    {
                      item_id: String(id || ""),
                      item_name: itemName || "",
                      currency: yhCur,
                      item_brand: "",
                      item_category: "",
                      item_variant: "",
                      price: yhPri,
                      quantity: 1,
                      index: 1
                    }
                  ]
                });
              }
              window.location.reload();
            }).catch(function (err) {
              console.log(err)
              window.handleErrMsg(err)
            })
          }
        }
      })
    }
    window.handleErrMsg = (err) => {
      if (err && err.response && err.response.data) {
        let data = err.response.data;
        if (data.status == 422) {
          window.Toast.show(data.message);
        }
      }
    }

    window.getCurrentProduct = (variantId, giftAttr) => {
      let param = {};
      if (window.cartDatas && window.cartDatas.items && giftAttr && giftAttr.properties) {
        window.cartDatas.items.forEach(item => {
          if (item.variant_id == variantId && item.properties && item.properties._gift) {
            param = {
              id: item.key,
              quantity: item.quantity + 1
            }
          }
        });
      }
      return param.id ? param : undefined
    }

    window.getProductStock = (variantId, giftId) => {
      let qty = 0;

      if (window.cartDatas && window.cartDatas.items) {
        window.cartDatas.items.forEach(item => {
          if (item.variant_id != variantId) {
            if (item.properties && item.properties._gift) {
              let gift = JSON.parse(item.properties._gift);
              if (gift[giftId]) {
                qty = qty + item.quantity;
              }
            }
          }
          if ((item.variant_id == giftId) && !(item.properties && item.properties._gift)) {
            qty = qty + item.quantity;
          }
        });
      }
      return qty;
    };
    window.getGiftStock = (giftId) => {
      let qty = 0;
      if (window.cartDatas && window.cartDatas.items) {
        window.cartDatas.items.forEach(item => {
          if (item.properties && item.properties._gift) {
            let gift = JSON.parse(item.properties._gift);
            if (gift[giftId]) {
              qty = qty + item.quantity;
            }
          }
        });
      }
      return qty;
    };
    a.get("/cart.js")
    .then(function (t) {
      window.cartDatas = t.data;
      window.cartChannelUpdate(t.data);
    })
    document.addEventListener("cart.update", function () {
      a.get("/cart.js")
        .then(function (t) {
          window.cartDatas = t.data;
          t.data && p(t.data);
        })
        .catch(function (t) {
          t.response && t.response.data && t.response.data;
        });
    }),
      d &&
        d.addEventListener("shown.bs.modal", function () {
          a.get("/cart.js")
            .then(function (t) {
              var cartData = t.data;
              window.cartDatas = t.data;
              window.cartChannelUpdate(t.data);
              if (cartData && cartData.items && cartData.items.length > 0) {
                var items = [];
                var idx = 0;
                for (var i = 0; i < cartData.items.length; i++) {
                  var it = cartData.items[i];
                  if (it.final_line_price > 0) {
                    idx++;
                    items.push({
                      item_id: it.sku || String(it.product_id),
                      item_name: it.product_title || "",
                      currency: cartData.currency || "USD",
                      item_brand: it.vendor || "",
                      item_category: it.product_type || "",
                      item_variant: it.variant_title || "",
                      price: parseFloat((it.final_price / 100).toFixed(2)),
                      quantity: it.quantity,
                      index: idx
                    });
                  }
                }
                if (items.length > 0) {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "view_cart",
                    currency: cartData.currency || "USD",
                    value: parseFloat((cartData.total_price / 100).toFixed(2)),
                    items: items
                  });
                }
              }
              cartData && p(cartData);
            })
            .catch(function (t) {
              t.response && t.response.data && t.response.data;
            });
        }),
      document.addEventListener("change", function (t) {
          var e = t.target;
          if (!e.classList.contains("as-form-control-number")) return;
          var cartEl = e.closest("#site-cart");
          if (!cartEl) return;

          i && clearTimeout(i),
            (i = setTimeout(function () {
              var t = {};
              (t[e.dataset.key] = e.value),
                a
                  .post("/cart/change.js", { 
                    id: e.dataset.key,
                    quantity: Number(e.value),
                    sections: [sectionId],
                   })
                  .then(function (t) {
                    window.cartChannelUpdate(t.data);
                    t.data && p1(t.data);
                  })
                  .catch(function (t) {
                    let oldVal = 0
                    window.cartDatas.items.forEach(item => {
                      if (item.id == e.dataset.id) {
                        oldVal = item.quantity;
                      }
                    });
                    e.value = oldVal;
                    if (err && err.response && err.response.data) {
                      let data = err.response.data;
                      let el = e.closest(".cart-item");
                      el.querySelectorAll(".cart-item__error-text").forEach((elem) => {
                        elem.textContent = data.message
                      });
                      el.querySelectorAll(".cart-item__error").forEach((elem) => {
                        elem.classList.remove("hidden");
                      });
                    }
                  });
            }, 400));
        }),
      document.addEventListener("click", function (t) {
          var removeBtn = t.target && t.target.closest && t.target.closest(".as-remove-item");
          removeBtn &&
            (t.preventDefault(),
            (function() {
              var el = removeBtn;
              var item;
              if (el.dataset.gtmItem) {
                try {
                  var raw = (el.dataset.gtmItem || "").replace(/&quot;/g, '"').replace(/&amp;/g, "&");
                  item = JSON.parse(raw);
                } catch (e) { return; }
              } else if (el.dataset.gtmItemId) {
                item = {
                  item_id: el.dataset.gtmItemId,
                  item_name: el.dataset.gtmItemName || "",
                  currency: el.dataset.gtmCurrency || "USD",
                  item_brand: el.dataset.gtmItemBrand || "",
                  item_category: el.dataset.gtmItemCategory || "",
                  item_variant: el.dataset.gtmItemVariant || "",
                  price: parseFloat(el.dataset.gtmPrice) || 0,
                  quantity: parseInt(el.dataset.gtmQuantity, 10) || 1
                };
              } else return;
              var items = [{
                item_id: item.item_id,
                item_name: item.item_name,
                currency: item.currency,
                item_brand: item.item_brand,
                item_category: item.item_category,
                item_variant: item.item_variant,
                price: item.price,
                quantity: item.quantity,
                index: 1
              }];
              var value = (item.price || 0) * (item.quantity || 1);
              var eventData = {
                event: "remove_from_cart",
                currency: item.currency,
                value: value,
                remove_items: items
              };
              window.dataLayer = window.dataLayer || [];
              function doPush() {
                window.dataLayer.push(eventData);
              }
              if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", function pushWhenReady() {
                  document.removeEventListener("DOMContentLoaded", pushWhenReady);
                  setTimeout(doPush, 0);
                });
              } else {
                doPush();
              }
            })(),
            r && clearTimeout(r),
            (r = setTimeout(function () {
              var e = {};
              (e[removeBtn.dataset.key] = 0),
                a
                  .post("/cart/change.js", { 
                    id: t.target.dataset.key,
                    quantity: 0,
                    sections: [sectionId] 
                  })
                  .then(function (t) {
                    window.cartChannelUpdate(t.data);
                    t.data && p1(t.data);
                  })
                  .catch(function (err) {
                    let oldVal = 0
                    window.cartDatas.items.forEach(item => {
                      if (item.id == t.target.dataset.id) {
                        oldVal = item.quantity;
                      }
                    });
                    t.target.value = oldVal;
                    
                    if (err && err.response && err.response.data) {
                      let data = err.response.data;
                      let el = t.target.closest(".cart-item");
                      el.querySelectorAll(".cart-item__error-text").forEach((elem) => {
                        elem.textContent = data.message
                      });
                      el.querySelectorAll(".cart-item__error").forEach((elem) => {
                        if (data && data.message) {
                          elem.classList.remove("hidden");
                        }
                      });
                    }
                  });
            }, 400)));
        }),
      (o = document.querySelectorAll(".as-purchase-form")) &&
        Array.prototype.forEach.call(o, function (t) {
          var e = t.querySelector(".as-variant-id"),
            n = e && e.value;
          n &&
            t.addEventListener("submit", function (e) {
              e.preventDefault();
              var variantIdInput = t.querySelector(".as-variant-id");
              var vid = variantIdInput && variantIdInput.value;
              let gift = {};
              let giftAttr = {};
              let giftElems = t.querySelectorAll('.as-gift-product-id');
              giftElems.forEach(function(e) {
                let qty = e.dataset.stock;
                let val = e.dataset.id;
                let num = Number(qty) - window.getProductStock(vid, val);
                if (num > 0) {
                  gift[val] = num;
                }
                let giftNum = window.getGiftStock(val);
                if (giftNum >= qty) {
                  gift = {};
                }
              })
              if (Object.keys(gift).length > 0) {
                giftAttr = {
                  "properties": {
                    "_gift": JSON.stringify(gift)
                  }
                }
              }
              var items = [{ id: vid, quantity: 1, ...giftAttr }];
              var form = e.target;
              var btn = form.querySelector(".as-add2cart") || form.querySelector('button[type=submit]');
              var position = (form.dataset && form.dataset.gtmPosition) || (btn && btn.dataset && btn.dataset.gtmPosition) || "collections";
              var itemName = (form.dataset && form.dataset.gtmItemName) || (btn && btn.dataset && btn.dataset.gtmItemName) || "";
              var n = t.querySelector(".as-add2cart");
              n &&
                (n.setAttribute("disabled", "disabled"),
                (n.innerText = n.dataset.loadingText || ""));

                let curProduct = window.getCurrentProduct(vid, giftAttr);
                if (curProduct) {
                  a.post("/cart/change.js", { id: curProduct.id, quantity: curProduct.quantity })
                  .then(function () {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                      event: "custom_add_to_cart",
                      product_name: itemName,
                      position: position
                    });
                    if (typeof window.pushGtmAddToCart === "function") {
                      var yhVin = form.querySelector(".as-variant-id");
                      if (yhVin && yhVin.value) {
                        var yhCents2 = parseInt(yhVin.getAttribute("data-price") || "0", 10) || 0;
                        var yhPri2 = yhCents2 / 100;
                        var yhCur2 = window.__shopCurrencyCode || "USD";
                        window.pushGtmAddToCart({
                          value: yhPri2,
                          currency: yhCur2,
                          items: [
                            {
                              item_id: String(yhVin.value || ""),
                              item_name: itemName || "",
                              currency: yhCur2,
                              item_brand: "",
                              item_category: "",
                              item_variant: "",
                              price: yhPri2,
                              quantity: 1,
                              index: 1
                            }
                          ]
                        });
                      }
                    }
                    c.trigger(document, "cart.update");
                      
                    let el = document.querySelector('#as-add1cart-modal-trigger');
                    el && el.click();
                  }).catch(function (err) {
                    console.log(err)
                    window.handleErrMsg(err)
                  })
                } else {
                  a
                    .post("/cart/add.js", { items: items })
                    .then(function () {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: "custom_add_to_cart",
                        product_name: itemName,
                        position: position
                      });
                      if (typeof window.pushGtmAddToCart === "function") {
                        var yhVin = form.querySelector(".as-variant-id");
                        if (yhVin && yhVin.value) {
                          var yhCents2 = parseInt(yhVin.getAttribute("data-price") || "0", 10) || 0;
                          var yhPri2 = yhCents2 / 100;
                          var yhCur2 = window.__shopCurrencyCode || "USD";
                          window.pushGtmAddToCart({
                            value: yhPri2,
                            currency: yhCur2,
                            items: [
                              {
                                item_id: String(yhVin.value || ""),
                                item_name: itemName || "",
                                currency: yhCur2,
                                item_brand: "",
                                item_category: "",
                                item_variant: "",
                                price: yhPri2,
                                quantity: 1,
                                index: 1
                              }
                            ]
                          });
                        }
                      }
                      c.trigger(document, "cart.update");
                      
                      let el = document.querySelector('#as-add1cart-modal-trigger');
                      el && el.click();
                    })
                    .catch(function (err) {
                      console.log(err)
                      window.handleErrMsg(err)
                    })
                }
                
                setTimeout(function () {
                  n &&
                    (n.removeAttribute("disabled"),
                    (n.innerText = n.dataset.normalText || ""));
                }, 1e3);
            });
        });
  },
  function (t, e, n) {
    var i = n(3).default;
    function r(t) {
      t &&
        ((this.$input = t.querySelector(".as-form-control-number")),
        (this.$plus = t.querySelector(".as-form-control-number-plus")),
        (this.$minus = t.querySelector(".as-form-control-number-minus")));
    }
    r.prototype = {
      constructor: r,
      init: function () {
        this.$plus && this.addPlusEventListener(),
          this.$minus && this.addMinusEventListener(),
          this.$input && this.addInputEventListener(),
          this.setActionStatus();
      },
      addPlusEventListener: function () {
        var t = this;
        this.$plus.addEventListener("click", function () {
          t.$input.value - 0 < t.$input.max - 0 &&
            ((t.$input.value = t.$input.value - 0 + (t.$input.step - 0)),
            t.setActionStatus(),
            i.trigger(t.$input, "change", { target: t.$input }));
        });
      },
      addMinusEventListener: function () {
        var t = this;
        this.$minus.addEventListener("click", function () {
          t.$input.value - 0 > t.$input.min - 0 &&
            ((t.$input.value = t.$input.value - 0 - (t.$input.step - 0)),
            t.setActionStatus(),
            i.trigger(t.$input, "change", { target: t.$input }));
        });
      },
      addInputEventListener: function () {
        var t = this;
        this.$input.addEventListener("change", function () {
          t.$input.value - 0 > t.$input.max - 0
            ? (t.$input.value = t.$input.max)
            : t.$input.value - 0 < t.$input.min - 0 &&
              (t.$input.value = t.$input.min),
            t.setActionStatus();
        });
      },
      setActionStatus: function () {
        this.$input.value - 0 >= this.$input.max - 0
          ? ((this.$plus.disabled = !0), (this.$minus.disabled = !1))
          : this.$input.value - 0 <= this.$input.min - 0
          ? ((this.$plus.disabled = !1), (this.$minus.disabled = !0))
          : ((this.$plus.disabled = !1), (this.$minus.disabled = !1));
      },
    };
    for (
      var o = document.querySelectorAll(".as-input-group-number"), a = 0;
      a < o.length;
      a++
    )
      new r(o[a]).init();
    t.exports = r;
  },
  function (t, e) {
    function n(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function r(t, e, n) {
      return e && i(t.prototype, e), n && i(t, n), t;
    }
    new ((function () {
      function t() {
        n(this, t),
          (this.$parent = document.querySelector(".as-footer-newsletter")),
          this.$parent &&
            ((this.$input = this.$parent.querySelector(".as-newsletter-input")),
            this.$input &&
              ((this.$submit = this.$parent.querySelector(
                ".as-newsletter-submit"
              )),
              (this.$error = this.$parent.querySelector(".as-error-tips")),
              (this.FORMAT = "format"),
              (this.EMPTY = "empty"),
              (this.regx = new RegExp(this.$input.pattern)),
              this.init()));
      }
      return (
        r(t, [
          {
            key: "init",
            value: function () {
              this.handleSubmit(), this.handleBlur();
            },
          },
          {
            key: "handleSubmit",
            value: function () {
              var t = this;
              this.$parent.onsubmit = function (e) {
                e = e || window.event;
                var n = t.$input.value;
                t.validateForm(n) || (e.stopPropagation(), e.preventDefault());
              };
            },
          },
          {
            key: "handleBlur",
            value: function () {
              var t = this;
              this.$input &&
                this.$input.addEventListener("blur", function () {
                  var e = t.$input.value;
                  t.validateForm(e);
                });
            },
          },
          {
            key: "handleFormErrorTips",
            value: function (t) {
              t && this.$error
                ? this.$error.dataset &&
                  (this.$error.innerHTML = this.$error.dataset[t])
                : (this.$error.innerHTML = "");
            },
          },
          {
            key: "validateForm",
            value: function (t) {
              return "string" != typeof t
                ? (this.handleFormErrorTips(this.FORMAT), !1)
                : 0 == t.length
                ? (this.handleFormErrorTips(this.EMPTY), !1)
                : this.regx.test(t)
                ? (this.handleFormErrorTips(), !0)
                : (this.handleFormErrorTips(this.FORMAT), !1);
            },
          },
        ]),
        t
      );
    })())(),
      new ((function () {
        function t() {
          n(this, t),
            (this.$parent = document.querySelector(".as-footer-social-wrap")),
            this.$parent &&
              ((this.mobilFlag = this.checkIsMobile()),
              this.mobilFlag &&
                ((this.$icon =
                  this.$parent.querySelectorAll(".as-social-link")),
                Array.from(this.$icon).map(function (t) {
                  t.removeAttribute("target"), t.removeAttribute("rel");
                })));
        }
        return (
          r(t, [
            {
              key: "checkIsMobile",
              value: function () {
                var t = this.$parent.querySelector(".as-is-mobile-flag");
                if (t) return "none" === window.getComputedStyle(t).display;
              },
            },
          ]),
          t
        );
      })())();
  },
  function (t, e, n) {
    var i = n(3).default,
      r = n(6);
    n(50), n(52);
    var o = n(7);
    function a() {
      (this._$root = document.getElementById("as-product")), this._init();
    }
    (a.prototype = {
      _init: function () {
        this._addEventListeners(),
          this._processRecommendations(),
          this._processPurchase(
            this._$root &&
              this._$root.querySelector(".as-product-custome-recommendations")
          ),
          this._checkIsMobile() && this._processTable();
      },
      _addEventListeners: function () {
        var t =
            this._$root && this._$root.querySelector(".as-product-purchase"),
          e = document.getElementById("as-add2cart-modal-trigger");
        t &&
          t.addEventListener("modal.add2cart.success", function () {
            e && e.click();
          });
      },
      _checkIsMobile: function () {
        var t = this._$root && this._$root.querySelector(".as-is-mobile-flag");
        return !!t && "none" === window.getComputedStyle(t).display;
      },
      _processPurchase: function (t) {
        var e = t && t.querySelectorAll(".as-purchase-form");
        e &&
          Array.prototype.forEach.call(e, function (t) {
            var e = t.querySelector(".as-variant-id"),
              n = e && e.value,
              o = { items: [{ id: n, quantity: 1 }] };
            n &&
              t.addEventListener("submit", function (e) {
                e.preventDefault();
                var variantIdInput = t.querySelector(".as-variant-id");
                var vid = variantIdInput && variantIdInput.value;
                let gift = {};
                let giftAttr = {};
                let giftElems = t.querySelectorAll('.as-gift-product-id');
                giftElems.forEach(function(e) {
                  let qty = e.dataset.stock;
                  let val = e.dataset.id;
                  let num = Number(qty) - window.getProductStock(vid, val);
                  if (num > 0) {
                    gift[val] = num;
                  }
                  let giftNum = window.getGiftStock(val);
                  if (giftNum >= qty) {
                    gift = {};
                  }
                })
                if (Object.keys(gift).length > 0) {
                  giftAttr = {
                    "properties": {
                      _gift: JSON.stringify(gift)
                    }
                  }
                }
                var items = [{ id: vid, quantity: 1, ...giftAttr }];
                var formEl = t;
                var btnEl = formEl.querySelector(".as-add2cart") || formEl.querySelector('button[type=submit]');
                var gtmPos = (formEl.dataset && formEl.dataset.gtmPosition) || (btnEl && btnEl.dataset && btnEl.dataset.gtmPosition) || "recommendations";
                var gtmName = (formEl.dataset && formEl.dataset.gtmItemName) || (btnEl && btnEl.dataset && btnEl.dataset.gtmItemName) || "";
                var n = t.querySelector(".as-add2cart");
                n &&
                  (n.setAttribute("disabled", "disabled"),
                  (n.innerText = n.dataset.loadingText || ""));
                   let curProduct = window.getCurrentProduct(vid, giftAttr);
                  if (curProduct) {
                    r.post("/cart/change.js", { id: curProduct.id, quantity: curProduct.quantity })
                    .then(function () {
                      window.dataLayer = window.dataLayer || [];
                      window.dataLayer.push({
                        event: "custom_add_to_cart",
                        product_name: gtmName,
                        position: gtmPos
                      });
                      if (typeof window.pushGtmAddToCart === "function") {
                        var yhVin3 = formEl.querySelector(".as-variant-id");
                        if (yhVin3 && yhVin3.value) {
                          var yhCents3 = parseInt(yhVin3.getAttribute("data-price") || "0", 10) || 0;
                          var yhPri3 = yhCents3 / 100;
                          var yhCur3 = window.__shopCurrencyCode || "USD";
                          window.pushGtmAddToCart({
                            value: yhPri3,
                            currency: yhCur3,
                            items: [
                              {
                                item_id: String(yhVin3.value || ""),
                                item_name: gtmName || "",
                                currency: yhCur3,
                                item_brand: "",
                                item_category: "",
                                item_variant: "",
                                price: yhPri3,
                                quantity: 1,
                                index: 1
                              }
                            ]
                          });
                        }
                      }
                      i.trigger(t._$product, "modal.add2cart.success"),
                      i.trigger(document, "cart.update");
                    }).catch(function (err) {
                      console.log(err)
                      window.handleErrMsg(err)
                    })
                  } else {
                    r
                      .post("/cart/add.js", { items: items })
                      .then(function () {
                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                          event: "custom_add_to_cart",
                          product_name: gtmName,
                          position: gtmPos
                        });
                        if (typeof window.pushGtmAddToCart === "function") {
                          var yhVin3 = formEl.querySelector(".as-variant-id");
                          if (yhVin3 && yhVin3.value) {
                            var yhCents3 = parseInt(yhVin3.getAttribute("data-price") || "0", 10) || 0;
                            var yhPri3 = yhCents3 / 100;
                            var yhCur3 = window.__shopCurrencyCode || "USD";
                            window.pushGtmAddToCart({
                              value: yhPri3,
                              currency: yhCur3,
                              items: [
                                {
                                  item_id: String(yhVin3.value || ""),
                                  item_name: gtmName || "",
                                  currency: yhCur3,
                                  item_brand: "",
                                  item_category: "",
                                  item_variant: "",
                                  price: yhPri3,
                                  quantity: 1,
                                  index: 1
                                }
                              ]
                            });
                          }
                        }
                        i.trigger(document, "cart.update");
                      })
                      .catch(function (err) {
                        console.log(err)
                        window.handleErrMsg(err)
                      });
                  }
      
                  setTimeout(function () {
                    n &&
                      (n.removeAttribute("disabled"),
                      (n.innerText = n.dataset.normalText || ""));
                  }, 1e3);
              });
          });
      },
      _processTable: function () {
        var t =
          this._$root &&
          this._$root.querySelectorAll(".as-product-content table");
        Array.prototype.forEach.call(t, function (t) {
          var e = t.querySelector("tbody"),
            n = t.querySelectorAll("tr");
          Array.prototype.forEach.call(n, function (t, n) {
            for (
              var i = t.querySelectorAll("td"), r = i.length, o = 1;
              o < r;
              o++
            ) {
              var a = i[o].innerHTML;
              e.rows[n * r].deleteCell(1),
                e.insertRow(n * r + o),
                e.rows[n * r + o].insertCell(0),
                (e.rows[n * r + o].cells[0].innerHTML = a);
            }
          });
        });
      },
      _processRecommendations: function () {
        var t = this,
          e =
            this._$root &&
            this._$root.querySelectorAll(".as-product-recommendations");
        null !== e &&
          Array.prototype.forEach.call(e, function (e) {
            var n = e.dataset.productId,
              i = e.dataset.baseUrl,
              a = e.dataset.limit,
              s =
                i +
                "?section_id=" +
                e.dataset.sectionId +
                "&product_id=" +
                n +
                "&limit=" +
                a;
            r.get(s)
              .then(function (n) {
                (e.innerHTML = n.data),
                  e.classList.remove("as-product-recommendations"),
                  t._processPurchase(e);
                for (
                  var i = document.querySelectorAll(
                      ".as-product-tag-container"
                    ),
                    r = 0;
                  r < i.length;
                  r++
                )
                  new o()._init(i[r]);
              })
              .catch(function () {});
          });
      },
    }),
      new a();
  },
  function (t, e, n) {
    var i = n(3).default,
      r = n(19).tns,
      o = n(2),
      a = n(51);
    function s() {
      (this._$root = document.getElementById("as-product")),
        (this.thumbnailGroupItem = -1),
        (this.youtubeAPIId = "as-youtube-api"),
        this._init();
    }
    (s.prototype = {
      _init: function () {
        var t = this;
        this._prepareToInitCarousel(),
          this._initModal(function (e) {
            t._processModal(e, "preview"),
              t._checkIsMobile() && t._processModal(e, "video_modal");
          }),
          this._initGallery(),
          this._initProductGallery(),
          this._addEventListeners();
      },
      _prepareToInitCarousel: function () {
        var t =
          this._$root &&
          this._$root.querySelector(".as-product-gallery:not(.d-none)");
        t &&
          -1 === this.thumbnailGroupItem &&
          (this.thumbnailGroupItem = this._getGroupStep(
            t.querySelector(".as-thumbnail-carousel-inner")
          ));
      },
      _initModal: function (t) {
        document.addEventListener("lazybeforeunveil", function (e) {
          var n = e.target;
          if (n.getAttribute("data-toggle")) {
            var i = n.getAttribute("data-target") || n.getAttribute("href"),
              r = i && document.querySelector(i + "-tpl"),
              a = r && o.compile(r.innerHTML);
            a && (r.outerHTML = a.render()), t && t(i);
          }
        });
      },
      _processModal: function (t, e) {
        if ("preview" === e) {
          var n = this._$root && this._$root.querySelector(t),
            r = n && n.querySelector(".as-preview-gallery"),
            o = n && n.dataset.variantId;
          r && this._initCarousel(r);
          var a =
              this._$root &&
              this._$root.querySelector(
                '.as-product-gallery[data-variant-id="' + o + '"]'
              ),
            s = document.body;
          n &&
            n.addEventListener("show.bs.modal", function () {
              i.trigger(a, "carousel.stop.video");
            }),
            this._checkIsMobile() &&
              (n &&
                n.addEventListener("shown.bs.modal", function () {
                  s && s.classList.add("disabled-scroll");
                }),
              n &&
                n.addEventListener("hidden.bs.modal", function () {
                  s && s.classList.remove("disabled-scroll");
                }));
        } else "video_modal" === e && this._processVideoModal();
      },
      _initGallery: function () {
        var t =
            this._$root && this._$root.querySelectorAll(".as-product-gallery"),
          e = this;
        t &&
          Array.prototype.forEach.call(t, function (t) {
            if ((e._initCarousel(t), e._checkIsMobile())) {
              var n = t.querySelectorAll(".as-video-modal-trigger");
              n &&
                Array.prototype.forEach.call(n, function (t) {
                  t.classList.add("lazyload");
                });
            } else {
              var r = t.querySelectorAll(".as-carousel-item-with-video");
              r &&
                a &&
                (Array.prototype.forEach.call(r, function (n) {
                  n.classList.add("lazyload"),
                    document.addEventListener("lazybeforeunveil", function (r) {
                      if (r.target === n) {
                        if (!n.player) {
                          n.player = new a(n, e.youtubeAPIId);
                          var o = n.querySelector(".as-youtube-player");
                          if (o) o.src = o.dataset.src || "";
                          else {
                            var s = n.querySelector("video");
                            s && (s.src = s.dataset.src || "");
                          }
                        }
                        var c = n.querySelector(".as-play-trigger");
                        c &&
                          c.addEventListener("click", function () {
                            i.trigger(t, "carousel.play.video");
                          });
                      }
                    });
                }),
                t.addEventListener("carousel.play.video", function () {
                  var e = t.mainCarousel;
                  if (document.querySelector('.product-gallery [data-tab="video"]')) {
                    // tab 中的播放器
                    var playerItem = document.querySelector('.as-carousel-item-with-video');
                    var videoBox = playerItem.querySelector(".as-video-container");
                    if (videoBox) {
                      videoBox.classList.add("z-index-1");
                      playerItem.player && playerItem.player.playVideo();
                    }
                    return
                  }
                  
                  if (e) {
                    var n = e.getInfo(),
                      i =
                        n.container.querySelectorAll(".as-carousel-item")[
                          n.index
                        ],
                      r = i.querySelector(".as-video-container");
                    r && r.classList.add("z-index-1"),
                      i.player && i.player.playVideo();
                  }
                }),
                t.addEventListener("carousel.stop.video", function () {
                  var e = t.mainCarousel;
                  if (document.querySelector('.product-gallery [data-tab="video"]')) {
                    var playerItem = document.querySelector('.as-carousel-item-with-video');
                    var videoBox = playerItem.querySelector(".as-video-container");
                    if (videoBox) {
                      videoBox.classList.remove("z-index-1");
                      playerItem.player && playerItem.player.stopVideo();
                    }
                    return
                  }

                  if (e) {
                    var n = e.getInfo(),
                      i =
                        n.container.querySelectorAll(".as-carousel-item")[
                          n.indexCached
                        ],
                      r = i.querySelector(".as-video-container");
                    r && r.classList.remove("z-index-1"),
                      i.player && i.player.stopVideo();
                  }
                }),
                t.addEventListener("carousel.indexChanged", function () {
                  i.trigger(t, "carousel.stop.video");
                }));
            }
            var o = t.querySelector(".as-preview-trigger");
            o && o.classList.add("lazyload");
            var s = t.querySelectorAll(".as-unfold-trigger");
            s &&
              Array.prototype.forEach.call(s, function (t) {
                t.classList.add("lazyload");
              });
          });
      },
      _initProductGallery: function () { 
        var t = document.querySelectorAll(".as-product-gallery1"),
          e = this;
        t &&
          Array.prototype.forEach.call(t, function (t) {
            if ((e._initProductCarousel(t), e._checkIsMobile())) {
              var n = t.querySelectorAll(".as-video-modal-trigger");
              n &&
                Array.prototype.forEach.call(n, function (t) {
                  t.classList.add("lazyload");
                });
            } else {
              var r = t.querySelectorAll(".as-carousel-item-with-video");
              r &&
                a &&
                (Array.prototype.forEach.call(r, function (n) {
                  n.classList.add("lazyload"),
                    document.addEventListener("lazybeforeunveil", function (r) {
                      if (r.target === n) {
                        if (!n.player) {
                          n.player = new a(n, e.youtubeAPIId);
                          var o = n.querySelector(".as-youtube-player");
                          if (o) o.src = o.dataset.src || "";
                          else {
                            var s = n.querySelector("video");
                            s && (s.src = s.dataset.src || "");
                          }
                        }
                        var c = n.querySelector(".as-play-trigger");
                        c &&
                          c.addEventListener("click", function () {
                            i.trigger(t, "carousel.play.video");
                          });
                      }
                    });
                }),
                t.addEventListener("carousel.play.video", function () {
                  var e = t.mainCarousel;
                  
                  if (e) {
                    var n = e.getInfo(),
                      i =
                        n.container.querySelectorAll(".as-carousel-item")[
                          n.index
                        ],
                      r = i.querySelector(".as-video-container");
                    r && r.classList.add("z-index-1"),
                      i.player && i.player.playVideo();
                  }
                }),
                t.addEventListener("carousel.stop.video", function () {
                  var e = t.mainCarousel;

                  if (e) {
                    var n = e.getInfo(),
                      i =
                        n.container.querySelectorAll(".as-carousel-item")[
                          n.indexCached
                        ],
                      r = i.querySelector(".as-video-container");
                    r && r.classList.remove("z-index-1"),
                      i.player && i.player.stopVideo();
                  }
                }),
                t.addEventListener("carousel.indexChanged", function () {
                  i.trigger(t, "carousel.stop.video");
                }));
            }

            var o = t.querySelector(".as-preview-trigger");
            o && o.classList.add("lazyload");
            var s = t.querySelectorAll(".as-unfold-trigger");
            s &&
              Array.prototype.forEach.call(s, function (t) {
                t.classList.add("lazyload");
              });
          });
      },
      _addEventListeners: function () {
        var t =
            this._$root && this._$root.querySelector(".as-product-purchase"),
          e =
            this._$root && this._$root.querySelectorAll(".as-product-gallery");
        t &&
          t.addEventListener("update.gallery", function (t) {
            var n = t.variantId || -1;
            e &&
              n > -1 &&
              Array.prototype.forEach.call(e, function (t) {
                if (!t.classList.contains("d-none")) {
                  var e = t.querySelector(".tns-slide-active");
                  e && e.player && e.player.stopVideo();
                }
                t.dataset.variantId === n
                  ? t.classList.remove("d-none")
                  : t.classList.add("d-none");
              });
          });
      },
      _initCarousel: function (t) {
        if (t) {
          var e = t.querySelector(".as-thumbnail-carousel");
          if (e) {
            var n = this._checkIsMobile(),
              o = this,
              a = t.querySelectorAll(".as-carousel-item");
            if (a && a.length > 1) {
              if (!t.querySelector(".as-carousel-inner") || !t.querySelector(".as-thumbnail-carousel-inner")) {
                return
              }

              var s = {
                  container: t.querySelector(".as-carousel-inner"),
                  navContainer: t.querySelector(".as-thumbnail-carousel-inner"),
                  navAsThumbnails: !0,
                  autoplay: !1,
                  controls: !1,
                  autoplayButtonOutput: !1,
                  autoplayHoverPause: !0,
                  speed: 1e3,
                  startIndex: 0,
                  loop: !1,
                  mode: n ? "carousel" : "gallery",
                  onInit: function () {
                    var e = t.querySelectorAll(".carousel-item");
                    Array.prototype.forEach.call(e, function (t) {
                      t.classList.remove("carousel-item"),
                        t.classList.remove("active");
                    });
                  },
                },
                c = r(s);
              t.mainCarousel = c;
              var l = this.thumbnailGroupItem,
                u = {
                  container: e.querySelector(".as-thumbnail-carousel-inner"),
                  prevButton: e.querySelector(".as-carousel-control-prev"),
                  nextButton: e.querySelector(".as-carousel-control-next"),
                  loop: !1,
                  autoplay: !1,
                  autoplayButtonOutput: !1,
                  autoplayHoverPause: !0,
                  speed: 500,
                  startIndex: 0,
                  items: 3,
                  responsive: {
                    "575": {
                      "items": l
                    }
                  },
                  onInit: function () {
                    var t = e.querySelector(".as-thumbnail-carousel-inner");
                    t && t.classList.remove("uninitialized");
                  },
                },
                d = l ? r(u) : '';
              c.events.on("indexChanged", function (e) {
                if (n && d) d.goTo(e.index);
                else {
                  var r = document.getElementById(e.container.id),
                    a = r && r.dataset.variantId,
                    s =
                      o._$root &&
                      o._$root.querySelector(
                        '.as-product-gallery[data-variant-id="' + a + '"]'
                      );
                  s &&
                    i.trigger(s, "carousel.indexChanged", {
                      index: e.index,
                      indexCached: e.indexCached,
                      variantId: a,
                    });
                }
                var c = t.querySelector(".as-preview-trigger");
                e.slideItems[e.index].classList.contains(
                  "as-carousel-item-with-video"
                )
                  ? c && c.classList.add("invisible")
                  : c && c.classList.remove("invisible");
              });
            }
          }
        }
      },
      _initProductCarousel: function (t) {
        if (t) {
          var e = t.querySelector(".as-carousel-inner");
          if (e) {
            var o = this,
              a = t.querySelectorAll(".as-carousel-item");
            if ((a && a.length) > 1) {
              var s = {
                  container: t.querySelector(".as-carousel-inner"),
                  autoplay: !1,
                  controls: !0,
                  prevButton: e.querySelector(".modal-prev-btn"),
                  nextButton: e.querySelector(".modal-next-btn"),
                  autoplayButtonOutput: !1,
                  autoplayHoverPause: !0,
                  navPosition: 'bottom',
                  controlsPosition: 'bottom',
                  speed: 1e3,
                  startIndex: 0,
                  loop: !1,
                  mode: "carousel",
                  onInit: function () {
                    
                  },
                },
                c = r(s);
              t.mainCarousel = c;
              c.events.on("indexChanged", function (e) {
                var r = document.getElementById(e.container.id + '-ow');
                var s = r.parentNode;
                i.trigger(s, "carousel.indexChanged", {
                  index: e.index,
                  indexCached: e.indexCached,
                });
                var c = t.querySelector(".as-preview-trigger");
                  e.slideItems[e.index].classList.contains(
                    "as-carousel-item-with-video"
                  )
                    ? c && c.classList.add("invisible")
                    : c && c.classList.remove("invisible");
              });
          
            }
          }
        }
      },
      _getGroupStep: function (t) {
        var e = t && t.clientWidth,
          n = t && t.querySelectorAll(".thumbnail-carousel-item"),
          i = n && n[0].clientWidth;
        return Math.round(e / i);
      },
      _checkIsMobile: function () {
        var t = this._$root && this._$root.querySelector(".as-is-mobile-flag");
        return !!t && "none" === window.getComputedStyle(t).display;
      },
      _processVideoModal: function () {
        var t = this._$root && this._$root.querySelectorAll(".as-video-modal"),
          e = this;
        t &&
          Array.prototype.forEach.call(t, function (t) {
            t.addEventListener("show.bs.modal", function () {
              !t.player && a && (t.player = new a(t, e.youtubeAPIId));
            }),
              t.addEventListener("hide.bs.modal", function () {
                t.player && t.player.stopVideo();
              });
          });
      },
    }),
      new s();
  },
  function (t, e) {
    function n(t, e) {
      t &&
        ((this.$root = t),
        (this.youtubeAPIId = e || "as-youtube-api"),
        (this.apiLoaded = !1),
        (this.player = null),
        (this.isYoutube = !1),
        (this.playYoutubeUntilAPILoaded = !1),
        this._init());
    }
    (n.prototype = {
      constructor: n,
      _init: function () {
        var t = this,
          e = this.$root.querySelector(".as-youtube-player");
        if (e) {
          document.getElementById(this.youtubeAPIId)
            ? window.YT && (this.apiLoaded = !0)
            : this._loadYoutubeAPI(),
            (this.isYoutube = !0),
            this._getYoutube(e, function (e) {
              (t.player = e), t.playYoutubeUntilAPILoaded && t.playVideo();
            });
        } else {
          var n = this.$root.querySelector("video");
          this.player = n;
        }
      },
      _loadYoutubeAPI: function () {
        var t = document.createElement("script");
        (t.id = this.youtubeAPIId),
          (t.src = "https://www.youtube.com/iframe_api");
        var e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(t, e);
      },
      _getYoutube: function (t, e) {
        var n = t.id;
        window.youtubeIdList ||
          ((window.youtubeIdList = []), (window.youtubeCB = [])),
          window.youtubeIdList.push(n),
          window.youtubeCB.push(e),
          this.apiLoaded
            ? new YT.Player(n, {
                events: {
                  onReady: function (t) {
                    e && e(t.target);
                  },
                },
              })
            : (window.onYouTubeIframeAPIReady = function () {
                window.youtubeIdList.forEach(function (t, e) {
                  new YT.Player(t, {
                    events: {
                      onReady: function (t) {
                        window.youtubeCB[e] && window.youtubeCB[e](t.target);
                      },
                    },
                  });
                });
              });
      },
      playVideo: function () {
        var t = this.player;
        t
          ? this.isYoutube
            ? t.playVideo()
            : t.play()
          : this.isYoutube && (this.playYoutubeUntilAPILoaded = !0);
      },
      stopVideo: function () {
        var t = this.player;
        t
          ? this.isYoutube
            ? (1 !== t.getPlayerState() && 3 !== t.getPlayerState()) ||
              (t.pauseVideo(), t.seekTo(0))
            : t.paused || (t.pause(), (t.currentTime = 0))
          : this.isYoutube && (this.playYoutubeUntilAPILoaded = !1);
      },
    }),
      (t.exports = n);
  },
  function (t, e, n) {
    var i = n(3).default,
      r = n(6),
      o = n(17);
    function a() {
      this._$product;
    }
    a.prototype = {
      _init: function (t) {
        (this._$product = t),
          (this._$options = this._$product.querySelectorAll(".as-step-option")),
          (this._$variants = this._$product.querySelectorAll(
            ".as-product-variant option"
          )),
          (this._$prices =
            this._$product.querySelectorAll(".as-product-price")),
          (this._$compareAtPrices = this._$product.querySelectorAll(
            ".as-product-compare-at-price"
          )),
          (this._$add2cart = this._$product.querySelector(".as-add2cart")),
          (this._$form = this._$product.querySelector(".as-product-form")),
          (this._$logistics =
            this._$product.querySelector(".as-logistics-info")),
          this._addEventListeners();
      },
      _addEventListeners: function () {
        var t = this;
        this._$product.addEventListener("change", function (e) {
          var n = t._$product.querySelectorAll(".as-step-option:checked"),
            i = Array.prototype.find.call(t._$variants, function (t) {
              return Array.prototype.every.call(n, function (e) {
                return t.dataset["option" + e.dataset.position] === e.value;
              });
            });
          t._checkCheckedOption(n, 1),
            i &&
              ((i.selected = !0),
              t._updatePrice(i),
              t._updateImages(i),
              t._updateAvailability(i),
              t._updateLogistics(i));
        }),
          this._addToCartEventListener();
      },
      _addToCartEventListener: function () {
        var t = this;
        this._$form.addEventListener("submit", function (e) {
          e.preventDefault();
          var position = (t._$add2cart && t._$add2cart.dataset && t._$add2cart.dataset.gtmPosition) || "bottom";
          var itemName = (t._$add2cart && t._$add2cart.dataset && t._$add2cart.dataset.gtmItemName) || (t._$product && t._$product.querySelector(".product-title") && t._$product.querySelector(".product-title").textContent) || "";
          t._$add2cart &&
            (t._$add2cart.setAttribute("disabled", "disabled"),
            (t._$add2cart.innerText =
              t._$add2cart.dataset.loadingText || ""));
          var n = t._processData();
          let curProduct = window.getCurrentProduct(n.id, n.giftAttr);
          if (curProduct) {
            r.post("/cart/change.js", { id: curProduct.id, quantity: curProduct.quantity })
            .then(function () {
              if (n.recommendArr.length > 0) {
                r.post("/cart/add.js", {items: n.recommendArr})
                .then(function () {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "custom_add_to_cart",
                    product_name: String(itemName || "").trim(),
                    position: position
                  });
                  if (typeof window.pushGtmAddToCartFromPdpProductRoot === "function") {
                    window.pushGtmAddToCartFromPdpProductRoot(t._$product);
                  }
                  i.trigger(t._$product, "modal.add2cart.success"),
                  i.trigger(document, "cart.update");
                })
                .catch(function (err) {
                  console.log(err)
                  window.handleErrMsg(err)
                });
              } else {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "custom_add_to_cart",
                  product_name: String(itemName || "").trim(),
                  position: position
                });
                if (typeof window.pushGtmAddToCartFromPdpProductRoot === "function") {
                  window.pushGtmAddToCartFromPdpProductRoot(t._$product);
                }
                i.trigger(t._$product, "modal.add2cart.success"),
                i.trigger(document, "cart.update");
              }
            }).catch(function (err) {
              console.log(err)
              window.handleErrMsg(err)
            })
          } else {
            r.post("/cart/add.js", n.items)
            .then(function () {
              if (n.recommendArr.length > 0) {
                r.post("/cart/add.js", {items: n.recommendArr})
                .then(function () {
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: "custom_add_to_cart",
                    product_name: String(itemName || "").trim(),
                    position: position
                  });
                  if (typeof window.pushGtmAddToCartFromPdpProductRoot === "function") {
                    window.pushGtmAddToCartFromPdpProductRoot(t._$product);
                  }
                  i.trigger(t._$product, "modal.add2cart.success"),
                  i.trigger(document, "cart.update");
                })
                .catch(function (err) {
                  console.log(err)
                  window.handleErrMsg(err)
                });
              } else {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                  event: "custom_add_to_cart",
                  product_name: String(itemName || "").trim(),
                  position: position
                });
                if (typeof window.pushGtmAddToCartFromPdpProductRoot === "function") {
                  window.pushGtmAddToCartFromPdpProductRoot(t._$product);
                }
                i.trigger(t._$product, "modal.add2cart.success"),
                i.trigger(document, "cart.update");
              }
            })
            .catch(function (err) {
              console.log(err)
              window.handleErrMsg(err)
            });
          }

            setTimeout(function () {
              t._$add2cart &&
                (t._$add2cart.removeAttribute("disabled"),
                (t._$add2cart.innerText =
                  t._$add2cart.dataset.normalText || ""));
            }, 1e3);
        });
      },
      _processData: function () {
        var t = { items: [] },
          e =
            this._$product &&
            this._$product.querySelector(".as-product-variant"),
          n = e[e.selectedIndex],
          i = n && n.value;
          let gift = {};
          let giftAttr = {};
          let giftElems = document.querySelectorAll('.product-gift .gift-card-radio');
          giftElems.forEach(function(e) {
            let qty = e.dataset.stock;
            let val = e.value;
            let num = Number(qty) - window.getProductStock(i, val);
            if (num > 0) {
              gift[val] = num;
            }
            let giftNum = window.getGiftStock(val);
            if (giftNum >= qty) {
              gift = {};
            }
          })
          if (Object.keys(gift).length > 0) {
            giftAttr = {
              "properties": {
                _gift: JSON.stringify(gift)
              }
            }
          }
          t.items.push({ quantity: 1, id: i, ...giftAttr });
          let recommendArr = [];
          document.querySelectorAll('.product-recommend .recommend-input:checked').forEach(function(e) {
            let id = e.value;
            let qty = e.parentNode.querySelector('.qty-input').value;
            qty = qty || 1;
            recommendArr.push({ quantity: qty, id: id })
          })
        return {
          items: t,
          giftAttr: giftAttr,
          recommendArr: recommendArr,
          id: i
        };
      },
      _checkCheckedOption: function (t, e) {
        if (!(e > t.length)) {
          for (var n = this._$variants, i = 1; i <= e; )
            (n = Array.prototype.filter.call(n, function (e) {
              return e.dataset["option" + i] === t[i - 1].value;
            })),
              i++;
          var r = e + 1,
            o = -1,
            a = !0,
            s = !1,
            c = this._$product.querySelectorAll(
              '.as-step-option[data-position="' + r + '"]'
            ),
            l = t[e];
          c &&
            Array.prototype.forEach.call(c, function (t, e) {
              var i = Array.prototype.some.call(n, function (e) {
                return e.dataset["option" + r] === t.value;
              });
              l === t && (i || (a = !1)),
                i && !s && ((s = !0), (o = e)),
                t.parentNode && t.parentNode.classList.toggle("d-none", !i);
            }),
            a ? this._checkCheckedOption(t, ++e) : c && c[o].click();
        }
      },
      _updateImages: function (t) {
        i.trigger(this._$product, "update.gallery", { variantId: t.value });
      },
      _updatePrice: function (t) {
        Array.prototype.forEach.call(this._$prices, function (e) {
          t.dataset &&
            (e.innerText = o.formatMoney(
              t.dataset.price || "",
              window.theme.moneyFormat
            ));
        }),
          Array.prototype.forEach.call(this._$compareAtPrices, function (e) {
            t.dataset &&
              (parseInt(t.dataset.compare) > parseInt(t.dataset.price)
                ? (e.classList.remove("d-none"),
                  e.classList.add("d-block"),
                  (e.innerText = o.formatMoney(
                    t.dataset.compare || "",
                    window.theme.moneyFormat
                  )))
                : (e.classList.remove("d-block"), e.classList.add("d-none")));
          });
      },
      _updateAvailability: function (t) {
        let el = document.querySelector('#add-to-cart-bar');
        (this._$add2cart.innerText =
          (t.dataset && t.dataset.availability) || ""),
          t.dataset && "available" === t.dataset.available
            ? (this._$add2cart.removeAttribute("disabled"),el.classList.remove("cart-sold_out"),
              this._$add2cart.setAttribute("aria-disabled", !1))
            : (this._$add2cart.setAttribute("disabled", !0),el.classList.add("cart-sold_out"),
              this._$add2cart.setAttribute("aria-disabled", !0));
      },
      _updateLogistics: function (t) {
        if (this._$logistics) {
          var e = (t.dataset && t.dataset.logistics) || "";
          "" != e
            ? (this._$logistics.classList.remove("d-none"),
              (this._$logistics.innerText = e))
            : (this._$logistics.classList.add("d-none"),
              (this._$logistics.innerText = ""));
        }
      },
    };
    for (
      var s = document.querySelectorAll(".as-product-purchase"), c = 0;
      c < s.length;
      c++
    )
      new a()._init(s[c]);
  },
  function (t, e, n) {
    var i = n(19).tns;
    function r() {
      (this._$root = document.getElementById("as-homepage")), this._init();
    }
    (r.prototype = {
      _init: function () {
        this._initCarousel(), this._initVideo();
      },
      _initCarousel: function () {
        var t =
            this._$root && this._$root.querySelectorAll(".as-heros-carousel"),
          e = this._checkIsMobile();
        t &&
          Array.prototype.forEach.call(t, function (t) {
            var n = t && t.querySelectorAll(".as-carousel-item");
            if (n && n.length > 1) {
              var r = {
                  container: t.querySelector(".carousel-inner"),
                  prevButton: t.querySelector(".carousel-control-prev"),
                  nextButton: t.querySelector(".carousel-control-next"),
                  navContainer: t.querySelector(".carousel-indicators"),
                  autoplay: !0,
                  autoplayButtonOutput: !1,
                  autoplayHoverPause: !0,
                  speed: "1000",
                },
                o = {};
              o = e
                ? Object.assign(r, {
                    mode: "carousel",
                    autoplayTimeout: "2000",
                  })
                : Object.assign(r, {
                    mode: "gallery",
                    autoplayTimeout: "7000",
                  });
              var a = i(o);
              e &&
                (a.events.on("touchEnd", function () {
                  a.pause();
                }),
                a.events.on("dragEnd", function () {
                  a.pause();
                }));
            }
          });
      },
      _checkIsMobile: function () {
        var t = this._$root && this._$root.querySelector(".as-is-mobile-flag");
        return !!t && "none" === window.getComputedStyle(t).display;
      },
      _initVideo: function () {
        if (!this._checkIsMobile()) {
          document.addEventListener("lazybeforeunveil", function (t) {
            var e = t.target;
            1 != e.autoplay &&
              e.classList.contains("as-collection-video") &&
              (e.load(),
              /Edge/.test(navigator.userAgent) &&
                (e.play(), e.pause(), (e.currentTime = 0)));
          });
          var t =
            this._$root &&
            this._$root.querySelectorAll(".as-collection-video-wrap");
          t &&
            Array.prototype.forEach.call(t, function (t) {
              var e = t.querySelector(".as-collection-video");
              e &&
                e.addEventListener(
                  "canplay",
                  function () {
                    e.dataset.canplay ||
                      "canplay" === e.dataset.canplay ||
                      ((e.dataset.canplay = "canplay"),
                      t.addEventListener("mouseenter", function () {
                        e.play();
                      }),
                      t.addEventListener("mouseleave", function () {
                        e.pause(), (e.currentTime = 0);
                      }));
                  },
                  !1
                );
            });
        }
      },
    }),
      new r();
  },
  function (t, e, n) {
    var i = n(1);
    new ((function () {
      return function t() {
        if (
          ((function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
          (this.COOKIE_NAME = "hasu_user_login"),
          (this.loginStatus = !!document.querySelector("#as-logged-in")),
          (this.cookieStatus = i.get(this.COOKIE_NAME)),
          this.loginStatus && !this.cookieStatus)
        ) {
          var e,
            n = document.querySelector(".as-log-out"),
            r =
              null == n || null === (e = n.dataset) || void 0 === e
                ? void 0
                : e.href;
          r && (window.location.href = r);
        }
        !this.loginStatus &&
          this.cookieStatus &&
          (window.location.href =
            "https://accounts.hasselblad.com/login?service=".concat(
              window.location.href
            ));
      };
    })())();
  },
  function (t, e, n) {
    function i(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var r = n(18);
    new ((function () {
      function t() {
        !(function (t, e) {
          if (!(t instanceof e))
            throw new TypeError("Cannot call a class as a function");
        })(this, t),
          (this.$parent = document.querySelector(".as-addresses")),
          this.$parent &&
            ((this.$addAddressBtn = this.$parent.querySelector(
              ".as-add-address-btn"
            )),
            (this.$allForm = this.$parent.querySelectorAll(".as-all-form")),
            (this.$addForm = this.$parent.querySelector(".as-add-form")),
            (this.$closeForm = this.$parent.querySelectorAll(
              ".as-close-address-form"
            )),
            (this.$errorTips = this.$parent.querySelectorAll(".as-error-tips")),
            (this.$addressList =
              this.$parent.querySelectorAll(".as-address-list")),
            (this.$addressEdit =
              this.$parent.querySelectorAll(".as-address-edit")),
            (this.$addressDelete =
              this.$parent.querySelectorAll(".as-address-delete")),
            (this.$saveDefault =
              this.$parent.querySelector(".as-save-default")),
            (this.index = 0),
            (this.HEADER_HEIGHT = 64),
            (this.$masking = this.$parent.querySelector(".as-address-masking")),
            this.init());
      }
      var e, n, o;
      return (
        (e = t),
        (n = [
          {
            key: "init",
            value: function () {
              this.handleAddAddress(),
                this.bindCloseForm(),
                this.handleSwitchAddressList(),
                this.handleEditAddress(),
                this.handleDeleteAddress(),
                this.handleSaveDefault(),
                this.handleFormTips();
            },
          },
          {
            key: "getScrollTop",
            value: function () {
              var t = 0;
              return (
                document.documentElement && document.documentElement.scrollTop
                  ? (t = document.documentElement.scrollTop)
                  : document.body && (t = document.body.scrollTop),
                t
              );
            },
          },
          {
            key: "handleAddAddress",
            value: function () {
              var t = this;
              this.$addAddressBtn &&
                this.$addAddressBtn.addEventListener("click", function () {
                  t.handleCloseAllForm(),
                    t.showMasking(),
                    t.$addForm && t.$addForm.classList.add("is-active");
                  var e = t.$addAddressBtn.getBoundingClientRect(),
                    n = t.getScrollTop();
                  window.scrollTo(0, e.top + n + t.HEADER_HEIGHT);
                });
            },
          },
          {
            key: "bindCloseForm",
            value: function () {
              var t = this;
              Array.from(this.$closeForm).map(function (e) {
                e.addEventListener("click", function () {
                  return (
                    t.handleCloseAllForm(),
                    t.handleCloseAllErrTips(),
                    window.scrollTo(0, 0),
                    !1
                  );
                });
              });
            },
          },
          {
            key: "handleSwitchAddressList",
            value: function () {
              var t = this;
              Array.from(this.$addressList).map(function (e, n) {
                e.addEventListener("click", function () {
                  t.index = n;
                  var i = t.$parent.querySelector(".address-list.is-active");
                  i && i.classList.remove("is-active"),
                    e.classList.add("is-active"),
                    t.changeFormSetDefault(n, !0);
                });
              });
            },
          },
          {
            key: "handleEditAddress",
            value: function () {
              var t = this;
              Array.from(this.$addressEdit).map(function (e, n) {
                e.addEventListener("click", function (e) {
                  (e || window.event).stopPropagation();
                  var i = t.$parent.querySelectorAll(".as-edit-form")[n];
                  t.handleCloseAllForm(),
                    t.showMasking(),
                    i && i.classList.add("is-active"),
                    t.changeFormSetDefault(n, !1);
                  var r = t.$addressList[n],
                    o = r && r.getBoundingClientRect(),
                    a = t.getScrollTop();
                  window.scrollTo(0, o.top + a + t.HEADER_HEIGHT);
                });
              });
            },
          },
          {
            key: "handleDeleteAddress",
            value: function () {
              var t = this;
              Array.from(this.$addressDelete).map(function (e, n) {
                e.addEventListener("click", function (e) {
                  (e || window.event).stopPropagation();
                  var i = t.$parent.querySelectorAll(
                      ".as-delete-confirm-masking"
                    ),
                    r = i[n];
                  Array.from(i).map(function (t) {
                    t.classList.remove("is-active");
                  }),
                    r && r.classList.add("is-active");
                  var o = r.querySelector(".as-delete-cancel"),
                    a = r.querySelector(".as-delete-confirm");
                  t.handleCancelDeleteAddress(o, r),
                    t.handleConfirmDeleteAddress(a);
                });
              });
            },
          },
          {
            key: "handleCancelDeleteAddress",
            value: function (t, e) {
              t &&
                t.addEventListener("click", function (t) {
                  (t || window.event).stopPropagation(),
                    e && e.classList.remove("is-active");
                });
            },
          },
          {
            key: "handleConfirmDeleteAddress",
            value: function (t) {
              t &&
                t.addEventListener("click", function (e) {
                  var n;
                  (e || window.event).stopPropagation();
                  var i =
                    null == t || null === (n = t.dataset) || void 0 === n
                      ? void 0
                      : n.addressId;
                  Shopify.postLink("/account/addresses/" + i, {
                    parameters: { _method: "delete" },
                  });
                });
            },
          },
          {
            key: "changeFormSetDefault",
            value: function (t, e) {
              var n = this.$parent.querySelectorAll(".as-edit-default")[t];
              n && (n.checked = e);
            },
          },
          {
            key: "handleSaveDefault",
            value: function () {
              var t = this;
              this.$saveDefault &&
                this.$saveDefault.addEventListener("click", function () {
                  var e = t.$parent.querySelectorAll(".as-edit-form")[t.index];
                  e && e.submit();
                });
            },
          },
          {
            key: "handleCloseAllForm",
            value: function () {
              Array.from(this.$allForm).map(function (t) {
                t.classList.remove("is-active");
              }),
                this.hiddenMasking(),
                this.changeFormSetDefault(this.index, !0);
            },
          },
          {
            key: "handleCloseAllErrTips",
            value: function () {
              Array.from(this.$errorTips).map(function (t) {
                t.innerHTML = "";
              });
            },
          },
          {
            key: "handleFormTips",
            value: function () {
              Array.from(this.$allForm).map(function (t) {
                new r(t);
              });
            },
          },
          {
            key: "showMasking",
            value: function () {
              this.$masking.classList.add("is-active"),
                this.$parent.classList.add("is-active");
            },
          },
          {
            key: "hiddenMasking",
            value: function () {
              this.$masking.classList.remove("is-active"),
                this.$parent.classList.remove("is-active");
            },
          },
        ]) && i(e.prototype, n),
        o && i(e, o),
        t
      );
    })())();
  },
  function (t, e, n) {
    function i(t) {
      return (
        (function (t) {
          if (Array.isArray(t)) return r(t);
        })(t) ||
        (function (t) {
          if ("undefined" != typeof Symbol && Symbol.iterator in Object(t))
            return Array.from(t);
        })(t) ||
        (function (t, e) {
          if (!t) return;
          if ("string" == typeof t) return r(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          "Object" === n && t.constructor && (n = t.constructor.name);
          if ("Map" === n || "Set" === n) return Array.from(t);
          if (
            "Arguments" === n ||
            /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
          )
            return r(t, e);
        })(t) ||
        (function () {
          throw new TypeError(
            "Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
          );
        })()
      );
    }
    function r(t, e) {
      (null == e || e > t.length) && (e = t.length);
      for (var n = 0, i = new Array(e); n < e; n++) i[n] = t[n];
      return i;
    }
    function o(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    var a = n(16).handleHoganRending,
      s = n(5),
      c = n(7);
    new ((function () {
      function t() {
        var e;
        if (
          ((function (t, e) {
            if (!(t instanceof e))
              throw new TypeError("Cannot call a class as a function");
          })(this, t),
          (this.$parent = document.querySelector(".as-search-page")),
          this.$parent)
        ) {
          (this.$searchPagination = this.$parent.querySelector(
            ".as-search-pagination"
          )),
            (this.$totalPages = this.$parent.querySelector(".as-total-pages")),
            (this.$currentPage =
              this.$parent.querySelector(".as-current-page")),
            (this.$next = this.$parent.querySelector(".as-pagination-next")),
            (this.$prev = this.$parent.querySelector(".as-pagination-prev")),
            (this.$FilterCount = this.$parent.querySelector(
              ".as-search-results-count"
            )),
            (this.$filter = this.$parent.querySelectorAll(
              ".as-filter-condition"
            )),
            (this.$filterMob = this.$parent.querySelectorAll(
              ".as-filter-condition-mob"
            )),
            (this.NUMBER_PER_PAGE = 15),
            (this.filterCondition = []);
          var n = document.getElementById("tpl-page-search-results");
          (this.result = JSON.parse(n.innerHTML) || {}),
            (this.products =
              null === (e = this.result) || void 0 === e ? void 0 : e.products),
            this.init();
        }
      }
      var e, n, r;
      return (
        (e = t),
        (n = [
          {
            key: "init",
            value: function () {
              this.initResultsData(),
                this.bindFilterEvent(),
                this.bindPaginateEvent(),
                this.resetCheckbox(),
                this.applyFilter();
            },
          },
          {
            key: "initResultsData",
            value: function () {
              (this.productsLen = this.products.length),
                (this.totalPages =
                  this.productsLen > 0
                    ? Math.ceil(this.productsLen / this.NUMBER_PER_PAGE)
                    : 0),
                (this.currentPage = 1),
                this.handleGroupingData(this.products);
            },
          },
          {
            key: "handleGroupingData",
            value: function (t) {
              (this.newProducts = {}), (this.resultCount = t.length);
              for (var e = 0; e < this.totalPages; e++)
                this.newProducts[e] = this.interceptArray(t, e);
              this.handleRending({ data: this.newProducts[0] });
            },
          },
          {
            key: "handleRending",
            value: function (t) {
              0 == this.resultCount
                ? (a("filter-search-results-none"),
                  this.$searchPagination &&
                    this.$searchPagination.classList.add("d-none"))
                : (a("page-search-tempalte", t),
                  this.$searchPagination &&
                    this.$searchPagination.classList.remove("d-none")),
                this.handleFilterCount();
              var e = this.$parent.querySelectorAll(".as-product-tag");
              Array.from(e).map(function (t) {
                new c()._init(t);
              }),
                this.handlePaginate();
            },
          },
          {
            key: "interceptArray",
            value: function (t, e) {
              var n = this.NUMBER_PER_PAGE;
              return t.slice(e * n, (e + 1) * n);
            },
          },
          {
            key: "bindFilterEvent",
            value: function () {
              var t = this;
              Array.from(this.$filter).map(function (e) {
                e.addEventListener("change", function () {
                  t.handleFilter(t.$filter);
                });
              });
            },
          },
          {
            key: "handleFilter",
            value: function (t) {
              var e = this;
              if (
                ((this.filterCondition = []),
                Array.from(t).map(function (t) {
                  var n = t.name;
                  t.checked &&
                    !e.filterCondition.includes(n) &&
                    e.filterCondition.push(n);
                }),
                0 == this.filterCondition.length ||
                  this.filterCondition.length == t.length)
              )
                return this.initResultsData(), !1;
              var n = [];
              this.products.map(function (t) {
                e.filterProducts(t.collection) && n.push(t);
              }),
                (this.totalPages =
                  n.length > 0
                    ? Math.ceil(n.length / this.NUMBER_PER_PAGE)
                    : 0),
                (this.currentPage = 1),
                this.handleGroupingData(n),
                this.handlePaginate();
            },
          },
          {
            key: "filterProducts",
            value: function (t) {
              if (0 == t.length) return !0;
              var e = [].concat(i(this.filterCondition), i(t));
              return e.length !== Array.from(new Set(e)).length;
            },
          },
          {
            key: "handlePaginate",
            value: function () {
              this.$totalPages &&
                (this.$totalPages.innerHTML = this.totalPages),
                this.$currentPage &&
                  (this.$currentPage.innerHTML = this.currentPage),
                this.$prev &&
                  (this.$prev.disabled =
                    1 == this.currentPage ? "disabled" : ""),
                this.$next &&
                  (this.$next.disabled =
                    this.currentPage == this.totalPages ? "disabled" : "");
            },
          },
          {
            key: "handleFilterCount",
            value: function () {
              this.$FilterCount &&
                (this.$FilterCount.innerHTML = this.resultCount);
            },
          },
          {
            key: "bindPaginateEvent",
            value: function () {
              var t = this;
              this.$prev &&
                this.$prev.addEventListener("click", function () {
                  1 != t.currentPage &&
                    (t.currentPage--,
                    t.handleRending({
                      data: t.newProducts[t.currentPage - 1],
                    }));
                }),
                this.$next &&
                  this.$next.addEventListener("click", function () {
                    t.currentPage != t.totalPages &&
                      (t.currentPage++,
                      t.handleRending({
                        data: t.newProducts[t.currentPage - 1],
                      }));
                  });
            },
          },
          {
            key: "closeFilterModal",
            value: function () {
              var t = this;
              (this.$closeFilter = this.$parent.querySelectorAll(
                ".as-search-filter-close"
              )),
                (this.filterModal = new s.Modal(
                  document.getElementById("as-search-filter"),
                  { keyboard: !1 }
                )),
                Array.from(this.$closeFilter).map(function (e) {
                  e.addEventListener("click", function () {
                    t.filterModal.hide();
                  });
                });
            },
          },
          {
            key: "resetCheckbox",
            value: function () {
              var t = this;
              (this.$filterReset = this.$parent.querySelector(
                ".as-search-filter-reset"
              )),
                this.$filterReset &&
                  this.$filterReset.addEventListener("click", function () {
                    Array.from(t.$filterMob).map(function (t) {
                      t.checked = "checked";
                    });
                  });
            },
          },
          {
            key: "applyFilter",
            value: function () {
              var t = this;
              (this.$applyFilter = this.$parent.querySelector(
                ".as-search-filter-apply"
              )),
                this.$applyFilter &&
                  this.$applyFilter.addEventListener("click", function () {
                    t.handleFilter(t.$filterMob);
                  }),
                this.closeFilterModal();
            },
          },
        ]) && o(e.prototype, n),
        r && o(e, r),
        t
      );
    })())();
  },
  function (t, e, n) {
    "use strict";
    n.r(e);
    n(5), n(39);
    function i() {
      var t = Error.call(this);
      return (
        (t.name = "Server error"),
        (t.message = "Something went wrong on the server"),
        (t.status = 500),
        t
      );
    }
    function r(t) {
      var e = Error.call(this);
      return (
        (e.name = "Not found"), (e.message = "Not found"), (e.status = t), e
      );
    }
    function o() {
      var t = Error.call(this);
      return (
        (t.name = "Server error"),
        (t.message = "Something went wrong on the server"),
        (t.status = 500),
        t
      );
    }
    function a(t) {
      var e = Error.call(this);
      return (
        (e.name = "Content-Type error"),
        (e.message = "Content-Type was not provided or is of wrong type"),
        (e.status = t),
        e
      );
    }
    function s(t) {
      var e = Error.call(this);
      return (
        (e.name = "JSON parse error"),
        (e.message = "JSON syntax error"),
        (e.status = t),
        e
      );
    }
    function c(t, e, n, i) {
      var r = Error.call(this);
      return (
        (r.name = e), (r.message = n), (r.status = t), (r.retryAfter = i), r
      );
    }
    function l(t, e, n) {
      var i = Error.call(this);
      return (i.name = e), (i.message = n), (i.status = t), i;
    }
    function u(t, e, n) {
      var i = Error.call(this);
      return (i.name = e), (i.message = n), (i.status = t), i;
    }
    function d() {
      this.events = {};
    }
    function f(t) {
      (this.eventName = t), (this.callbacks = []);
    }
    function h(t) {
      (this._store = {}),
        (this._keys = []),
        t && t.bucketSize
          ? (this.bucketSize = t.bucketSize)
          : (this.bucketSize = 20);
    }
    function p(t, e) {
      var n = "";
      return (
        (e = e || null),
        Object.keys(t).forEach(function (i) {
          var r = i + "=";
          switch (
            (e && (r = e + "[" + i + "]"),
            (function (t) {
              return Object.prototype.toString
                .call(t)
                .slice(8, -1)
                .toLowerCase();
            })(t[i]))
          ) {
            case "object":
              n += p(t[i], e ? r : i);
              break;
            case "array":
              n += r + "=" + t[i].join(",") + "&";
              break;
            default:
              e && (r += "="), (n += r + encodeURIComponent(t[i]) + "&");
          }
        }),
        n
      );
    }
    (d.prototype.on = function (t, e) {
      var n = this.events[t];
      n || ((n = new f(t)), (this.events[t] = n)), n.registerCallback(e);
    }),
      (d.prototype.off = function (t, e) {
        var n = this.events[t];
        n &&
          n.callbacks.indexOf(e) > -1 &&
          (n.unregisterCallback(e),
          0 === n.callbacks.length && delete this.events[t]);
      }),
      (d.prototype.dispatch = function (t, e) {
        var n = this.events[t];
        n && n.fire(e);
      }),
      (f.prototype.registerCallback = function (t) {
        this.callbacks.push(t);
      }),
      (f.prototype.unregisterCallback = function (t) {
        var e = this.callbacks.indexOf(t);
        e > -1 && this.callbacks.splice(e, 1);
      }),
      (f.prototype.fire = function (t) {
        this.callbacks.slice(0).forEach(function (e) {
          e(t);
        });
      }),
      (h.prototype.set = function (t, e) {
        if (this.count() >= this.bucketSize) {
          var n = this._keys.splice(0, 1);
          this.delete(n);
        }
        return this._keys.push(t), (this._store[t] = e), this._store;
      }),
      (h.prototype.get = function (t) {
        return this._store[t];
      }),
      (h.prototype.has = function (t) {
        return Boolean(this._store[t]);
      }),
      (h.prototype.count = function () {
        return Object.keys(this._store).length;
      }),
      (h.prototype.delete = function (t) {
        var e = Boolean(this._store[t]);
        return delete this._store[t], e && !this._store[t];
      });
    var m,
      g,
      v,
      y =
        ((m = function (t, e, n, d) {
          var f = new XMLHttpRequest();
          (f.onreadystatechange = function () {
            if (f.readyState !== XMLHttpRequest.DONE);
            else {
              var t = f.getResponseHeader("Content-Type");
              if (f.status >= 500) return void d(new o());
              if (404 === f.status) return void d(new r(f.status));
              if (
                "string" != typeof t ||
                null === t.toLowerCase().match("application/json")
              )
                return void d(new a(f.status));
              if (417 === f.status) {
                try {
                  var h = JSON.parse(f.responseText);
                  d(new l(f.status, h.message, h.description));
                } catch (t) {
                  d(new s(f.status));
                }
                return;
              }
              if (422 === f.status) {
                try {
                  var p = JSON.parse(f.responseText);
                  d(new u(f.status, p.message, p.description));
                } catch (t) {
                  d(new s(f.status));
                }
                return;
              }
              if (429 === f.status) {
                try {
                  var m = JSON.parse(f.responseText);
                  d(
                    new c(
                      f.status,
                      m.message,
                      m.description,
                      f.getResponseHeader("Retry-After")
                    )
                  );
                } catch (t) {
                  d(new s(f.status));
                }
                return;
              }
              if (200 === f.status) {
                try {
                  var g = JSON.parse(f.responseText);
                  (g.query = e), n(g);
                } catch (t) {
                  d(new s(f.status));
                }
                return;
              }
              try {
                var v = JSON.parse(f.responseText);
                d(new i(f.status, v.message, v.description));
              } catch (t) {
                d(new s(f.status));
              }
            }
          }),
            f.open(
              "get",
              "/search/suggest.json?q=" + encodeURIComponent(e) + "&" + t
            ),
            f.setRequestHeader("Content-Type", "application/json"),
            f.send();
        }),
        (g = 10),
        (v = null),
        function () {
          var t = this,
            e = arguments;
          clearTimeout(v),
            (v = setTimeout(function () {
              (v = null), m.apply(t, e);
            }, g || 0));
        });
    function b(t) {
      if (!t) throw new TypeError("No config object was specified");
      (this._retryAfter = null),
        (this._currentQuery = null),
        (this.dispatcher = new d()),
        (this.cache = new h({ bucketSize: 40 })),
        (this.configParams = p(t));
    }
    function _(t) {
      return "string" != typeof t
        ? null
        : t.trim().replace(" ", "-").toLowerCase();
    }
    function w(t, e) {
      if (!(t instanceof e))
        throw new TypeError("Cannot call a class as a function");
    }
    function E(t, e) {
      for (var n = 0; n < e.length; n++) {
        var i = e[n];
        (i.enumerable = i.enumerable || !1),
          (i.configurable = !0),
          "value" in i && (i.writable = !0),
          Object.defineProperty(t, i.key, i);
      }
    }
    function k(t, e, n) {
      return e && E(t.prototype, e), n && E(t, n), t;
    }
    (b.TYPES = { PRODUCT: "product", PAGE: "page", ARTICLE: "article" }),
      (b.FIELDS = {
        AUTHOR: "author",
        BODY: "body",
        PRODUCT_TYPE: "product_type",
        TAG: "tag",
        TITLE: "title",
        VARIANTS_BARCODE: "variants.barcode",
        VARIANTS_SKU: "variants.sku",
        VARIANTS_TITLE: "variants.title",
        VENDOR: "vendor",
      }),
      (b.UNAVAILABLE_PRODUCTS = { SHOW: "show", HIDE: "hide", LAST: "last" }),
      (b.prototype.query = function (t) {
        try {
          !(function (t) {
            var e;
            if (null == t)
              throw (
                (((e = new TypeError("'query' is missing")).type = "argument"),
                e)
              );
            if ("string" != typeof t)
              throw (
                (((e = new TypeError("'query' is not a string")).type =
                  "argument"),
                e)
              );
          })(t);
        } catch (t) {
          return void this.dispatcher.dispatch("error", t);
        }
        if ("" === t) return this;
        this._currentQuery = _(t);
        var e = this.cache.get(this._currentQuery);
        return e
          ? (this.dispatcher.dispatch("success", e), this)
          : (y(
              this.configParams,
              t,
              function (t) {
                this.cache.set(_(t.query), t),
                  _(t.query) === this._currentQuery &&
                    ((this._retryAfter = null),
                    this.dispatcher.dispatch("success", t));
              }.bind(this),
              function (t) {
                t.retryAfter && (this._retryAfter = t.retryAfter),
                  this.dispatcher.dispatch("error", t);
              }.bind(this)
            ),
            this);
      }),
      (b.prototype.on = function (t, e) {
        return this.dispatcher.on(t, e), this;
      }),
      (b.prototype.off = function (t, e) {
        return this.dispatcher.off(t, e), this;
      });
    var S = n(2);
    n(1),
      new ((function () {
        function t() {
          w(this, t),
            (this.$parent = document.querySelector(".as-navbar")),
            this.$parent && this.init();
        }
        return (
          k(t, [
            {
              key: "init",
              value: function () {
                this.handleExpand(), this.initCartCount();
              },
            },
            {
              key: "handleExpand",
              value: function () {
                var t = this;
                (this.$expand = this.$parent.querySelector(".as-expand")),
                  this.$expand &&
                    this.$expand.addEventListener("click", function () {
                      "false" == t.$parent.dataset.expand
                        ? ((t.$parent.dataset.expand = !0),
                          document.body.classList.remove("overflow-hidden"))
                        : ((t.$parent.dataset.expand = !1),
                          document.body.classList.add("overflow-hidden"));
                    });
              },
            },
            {
              key: "initCartCount",
              value: function () {
                if (this.$parent) {
                  var t = this.$parent.querySelectorAll(".as-cart-items-count");
                  Array.prototype.forEach.call(t, function (t) {
                    t &&
                      document.addEventListener("cart.updated", function (e) {
                        var n = e.detail,
                          i = n && n.item_count;
                        i && i > 0
                          ? (t.classList.add("show"),
                            (t.innerHTML = i < 100 ? n.item_count : "99+"))
                          : (t.classList.remove("show"), (t.innerHTML = ""));
                      });
                  });
                }
              },
            },
          ]),
          t
        );
      })())(),
      new ((function () {
        function t() {
          w(this, t),
            (this.$parent = document.querySelector(".as-navbar")),
            this.$parent &&
              ((this.$searchTrigger = this.$parent.querySelectorAll(
                ".as-navbar-search-trigger"
              )),
              (this.$searchForm = this.$parent.querySelector("#searchform")),
              (this.$input = this.$parent.querySelector(".as-search-input")),
              (this.$searchResult =
                this.$parent.querySelector(".as-search-result")),
              (this.SEARCH_TYPE = b.TYPES.PRODUCT),
              (this.MAX_SHOW_RESULT = 5),
              (this.predictiveSearch = new b({
                resources: {
                  type: [this.SEARCH_TYPE],
                  limit: this.MAX_SHOW_RESULT,
                  options: {
                    unavailable_products: "last",
                    fields: [
                      b.FIELDS.TITLE,
                      b.FIELDS.PRODUCT_TYPE,
                      b.FIELDS.VARIANTS_TITLE,
                    ],
                  },
                },
              })),
              this.init());
        }
        return (
          k(t, [
            {
              key: "init",
              value: function () {
                this.triggerSearch(),
                  this.bindKeyUp(),
                  this.handleSearchSuccess(),
                  this.handleSearchError(),
                  this.handleCloseSearch();
              },
            },
            {
              key: "triggerSearch",
              value: function () {
                for (var t = this, e = 0; e < this.$searchTrigger.length; e++)
                  this.$searchTrigger[e].addEventListener("click", function () {
                    t.$input.focus(),
                      t.$parent.classList.add("searchopen"),
                      (document.body.scrollTop = 0),
                      document.documentElement &&
                        (document.documentElement.scrollTop = 0);
                  });
              },
            },
            {
              key: "bindKeyUp",
              value: function () {
                var t = this;
                this.$input.addEventListener("keyup", function (e) {
                  t.debounce(t.handleKeyUp(e), 500);
                });
              },
            },
            {
              key: "handleKeyUp",
              value: function (t) {
                var e = t || window.event;
                if (((this.val = e.target.value), 13 == t.keyCode)) {
                  var n = window.location.pathname.split("/")[1];
                  (this.ALLSTORE = "fr&de&uk"),
                    (n =
                      this.ALLSTORE.includes(n) && n.length > 0
                        ? "".concat(n, "/")
                        : ""),
                    (window.location.href = ""
                      .concat(window.location.origin, "/")
                      .concat(n, "search?q=")
                      .concat(this.val.replace("%", " "), "&type=product"));
                }
                this.val.length > 1
                  ? this.predictiveSearch.query(this.val)
                  : this.val.length < 1
                  ? this.handleHoganRending("search-result")
                  : (this.$searchResult.innerHTML = "");
              },
            },
            {
              key: "handleHoganRending",
              value: function (t, e) {
                var n = document.querySelector("#tpl-".concat(t));
                if (!n) return !1;
                var i = S.compile(n.innerHTML, { delimiters: "@{ }@" }),
                  r = this.$parent.querySelector(".as-".concat(t));
                r && (r.innerHTML = i.render(e));
              },
            },
            {
              key: "handleSearchSuccess",
              value: function () {
                var t = this;
                this.predictiveSearch.on("success", function (e) {
                  for (
                    var n,
                      i,
                      r =
                        null == e ||
                        null === (n = e.resources) ||
                        void 0 === n ||
                        null === (i = n.results) ||
                        void 0 === i
                          ? void 0
                          : i.products,
                      o = r.length,
                      a = function (e) {
                        var n = r[e].title,
                          i = new RegExp(t.val, "ig"),
                          o = n.match(i);
                        (r[e].title_html = n),
                          o &&
                            o.map(function (t) {
                              r[e].title_html = r[e].title_html.replace(
                                t,
                                "<b>".concat(t, "</b>")
                              );
                            }),
                          (r[e].title_html = r[e].title_html.replace(
                            /\s/g,
                            "&nbsp;"
                          ));
                      },
                      s = 0;
                    s < o;
                    s++
                  )
                    a(s);
                  if (0 == o) return (t.$searchResult.innerHTML = ""), !1;
                  t.handleHoganRending("search-result-list", { data: r });
                });
              },
            },
            {
              key: "handleSearchError",
              value: function () {
                var t = this;
                this.predictiveSearch.on("error", function (e) {
                  t.$searchResult.innerHTML = "";
                });
              },
            },
            {
              key: "handleCloseSearch",
              value: function () {
                var t = this;
                this.$parent
                  .querySelector("#as-nav-search")
                  .addEventListener("hidden.bs.modal", function () {
                    t.$parent.classList.remove("searchopen"),
                      t.handleHoganRending("search-result"),
                      (t.$input.value = "");
                  });
              },
            },
            {
              key: "debounce",
              value: function (t, e) {
                var n;
                return function () {
                  var i = this,
                    r = arguments;
                  n && clearTimeout(n),
                    (n = setTimeout(function () {
                      t.apply(i, r);
                    }, e));
                };
              },
            },
          ]),
          t
        );
      })())(),
      n(42),
      n(44),
      n(45),
      n(46),
      n(48),
      n(7);
    n(20);
    n(1), n(6);
    document.body.classList.remove("invisible"),
      n(49),
      n(53),
      n(54),
      n(55),
      n(18),
      n(56),
      document.addEventListener("touchstart", function () {}, !0);
  },
]);
